export default {
  translation: {
    Automation_flow_templates: "Flow Templates",
    Automation_ai_templates: "AI Templates",
    Automation_sample: "Sample",
    Automation_sample_notice: "You can use pre-built templates and customize them",
    Automation_template_number: "Template #{{number}}",
    Automation_beginner: "Beginner",
    Automation_intermediate: "Intermediate",
    Automation_advanced: "Advanced",
    Automation_trending: "Trending",
    Automation_sample_cart: "E-commerce Cart Recovery",
    Automation_sample_cart_description:
      "Sample idea: help shoppers return to their cart and answer their purchase questions.",
    Automation_sample_language: "Multilingual Conversations",
    Automation_sample_language_description:
      "Sample idea: guide visitors to a conversation in their preferred language.",
    Automation_sample_support: "Customer Support Assistant",
    Automation_sample_support_description:
      "Sample idea: answer common questions and guide customers to the right next step.",
    Automation_sample_welcome: "Welcome New Customers",
    Automation_sample_welcome_description:
      "Sample idea: welcome new visitors and introduce your products and services.",
    Automation_flow_history: "Flow History",
    Automation_ai_history: "AI History",
    Automation_loaded_count: "Loaded items; + means more items are available.",
    Automation_sort_newest: "newest first",
    Automation_sort_oldest: "oldest first",
    Automation_sort_title: "by title",
    Automation_connected_posts: "Connected posts",
    Automation_not_connected: "Not connected to any post.",
    Automation_connections_access: "Comment permission and Automation/Comment access are needed to view connections.",
    Automation_checking_connections: "Checking post connections...",
    Automation_connections_retry: "Could not verify all connections. Try again.",
    aiSuggestedPrompts_title: "Suggested prompts",
    aiSuggestedPrompts_openImage: "Open image fullscreen",
    aiSuggestedPrompts_explain: "Choose a prompt to use as your starting point.",
    aiSuggestedPrompts_category: "Prompt category",
    aiSuggestedPrompts_subCategory: "Subcategory",
    aiSuggestedPrompts_allCategories: "All categories",
    aiSuggestedPrompts_loading: "Loading...",
    aiSuggestedPrompts_empty: "No suggested prompts found.",
    aiSuggestedPrompts_loadMore: "Load more",
    aiSuggestedPrompts_prompt: "Prompt",
    aiSuggestedPrompts_copy: "Copy prompt",
    aiSuggestedPrompts_showMore: "Show more",
    aiSuggestedPrompts_showLess: "Show less",
    // #region landing page.
    unpin: "Unpin",
    pin: "Pin",
    AudienceTooltip:
      "For a more accurate measure of your current engagement, statistics are based on your performance over the past 30 days. Instagram statistics are based on your account's entire activity period and may differ from these figures",
    usethisPrompt: "Use in prompt",
    toggleShowAll: " Show All",
    toggleShowmonthly: " Show Monthly",
    Nodetutorial: "Block Description",
    Dublicate: "Duplicate",
    zoomout: "Zoom Out",
    fitscreen: "Fit to Screen",
    zoomin: "Zoom In",
    History_saved: "Saved Histories",
    Data_Management_explain: "You can save your workflow and, if needed, import workflows from other platforms.",
    flow_shortcuts_explain: "Keyboard shortcuts to increase speed and efficiency in managing workflows.",
    shortcuts: "Shortcuts",
    Workflow_Statistics: "Workflow Statistics",
    Nodes: "Nodes",
    Connections: "Connections",
    Last_Auto_saved: "Last Auto Saved",
    Canvas_Behavior: "Canvas Behavior",
    Canvas_Behavior_explain: "Configure grid snapping and panning boundaries for better control",
    Data_Management: "Data Management",
    exportJSON: "Export JSON",
    importJSON: "Import JSON",
    importJSON_success: "File imported successfully",
    importJSON_error: "Error importing file",

    quantity: "Quantity",
    allquantity: "Total Quantity",
    remainingquantity: "Remaining Quantity",
    Connecting: "Connecting",
    Connected: "Connected",
    EmailNotification: "Email Notifications",
    EmailNotificationExplain: "System notifications are sent to this Email address.",
    MobileNotification: "Mobile Notifications",
    MobileNotificationExplain: "System notifications are sent to this Mobile address.",
    Responded: "Responded",
    notimelimit: "No time limit",
    level: "Level",
    loading: "Loading...",
    menu: "menu",
    bestposts: "Best Posts",
    daysAgo: "days ago",
    hoursAgo: "hours ago",
    minutesAgo: "minutes ago",
    justNow: "just now",
    upgradeyouraccount: "Upgrade your account",
    featureNotAvailable: "This feature is not available",
    featureNotAvailableDesc: "Upgrade your account to use this feature.",
    likeaprouser: "Start a real business",
    followerrate: "Follower growth rate",
    shoppertitle: "Everything is ready to sell 👌",
    advertisertitle: "Everything is ready for advertising 👌",
    shopperdescription: "Track your sales performance accurately.",
    advertiserdescription: "Track your advertising performance accurately.",

    syncingAccountTitle: "Fetching Information",
    syncingAccountDescription: "Your Instagram information is being updated in Brancy",
    syncingAccountDescriptiontooltip: "Some of your information will be updated within the next 24 hours",
    subscriptionExpiringTitle: "Your Subscription Is Expiring",
    subscriptionExpiringDescription: "Renew your subscription to continue using the available features",
    subscriptionDaysRemaining: "{{days}} days remaining",

    priceHistory: "Price History",
    unselect: "unselect",
    shopper: "Seller",
    onlinestore: "Online Store",
    onlinestoreExplain: "Everything you need to sell more, all in one place.",
    influencerExplain: "All tools for advertisers and influencers, professionally combined",
    advertiser: "Advertiser",
    influencer: "Influencer",
    skip: "Skip",
    skipfornow: "Skip for now",
    freedays: "40 Days",
    usersettingexplain:
      "Instagram account information can only be changed within Instagram and will be updated automatically here.",
    freedaysExplain:
      "If you have an active and growing Instagram page, this plan is designed for you. Full access to tools, analytics, content and message management, comments, and teammate admin creation on Brancy is activated.",
    instagramerplanactive: "Your Instagram plan is active",
    influencerplanactive: "Your Influencer plan is active",
    onlinestoreplanactive: "Your Online Store plan is active",

    chooselanguage: "Choose Language",
    chooselanguageExplain: "Select your preferred language",
    chooseTheme: "Choose Theme",
    chooseThemeExplain: "Select your favorite theme",
    chooseCalendar: "Choose Calendar",
    chooseCalendarExplain: "Select the type of calendar you prefer",
    setupchooseexplain: "These settings can be changed later in Settings",
    CollaboratorExplain: "Share a Post or Reels Collaboratively Between Multiple Instagram Pages",

    SwitchtoUserpanel: "Switch to User Panel",
    Lottery: "Lottery",
    services: "Features",
    markets: "Platforms",
    pricing: "Pricing",
    page1_text1: "Instagram Business Management",
    page1_text2: "With next Generation of",
    page1_StartNow: "A free start with access to Premium tools",
    page1_services: "Services",
    page1_analytics: "Analytics",
    page1_transportation: "Transportation",
    page1_financial_solutions: "Financial Solutions",
    page1_customer_communication: "Customer Communication",
    page1_content_management: "Content Management",
    page1_artificial_intelligence: "Artificial Intelligence",
    page1_tools: "Tools",
    page1_advertises: "Ad Management",
    page2_text1: "Ultimate Services for any business",
    page2_text2:
      "Brancy is a powerful tool for managing your Instagram account, providing you with the tools you need to succeed.",
    page2_ads_statistics_title: "Statistics",
    page2_ads_statistics_description: "Advanced performance analytics tool",
    page2_ads_statistics_servicedescription:
      "Use this advanced tool to monitor all key ad performance metrics of your page precisely, in real-time, and analytically. Get full professional insight to optimize your ad campaigns.",
    page2_ads_calendar_title: "Work Calendar",
    page2_ads_calendar_description: "Most practical ad management",
    page2_ads_calendar_servicedescription:
      "Manage all your ads—both approved by you and AI-suggested—in a smart calendar with an advanced, organized timeline. Experience fast, error-free ad planning.",
    page2_ads_adlist_title: "Ads List",
    page2_ads_adlist_description: "View the queue of ads awaiting approval",
    page2_ads_adlist_servicedescription:
      "See a clear, categorized list of ads pending your approval and quickly approve or reject them with one click. Streamline your ad management professionally and efficiently.",
    page2_store_addproduct_title: "Add Product",
    page2_store_addproduct_description: "Identify all products from your page",
    page2_store_addproduct_servicedescription:
      "Our smart system detects all products in your page posts and prepares them automatically for adding. This boosts your speed and minimizes errors.",
    page2_store_productlist_title: "Product List",
    page2_store_productlist_description: "Inventory and product management",
    page2_store_productlist_servicedescription:
      "Manage products and inventory professionally, accurately, and worry-free. Everything is smartly accessible with full reporting.",
    page2_store_orders_title: "Orders",
    page2_store_orders_description: "Order, invoice & shipping management",
    page2_store_orders_servicedescription:
      "From order placement to invoicing and tracked shipping, all steps are automated and seamless. Ensures a fast, accurate, and flawless customer experience.",
    page2_store_statistics_title: "Statistics",
    page2_store_statistics_description: "Advanced performance analytics tool",
    page2_store_statistics_servicedescription:
      "Use advanced stats to track sales, revenue, and growth trends from multiple angles and make smarter data-driven decisions.",
    page2_delivery_smartshipping_title: "Smart Shipping Cost",
    page2_delivery_smartshipping_description: "Cost by origin, destination, size, and weight",
    page2_delivery_smartshipping_servicedescription:
      "Shipping cost is calculated precisely and automatically based on origin, destination, dimensions, and weight. Provides accurate fees without human error.",
    page2_delivery_postalservice_title: "Postal Service",
    page2_delivery_postalservice_description: "Package collection and delivery",
    page2_delivery_postalservice_servicedescription:
      "Your packages are smartly collected from the store and sent to the destination without manual follow-up. A smooth, fast, and organized logistics experience.",
    page2_delivery_tracking_title: "Package Tracking",
    page2_delivery_tracking_description: "Automatic package status and tracking",
    page2_delivery_tracking_servicedescription:
      "Automatic tracking with precise real-time status for customers, ensuring full transparency and trust.",
    page2_jobs_subadmin_title: "Sub Admin",
    page2_jobs_subadmin_description: "Ability to add sub admins",
    page2_jobs_subadmin_servicedescription:
      "Add sub admins securely without sharing passwords and customize access for each. Full control with guaranteed security.",
    page2_ids_store_title: "ID Store",
    page2_ids_store_description: "Buy and sell Instagram IDs",
    page2_ids_store_servicedescription:
      "Buy and sell Instagram accounts securely with authentication. Features include detailed analysis, smart pricing, auctions, and page stats validation—all in one place.",
    page2_publish_contentmanagement_title: "Content Management",
    page2_publish_contentmanagement_description: "Manage Posts and Stories",
    page2_publish_contentmanagement_servicedescription:
      "Manage all posts and stories in an advanced smart platform with scheduling, categorization, and fast publishing for hassle-free social media control.",
    page2_publish_contentpublishing_title: "Content Publishing",
    page2_publish_contentpublishing_description: "Scheduled Posts and Stories Publishing",
    page2_publish_contentpublishing_servicedescription:
      "Publish posts and stories smartly on schedule. The system suggests the best time based on follower behavior analysis.",
    page2_publish_analytics_title: "Post & Story Analytics",
    page2_publish_analytics_description: "Complete Content Analysis",
    page2_publish_analytics_servicedescription:
      "Gain deep insights on published content performance and audience feedback to optimize your content strategy.",
    page2_publish_statistics_title: "Statistics",
    page2_publish_statistics_description: "Advanced Performance Analytics Tool",
    page2_publish_statistics_servicedescription:
      "The most advanced content analytics tool with full details on post and story performance, charts, and precise analyses for better decisions.",
    page2_extension_biolink_title: "Bio Link",
    page2_extension_biolink_description: "More than a simple bio link",
    page2_extension_biolink_servicedescription:
      "A dedicated beautiful page showcasing all your important links with responsive design and full customization, beyond a simple link.",
    page2_extension_paymentgateway_title: "Payment Gateway",
    page2_extension_paymentgateway_description: "Dedicated Payment Gateway",
    page2_extension_paymentgateway_servicedescription:
      "A secure, dedicated payment gateway with no technical knowledge required, offering detailed reports and transaction management in a user-friendly environment.",
    page2_extension_customwebsite_title: "Custom Website",
    page2_extension_customwebsite_description: "Custom website tailored to your page",
    page2_extension_customwebsite_servicedescription:
      "A custom website matching your page's visual identity, no coding needed. Showcase all your products and services professionally and beautifully.",
    page4_menu_instagram_management: "Instagram Page Management",
    page4_menu_admin_subadmin: "Admin & Sub Admin",
    page4_menu_store_shipping: "Store & Shipping",
    page4_menu_advertising: "Advertising",
    page4_menu_hashtag_management: "Hashtag Management",
    page4_menu_ai_analysis: "Smart AI Analysis",
    page4_menu_ad_scheduling: "Ad Scheduling",
    page4_menu_financial_wallet: "Finance & Wallet",
    page4_menu_page_statistics: "Page Statistics",
    page4_menu_professional_messaging: "Professional Messaging",

    page4_content_instagram_management_text:
      "Manage all parts of your page—from content publishing to comment and direct replies—integrated and professional, no need for multiple apps!",
    page4_content_admin_subadmin_text:
      "Build your team! Assign specific roles, restrict access, and fully monitor activities without worrying about human errors.",
    page4_content_store_shipping_text:
      "A real Instagram store! Manage inventory, orders, invoicing, and shipping tracking—all from one panel. Online selling made easy!",
    page4_content_advertising_text:
      "Design, run, and analyze Instagram ads in a few clicks! Attract targeted audience, measure campaign ROI, and stop wasting budget.",
    page4_content_hashtag_management_text:
      "Choose your hashtags smartly! Analyze top related hashtags, save categorized lists, and get smart suggestions for each post for max reach.",
    page4_content_ai_analysis_text:
      "Examine follower behavior closely! Discover patterns, interests, and prime activity times with advanced AI analysis and win your strategy.",
    page4_content_ad_scheduling_text:
      "Keep your ads running even while you sleep! Plan campaigns, set start and end times, and grow worry-free.",
    page4_content_financial_wallet_text:
      "Keep all transactions under control! Track income, expenses, wallet balance, and get full financial reports for better page capital management.",
    page4_content_page_statistics_text:
      "Accurate real stats on page growth: engagement rate, follower growth, post performance, views, and tons of data for smart decisions.",
    page4_content_professional_messaging_text:
      "Experience real direct marketing! Send group messages, set auto-replies, and professionally manage follower conversations without confusion.",

    shipping: "Shipping",
    jobs: "Jobs",
    IDstore: "ID Store",
    page3_text1: "The solution to all your business needs",
    page5_whyBrancy: "Why Brancy?",
    page5_title1: "Official and Secure Instagram Partner",
    page5_title2: "Integrated Ecosystem, Smart Savings",
    page5_title3: "Professional Smart Interaction",
    page5_title4: "Advanced and Smart Dashboard",
    page5_title5: "Smart Sales and Logistics System",
    page5_title6: "Dedicated Smart Website",
    page5_explain1: "Smart control with no sensitive data access – Instagram-safe & algorithm-friendly.",
    page5_explain2: "All tools in one; 70% cost cut, 85% time saved from content to ads.",
    page5_explain3: "AI auto-replies – 40% more responses, 95% customer retention.",
    page5_explain4: "Fast UI, real-time insights, admin roles, scheduling & reports.",
    page5_explain5: "Direct selling in DMs – secure gateway, store, shipping & smart inventory.",
    page5_explain6: "Pro Bio link & website – sell, book, SEO-ready & social-friendly.",
    Beginner: "Beginner",
    Basic: "Basic",
    Growing: "Growing",
    Advanced: "Advanced",
    Professional: "Professional",
    Special: "Special",
    Unavailable: "Unavailable",

    page9_planheader: "Start professionally , enjoy the features!",
    page9_planexplain: "40 Days free, full and unlimited access!",
    page9_plantitle: "Select your follower count to see the right package",

    page9_freeplan: "Free",
    page9_basicplan: "Basic",
    page9_proplan: "Pro",
    page9_adsplan: "Ads",
    page9_storeplan: "Store",
    page9_monthly: "monthly",
    page9_Compare: "Compare plans in details",
    page9_content_management: "Post and Story Management",
    page9_analize_management: "Advanced Analytics and Statistical Tools",
    page9_message_management: "Direct and Comment Management",
    page9_biolink_management: "Smart Bio Link and Custom Website",
    page9_subadmin_management: "Sub-admin Hiring and Management",
    page9_basicoption: "Basic Tools",
    page9_ticket_management: "Direct Sales & Smart Tickets",
    page9_finance_management: "Payment & Wallet",
    page9_store_management: "Smart Store Inventory",
    page9_logestic_management: "Automated Shipping & Delivery",
    page9_storeanalize_management: "Advanced Sales Analytics",
    page9_calendar_management: "Ad Scheduling Calendar",
    page9_advertise_management: "Smart Ad Management",
    page9_adsanalize_management: "Advanced Ad Analytics",
    page9_campagin_management: "Create and Join Campaigns",
    page9_adsticket_management: "Auto-Send Ad Feedback to Clients",

    page6_Header: "Thousands of active businesses",
    page6_Explain: "Most successful businesses have joined the big Brancy family",
    page10_header: "What Our Customers are Saying",
    page8_HelpCenter: "Help Center",
    page8_Community: "Community",
    page8_learn: "Learn",
    page8_Blog: "Blog",
    page8_FAQ: "FAQ",
    page8_Support: "Support",
    support_Online: "Online support",
    support_EnterBlog: "Enter blog",
    page8_CommunityExplain:
      "Connect with other users, share your experiences, and benefit from collective advice for further growth.",
    page8_learnExplain:
      "In this section, you will learn the latest strategies for using Instagram in business. Everything you need for business growth can be found here.",
    page8_BlogExplain:
      "Access the latest articles and educational content. Up-to-date information in various business and digital marketing fields awaits you.",
    page8_FAQExplain:
      "Your frequently asked questions are answered here. For any guidance on services or products, refer to this section.",
    page8_SupportExplain:
      "Our support team is ready to assist you. If you have any issues or questions, just contact us.",
    page8_CommunityBTN: "Let's Connect",
    page8_learnBTN: "Learn Fast",
    page8_BlogBTN: "Read the Latest",
    page8_FAQBTN: "Quick Answers",
    page8_SupportBTN: "We're Here to Help",
    footer_Brancy: "Brancy",
    footer_AboutUs: "About Us",
    installPromptMessage: "Install the Brancy web app",
    install: "Install",
    installStep1: "Tap the share button in the bottom bar.",
    installStep2: "Scroll the opened menu up and choose Add to Home Screen.",
    installStep3: "Tap Add at the top of the screen.",
    // About Us Page

    aboutUs_pageTitle: "About Brancy",
    aboutUs_metaDescription:
      "Discover Brancy, a comprehensive and international platform for managing social networks and digital businesses; where innovation, trust, and sustainable growth come together to shape the future of the digital economy.",
    aboutUs_subtitle: "Smart Management of the Digital Economy with Brancy",
    aboutUs_ourStoryTitle: "Our Story",
    aboutUs_ourStoryPara1:
      "Brancy was born with the goal of redefining online business management; a point where advanced technologies and the real needs of business owners intersect. We don’t just provide a tool, we’ve created a platform where businesses can operate like a large, professional organization.",
    aboutUs_ourStoryPara2:
      "This path was built on a belief: technology should facilitate human and business growth, not become an obstacle.",
    aboutUs_innovationTitle: "Innovation as a Fundamental Advantage",
    aboutUs_innovationPara1:
      "Brancy leverages AI, big data, and modern web technologies to deliver a seamless, secure, and efficient experience for users. Every feature is designed with simplicity and maximum productivity in mind.",
    aboutUs_innovationPara2:
      "For us, innovation is not limited to technology; it’s a strategic approach rooted in our organizational culture and vision for the future.",
    aboutUs_coreValuesTitle: "Our Core Values",
    aboutUs_innovationFirstTitle: "Pioneering Innovation",
    aboutUs_innovationFirstDesc:
      "We are always looking for solutions that meet the future needs of digital businesses.",
    aboutUs_trustSecurityTitle: "Trust & Security",
    aboutUs_trustSecurityDesc:
      "Data security and process transparency are our priorities so users can grow with complete confidence.",
    aboutUs_globalCommunityTitle: "A Global Community",
    aboutUs_globalCommunityDesc:
      "Brancy goes beyond borders, connecting a global ecosystem of businesses and professionals.",
    aboutUs_sustainableGrowthTitle: "Sustainable Growth",
    aboutUs_sustainableGrowthDesc:
      "We are committed to smart and sustainable expansion aligned with ethical principles and social responsibility.",
    aboutUs_userEmpowermentTitle: "User Empowerment",
    aboutUs_userEmpowermentDesc:
      "Our intuitive tools and educational resources ensure equal access to digital opportunities for everyone.",
    aboutUs_continuousEvolutionTitle: "Continuous Evolution",
    aboutUs_continuousEvolutionDesc:
      "In a dynamic world, change is part of our path. We continuously move forward with learning and constant improvement.",
    aboutUs_globalImpactTitle: "Global Impact",
    aboutUs_globalImpactPara:
      "Today, Brancy is a platform empowering millions of entrepreneurs and businesses; a bridge between digital opportunities and a borderless future.",
    aboutUs_activeUsers: "Active Users",
    aboutUs_countries: "Covered Countries",
    aboutUs_uptime: "System Uptime",
    aboutUs_support: "Dedicated Support",
    aboutUs_teamTitle: "Brancy Team",
    aboutUs_teamPara1:
      "Our team is a blend of technologists, strategists, and creatives from around the world, united by the shared mission of developing the digital economy.",
    aboutUs_teamPara2:
      "From industry pioneers to the energy of young talents, we at Brancy lead a global movement shaping a new generation of digital commerce.",

    footer_ContactUs: "Contact Us",
    footer_JoinUs: "Join Us",
    footer_OrgChart: "Org Chart",
    footer_FollowUs: "Follow Us",
    footer_Solutions: "Solutions",
    footer_HelpCenter: "Help Center",
    footer_Support: "Support",
    footer_FAQ: "Frequently Asked Questions",
    footer_ReportAnIssue: "Report An Issue",
    footer_TrustLegal: "Trust & Legal",
    footer_TermsAndConditions: "Terms & Conditions",
    footer_PrivacyNotice: "Privacy Notice",
    footer_CookieNotice: "Cookie Notice",
    footer_Blog: "Blog",
    footer_ProductUpdates: "Latest Updates",
    footer_Articles: "Articles",
    footer_LatestNews: "Latest News",

    // Join Us page
    joinUs_subtitle: "Join Brancy; where innovation and a sustainable future take shape.",
    joinUs_whyWorkWithUs: "Why Brancy?",
    joinUs_whyWorkWithUsDescription:
      "Brancy is not just a workplace; it is a strategic platform for both professional and personal growth. We believe leading organizations are built on top talents. Our commitment is to create a dynamic, transparent, and supportive environment where team members can make a lasting impact.",
    joinUs_openPositions: "Open Positions",
    joinUs_openPositionsDescription:
      "Explore available opportunities and choose the role that matches your expertise and career vision.",
    joinUs_frontendDeveloper: "Frontend Developer",
    joinUs_frontendDeveloperDescription:
      "Responsible for designing and implementing modern user experiences using React and TypeScript. You will play a key role in enhancing product quality and performance.",
    joinUs_backendDeveloper: "Backend Developer",
    joinUs_backendDeveloperDescription:
      "Design and develop scalable and secure systems with Node.js and cloud technologies. This role requires systemic thinking and problem-solving for complex challenges.",
    joinUs_uiUxDesigner: "UI/UX Designer",
    joinUs_uiUxDesignerDescription:
      "Create standard user interfaces and intuitive experiences that drive satisfaction and loyalty. Attention to detail and creativity are vital here.",
    joinUs_productManager: "Product Manager",
    joinUs_productManagerDescription:
      "Lead product strategy and coordinate cross-functional teams to deliver effective and competitive solutions. This position suits analytical thinkers with stakeholder management skills.",
    joinUs_marketingSpecialist: "Marketing Specialist",
    joinUs_marketingSpecialistDescription:
      "Plan and execute digital marketing campaigns and strengthen brand positioning in the market. This role requires both analytical and creative skills.",
    joinUs_customerSupport: "Customer Support Specialist",
    joinUs_customerSupportDescription:
      "Provide professional support services, solve issues effectively, and enhance user experience. This position requires accuracy, patience, and strong communication skills.",
    joinUs_engineering: "Engineering",
    joinUs_design: "Design",
    joinUs_product: "Product",
    joinUs_marketing: "Marketing",
    joinUs_support: "Support",
    joinUs_remoteOnsite: "Remote / Onsite",
    joinUs_onsite: "Onsite",
    joinUs_remote: "Remote",
    joinUs_fullTime: "Full-Time",
    joinUs_partTimeFullTime: "Part-Time / Full-Time",
    joinUs_applyNow: "Apply Now",
    joinUs_applicationProcess: "Brancy Recruitment Process",
    joinUs_submitApplication: "Submit Application",
    joinUs_submitApplicationDescription: "Send your resume and skills. Our team will review it carefully.",
    joinUs_initialScreening: "Initial Screening",
    joinUs_initialScreeningDescription:
      "HR department reviews resumes within 3 to 5 business days and contacts if suitable.",
    joinUs_technicalInterview: "Technical Interview",
    joinUs_technicalInterviewDescription:
      "Evaluation of technical knowledge and experience through specialized interviews with teams.",
    joinUs_finalInterview: "Final Interview",
    joinUs_finalInterviewDescription:
      "Final session with senior managers and key teams to ensure alignment of goals and values.",
    joinUs_welcomeAboard: "Welcome Aboard",
    joinUs_welcomeAboardDescription:
      "After acceptance, a comprehensive onboarding process will begin to familiarize you with the organization's culture and goals.",
    joinUs_readyToJoinUs: "Didn’t find your desired position?",
    joinUs_readyToJoinUsDescription:
      "We are always welcoming skilled and motivated individuals. Send your resume and describe your vision for collaboration with Brancy.",
    joinUs_sendYourResume: "Send Your Resume",

    // #region  landing page
    Dashboard: "Dashboard",
    greeting1: "The sun is awake with you,",
    greeting2: "Good morning full of energy,",
    greeting3: "Have a nice day,",
    greeting4: "Good afternoon,",
    greeting5: "Good golden evening,",
    greeting6: "Night is near",
    greeting7: "Good peaceful night,",
    greetingtext1: "Early morning is truly magical🌅",
    greetingtext2: "The world is waiting for your steps 💪",
    greetingtext3: "Time for some tea and a smile ☕😊",
    greetingtext4: "Enjoy your delicious food 🍽️",
    greetingtext5: "The sun is still in the sky, go ahead 🌟",
    greetingtext6: "Create a cool ending 🌇",
    greetingtext7: "Dream big and start tomorrow🌙",
    userpanel_yourorders: "Your Orders",
    userpanel_SavedProducts: "Saved Products",
    userpanel_NoSavedProducts: "No saved products available.",
    userpanel_Startexplore: "Start exploring between millions",
    userpanel_Startexploreexplain: "Markets, Products and pages",
    userpanel_TicketSupportExplain: "Order tracking, chat with seller",
    userpanel_TicketSupport: "Stay in touch via ticket",

    userpanel_UseInstagram: "Manage Instagram like a Pro.",
    userpanel_FreeProPanel: "Free ProPanel",
    userpanel_Premiumaccount: "Premium account",
    userpanel_daysFreePremium: "40 days Free Premium",
    userpanel_LimitedOffer: "Limited Offer !",
    // #region 0️⃣ General Section
    //0️⃣ General -> sidebar -> sidebar
    needPass: "Verification and Activation",
    needPassExplain: "To gain full access to this feature, the Instagram account password is required",
    soon: "Coming Soon",
    soonExplain: "we are working on it ! This feature will be available soon",
    underdevelop: "Under Development",
    welcomeToBrancy: "Welcome to Brancy!",
    notloginexplain: "To benefit from Brancy's services, please connect your Instagram account.",
    welcomeToBrancyExplain: "Enter your Instagram ID to set up your ultimate management panel.",
    welcomeToBrancyExplainPhone: "Enter your Phone Number to set up your ultimate management panel.",
    loginWithGoogle: "Google Login",
    loginWithMobile: "SMS Login",

    or: "or",
    InstagramID: "Instagram Username (ID)",
    EmptyNotification: "There is no notification yet",
    Notification_NewMessage: "You have a new message from {{sender}}",
    Notification_NewOrder: "You have a new order from {{sender}}",
    Notification_ImagesCreatedBy: "Your images were successfully created by the {{version}} model.",
    Notification_VideoCreatedBy: "Your video was successfully created by the {{version}} model.",
    Notification_MediaCreationFailed: "Your media failed to be created by the {{version}} model: {{metadata}}",
    Notification_VideoCreationFailed: "Your video failed to be created by the {{version}} model: {{metadata}}",
    Notification_NewPost: "New Post",
    Notification_UploadPostFailed: "Upload Post Failed",
    Notification_NewStory: "New Story",
    Notification_UploadStoryFailed: "Upload Story Failed",
    Notification_NewVideo: "New Video",
    Notification_VideoCreationFailedTitle: "Video Creation Failed",
    Notification_YouHaveNewMessage: "You have a new message",
    Notification_AccountDeauthorized: "Instagram account deauthorized",
    EnterYourText: "Enter Your Text",
    EnterYourphonenumber: "Enter Your Phone Number",
    CopyText: "Copy Text",
    successfulCopy: "Copied",
    download: "Download",
    automatic: "Automatic",
    manual: "Manual",
    phonenumber: "Phone Number",
    SendVerificationCode: "Send Code",
    ShowUserDashboard: "Go to Dashboard",
    VerificationCode: "Verification Code",
    VerificationCodeExplain: "Please enter the verification code sent to your phone.",
    remainingTime: "Remaining Time",
    createtime: "Create Time",
    ResendVerificationCode: "Resend Verification Code",
    Verify: "Verify",
    VerifyAddress: "Verify Address",
    VerifyCode: "Verify Code",
    Continue: "Continue",
    metaRedirect_aiAnalysisNotice:
      "Please note that analyzing your page with artificial intelligence may take several hours.",
    Efficiency: "Efficiency",
    max: "max",
    logout: "Log Out",
    notallowed: "Not Allowed",
    notallowedExplain: "You are not allowed to access this feature",
    notallowedExplainPage: "You are not allowed to access this page",

    CreateAutomationFlow: "Create Automation Flow",
    CreateAutomationFlowExplain: "Automate Instagram interactions with a visual workflow builder.",
    CreateAutomationAI: "Create Automation AI",
    CreateAutomationAIExplain: "Automate Instagram interactions with AI-driven responses.",
    flowProperties_notworking_privateReply:
      "⚠️ Note: This flow does not run in private chats with friends and is only used for automatic replies to comments and Direct messages",
    flowProperties_privateReply_requiresFollower:
      "This flow cannot be used for private replies. Enable The user must follow the page in Settings to activate it.",

    sending: "Sending",
    uploadsRemaining: "Uploads Remaining",
    logoutExplain: "you are attempting to Logout From Brancy",
    color: "Color",
    button: "Button",
    Liter: "Liter",
    FrontFace: "Front Face",
    SideFace: "Side Face",
    TopFace: "Top Face",
    Area: "Area",
    Perimeter: "Perimeter",
    Volume: "Volume",
    inSystem: "In System",
    reject: "Reject",
    rejected: "Rejected",
    approved: "Approved",
    ExpirationTime: "Expiration Time",
    send: "send",
    accept: "Accept",
    selectall: "Select All",
    General: "General",
    Business: "Business",
    undo: "Undo",
    redo: "redo",
    close: "Close",
    closed: "Closed",
    admin: "Admin",
    user: "User",
    total: "Total",
    Unknown: "Unknown",
    stop: "Stop",
    save: "Save",
    discard: "Discard",
    all: "All",
    update: "Update",
    like: "like",
    dislike: "Dislike",
    next: "Next",
    cancel: "cancel",
    canceled: "Canceled",
    comment: "comment",
    mention: "mention",
    add: "Add",
    icon: "Icon",
    select: "Select",
    copylist: "Copy List",
    reply: "Reply",
    replies: "Replies",
    PrivateReply: "Private Reply",
    copy: "Copy",
    everywhere: "Everywhere",
    UnHide: "UnHide",
    show: "show",
    Hide: "Hide",
    pageSummary: "Account Summary",
    summaryGeneralIntro: "General Page Overview",
    summaryUserEngagement: "User Engagement Analysis",
    summaryContentStrategy: "Content Strategy Review",
    summaryPostingSchedule: "Posting Schedule Evaluation",
    summaryImprovementSuggestions: "Improvement and Growth Suggestions",
    Ignore: "Ignore",
    Orange: "Orange",
    Purple: "Purple",
    Green: "Green",
    White: "White",
    DarkGray: "Dark Gray",
    Blue: "Blue",
    LightGray: "Light Gray",
    Brown: "Brown",
    Pink: "Pink",
    Yellow: "Yellow",
    Silver: "Silver",
    Black: "Black",
    Red: "Red",
    back: "back",
    start: "Start",
    country: "Country",
    device: "Device",
    yourdevice: "Your Device",
    otherdevice: "Other Device",
    SessionID: "Session ID",
    header: "header",
    upload: "upload",
    active: "Active",
    activate: "Activate",
    deactive: "Deactive",
    Deactivate: "Deactivate",
    activateAll: "Activate All",
    DeactivateAll: "Deactivate All",
    signout: "Sign out",
    switchaccount: "Switch Account",
    instagramConnect: "Connect Instagram Account",
    upgrade: "Upgrade",
    Renew_Subscription: "Renew Subscription",
    done: "Done",

    text: "Text",
    PlaceHolder: "Typing...",
    media: "Video/Photo",
    ReplyStory: "Reply to Story",
    photo: "Photo",
    audio: "Voice Message",
    Generic: "General",
    StoryMention: "Story Mention",
    FileShare: "File",
    voice: "Audio",

    abort: "Abort",
    Pending: "Pending",
    Preparing: "Preparing",
    Finished: "Finished",
    finish: "Finish",
    exportJPG: "Export JPG",
    exportPDF: "Export PDF",
    exportXlxs: "Export Excel",
    dismiss: "Dismiss",
    empty: "Empty",
    searching: "searching ...",
    searchMessage: "Search People or Keyword",
    searchKeyword: "Search Keyword",
    Recommended: "Recommended",
    VERFIED: "VERFIED",
    SuccessADS: "SuccessADS",
    SuccessSALES: "SuccessSALES",
    StartOrder: "StartOrder",
    Startshoping: "Startshoping",
    question: "question",
    Answer: "Answer",
    shareStory: "Share Story",
    search: "search",
    searchLocation: "Search Location",
    searchPeople: "Search People",
    edit: "Edit",
    delete: "Delete",
    deletecover: "Delete Cover",
    details: "Details",
    Insights: "Insights",
    new: "New",
    comments: "Comments",
    nocomment: "No Comments",
    SimilarProducts: "Similar Products",
    QandA: "Questions",
    caption: "Caption",
    collaborator: "collaborator Page",
    collaboratorpost: "collaborator Post",
    sidebar_Home: "Home",
    sidebar_Page: "Page",
    sidebar_Message: "Messages",
    sidebar_Wallet: "Wallet",
    sidebar_biolink: "Bio Link",
    sidebar_Advertise: "Advertises",
    sidebar_Store: "Store",
    sidebar_Stores: "Stores",
    sidebar_Business: "Business",
    sidebar_Setting: "Settings",
    //0️⃣ General -> navbar
    navbar_Post: "Post",
    navbar_Live: "Live",
    navbar_Story: "Story",
    navbar_Feed: "Feed",
    navbar_Reels: "Reels",
    navbar_Statistics: "Statistics",
    navbarTools: "Tools",
    navbar_Direct: "Directs",
    navbar_Comments: "Comments",
    navbar_Ticket: "Tickets",
    navbar_AI: "AI",
    navbar_ContentCreator: "Content Creator",
    navbar_Properties: "properties",
    navbar_AIAndFlow: "AI & Agent",
    navbar_Payment: "Payments",
    navbar_Title: "Title",
    navbar_Home: "Home",
    navbar_Biolink: "Mylink",
    navbar_Calendar: "Calendar",
    navbar_AdList: "Adlist",
    navbar_General: "General",
    navbar_SubAdmin: "SubAdmins",
    navbar_HelpCenter: "Help & Support",
    addnewaccount: "Add Account",
    addedaccounts: "Added Accounts",
    SwitchtoAccountexplain: "All your accounts added in Brancy listed here",
    SwitchtoAccount: "Switch to Account",
    accountmanagement: "Account Management",
    subadmininvitation: "Collaboration Invite",
    subadmininvitationexplain: "Instagram management invitation as a Sub Admin",
    Addfaq: "Add FAQ",
    addfaqexplain: "You can add up to 4 frequently asked questions",
    faqEmptyState: "Your frequently asked questions will appear here",

    navbar_Products: "Products",
    navbar_Orders: "Orders",
    navbar_totalOrders: "Total Orders",
    //0️⃣ countdown
    countdown_Days: "Days",
    countdown_Hours: "Hours",
    countdown_Minutes: "Minutes",
    Expired: "Expired",
    justnow: "Just Now",
    LessThanAMinute: "Less than a minute",
    ExpiresIn: "Expires in",
    ExportPDF: "Export PDF",
    ExportJPG: "Export JPG",
    ShareTo: "Share To",
    Expand: "Expand", // #endregion General Section      // #region 1️⃣home Section
    // 1️⃣ Home -> cards
    home_FollowRequest: "Follow Requests",
    home_UnreadNewComments: "Unread New Comments",
    home_Last24H: "Last 24 Hours",
    home_Last30Days: "Last 30 Days",
    home_LastLikes: "Last Likes",
    home_LastPost: "Last Post",
    home_Followings: "Followings",
    home_Followers: "Followers",
    AudienceLocation: "Active Audience Location",
    AudienceGender: "Active Audience Gender",
    AudienceAge: "Active Audience Age",

    AudienceGenderStats:
      "You have {{female}} female followers, {{male}} male followers, and {{unknown}} users with unknown gender",

    AudienceAgeStats:
      "Most of your audience is from the {{ageRange}} age range ({{percentage}}%) so content should be attractive and suitable for {{ageCategory}} audience.",

    AgeCategoryYoung: "young",
    AgeCategoryMiddleAged: "middle-aged",
    AgeCategoryOlder: "older",

    AudienceLocationStats:
      "Most of your active audience is from {{country}} with {{countryCount, number}} people and from {{city}} with {{cityCount, number}} people",

    // 1️⃣ Home -> last like
    lastLike: "Last Likes",
    // 1️⃣ Home -> last message
    lastMessage: "Last Messages",
    lastOrder: "Last Orders",
    lastTransaction: "Last Transactions",
    // 1️⃣ Home -> last follower
    LastFollowers: "Last Followers",
    // #endregion home Section      // #region 2️⃣page Section
    // 2️⃣ Page -> Post
    CreateNewPost: "Create New Post",
    Postnotvisible: "Post Not Visible?",
    Storynotvisible: "Story Not Visible?",
    SmartPageAnalysis: "Smart Page Analytics",
    EducationAndGuidance: "Education & Guidance",
    HowToUseBrancy: "How to Use Brancy",
    BrancyKnowsYou: "Brancy Knows You",
    BrancyKnowsYouExplain:
      "Brancy deeply analyzes your page to build a complete picture of your digital identity — from your personality, business, and activities to your communication tone and style, content type, presentation style, posting schedule, and the way you interact with your audience.\n\nThis analysis also considers how you operate across all of your page's communication touchpoints — from responding to comments and Direct messages to your writing style, the way you interact with your audience, and how you respond to different situations.\n\nWith no need for manual training, tone configuration, or entering additional information, Brancy knows you and aligns its AI with your real identity and style.",
    CreateYourDigitalVersion: "Create Your Digital Version",
    CreateNewStrory: "Create New Story",
    PostDraft: "Post Draft",
    StoryDraft: "Story Draft",
    publishError: "Publish Error",
    DeletedPost: "Deleted Post",
    errorDraft_title: "An error occurred while publishing the post",
    errorDraft_configFailed: "Post publishing settings are incorrect, please check and correct them.",
    errorDraft_invalidTags: "Invalid tags: ",
    errorDraft_unknown: "Unknown error! Please try again.",
    errorDraft_uploadError: "Image upload failed, please try again.",
    errorDraft_userCancel: "Post publishing was canceled by you.",
    InvalidAspectRatio: "Invalid aspect ratio",
    SizeLimitExceed: "File size exceeds the limit",
    UnSupportMediaType: "Unsupported media type",
    NotPublishedAtTheTime: "Post not published at the selected time",
    NotSuccessLogin: "Login unsuccessful",

    NewScheduledPost: "New Scheduled Post",
    thereAreNoPost: "You haven't created any scheduled Post yet",
    ScheduledPost: "Scheduled Post",
    // 2️⃣ Page -> story
    pageStory_CreateNewStory: "Create New Story ",
    pageStory_CreateNewStories: "New Scheduled Story ",
    pageStory_thereAreNoStories: "You haven't created any scheduled Story yet",
    pageStory_ScheduledStories: "Scheduled Story",
    // 2️⃣ Page -> highlight
    pageStory_highlightManagement: "Highlight Management",
    pageStory_thereAreNoHighlight: "There are no Highlights",
    pageStory_HighlightTitle: "Highlights / Folders",
    // 3️⃣ Page -> statistics
    pageStatistics_YourBestFollowers: "Your Best Followers",
    pageStatistics_YourBestFollowersExplain:
      "Calculated based on the total interaction score across the entire page (including likes, comments, and shares).",
    pageStatistics_LoadMore: "Load More",
    pageStatistics_UnFollowers: "Unfollowers",
    pageStatistics_Followers: "Followers",
    pageStatistics_NewFollowers: "New Followers",
    pageStatistics_ActiveFollowers: "Active Followers",
    pageStatistics_MediaFollows: "Media Follows",
    pageStatistics_Reach: "Reach",
    pageStatistics_ProfileVisit: "Profile Visits",
    pageStatistics_30Days: "30 days",
    pageStatistics_60Days: "60 days",
    pageStatistics_90Days: "90 days",
    pageStatistics_120Days: "120 days",
    pageStatistics_WorstTime: "Worst Time",
    pageStatistics_BestTime: "Best Time",
    pageStatistics_likes: "Likes",
    pageStatistics_Impression: "Impression",
    pageStatistics_Engagements: "Engagements",
    pageStatistics_Views: "Views",
    pageStatistics_RePosts: "Reposts",
    pageStatistics_followerViews: "Visitor Followers",
    pageStatistics_ghostViewers: "Ghost Viewers",
    pageStatistics_Comments: "Comments",
    pageStatistics_Shares: "Shares",
    pageStatistics_summary: "Summary",
    pageStatistics_EmptyList: "There is no data yet!",
    pageStatistics_from: "From",
    pageStatistics_post: "Posts",
    pageStatistics_stories: "Stories",
    pageStatistics_MaxView: "Max Reach",
    pageStatistics_MinView: "Min Reach",
    pageStatistics_MaxCommentLike: "Max Comment & Like",
    pageStatistics_MinCommentLike: "Min Comment & Like",
    pageStatistics_PostTimeAnalysis: "Post Time Analysis",
    pageStatistics_Rate: "Rate",
    pageStatistics_RateExplain: "Based on the highest number of comments received across the entire page",

    pageStatistics_24HourHeatmap: "24-Hour Heatmap",
    pageStatistics_Low: "Low",
    pageStatistics_High: "High",
    pageStatistics_TopHour: "Top Hour",
    pageStatistics_WeakHour: "Weak Hour",
    pageStatistics_AverageHour: "Average Hour",
    pageStatistics_TopMinute: "Top Minute",
    pageStatistics_WeakMinute: "Weak Minute",
    pageStatistics_AverageMinute: "Average Minute",
    pageStatistics_HourExcellentLevel:
      "This hour has an excellent engagement level (above 80% capacity). Engagement during this time is {{percentage}}% higher than average, making it ideal for posting important content.",
    pageStatistics_HourGoodLevel:
      "This hour has a good engagement level (60–80% capacity). Engagement during this period is {{percentage}}% above average, suitable for posting regular content.",
    pageStatistics_HourAverageLevel:
      "This hour has an average engagement level (40–60% capacity). For better results, try hours with higher intensity (green). Difference from the best time: {{difference}}%.",
    pageStatistics_HourWeakLevel:
      "This hour has a weak engagement level (20–40% capacity). Posting during higher-intensity hours is recommended.",
    pageStatistics_HourVeryWeakLevel:
      "This hour has a very weak engagement level (below 20% capacity). Engagement is lower than expected and posting is not recommended.",
    pageStatistics_MinuteTopDescription:
      "This minute is among the top 10 minutes of {{hour}}:00. For maximum engagement, posting exactly at this time is recommended. Difference from the weakest minute: {{difference}}%.",
    pageStatistics_MinuteWeakDescription:
      "Engagement during this minute is low. Posting in the early or mid minutes of the hour may yield better results. Difference from the best minute: {{difference}}%.",
    pageStatistics_MinuteAverageDescription:
      "Engagement is average. To further optimize, review the higher-ranked minutes of this hour.",
    pageStatistics_PeakEngagement: "Peak Engagement",
    pageStatistics_StableGrowth: "Stable Growth",
    pageStatistics_HighEngagementProbability: "High Engagement Probability",
    pageStatistics_LowestEngagement: "Lowest Instant Engagement",
    pageStatistics_SustainedLowPeriod: "Sustained Low Period",
    pageStatistics_LowEngagementProbability: "Low Engagement Probability",
    pageStatistics_BestTimes: "Best Times",
    pageStatistics_WorstTimes: "Worst Times",
    pageStatistics_EngagementPrediction: "Engagement Prediction",
    pageStatistics_PeakTimeDescription:
      "This moment has the highest engagement. Posting at this hour is recommended for maximum audience reach.",
    pageStatistics_StableTimeDescription:
      "Engagement starts rising from this time and remains above average. Suitable for stable engagement.",
    pageStatistics_SecondaryTimeDescription: "Posting at this time can be expected to yield good results.",
    pageStatistics_LowestTimeDescription:
      "This time has the lowest instant engagement. Posting at this hour loses {{percentage}}% of potential engagement.",
    pageStatistics_SustainedLowTimeDescription:
      "Engagement starts declining from this time and stays low for a while. Not recommended for posting.",
    pageStatistics_SecondaryLowTimeDescription:
      "Another weak moment with low engagement probability. Posting at this time is not recommended.",
    pageStatistics_HourEngagementTooltip: "{{hour}}:00 - {{count}} Engagement ({{percentage}}%)",
    pageStatistics_MinuteEngagementTooltip: "{{hour}}:{{minute}} - {{count}} Engagement",
    // statistics suggestions box

    Statistics_UnFollowers_up_title: "Decrease in Unfollowers 💡Time to strengthen your retention strategy",
    Statistics_UnFollowers_up_summary:
      "The drop has decreased, meaning your recent content worked. Continue this path with more accuracy.",
    Statistics_UnFollowers_up_action1: "Analyze your last three Posts in terms of cover, first line, and CTA.",
    Statistics_UnFollowers_up_action2: "Create a weekly calendar based on these formats and track the changes.",
    Statistics_UnFollowers_up_action3: "Create a welcome Story and a clean Highlight for new Followers.",
    Statistics_UnFollowers_up_urgency: "Medium",

    Statistics_UnFollowers_neutral_title: "Stable unfollow rate 💡get data from users before changing anything",
    Statistics_UnFollowers_neutral_summary:
      "Audience behavior hasn’t changed; you need to directly gather their opinions and run short tests.",
    Statistics_UnFollowers_neutral_action1: "Post a Story poll asking what they find more appealing.",
    Statistics_UnFollowers_neutral_action2: "Publish one fixed-format Post per week and compare the results.",
    Statistics_UnFollowers_neutral_action3:
      "Collect the three most frequent Comment issues and make a problem-solving Post for each.",
    Statistics_UnFollowers_neutral_urgency: "Low",

    Statistics_UnFollowers_down_title: "Increase in Unfollowers 💡You Need a Quick Fix",
    Statistics_UnFollowers_down_summary:
      "A rise in unfollows means there's a negative signal in your content or posting rhythm; you need fast testing and reaction.",
    Statistics_UnFollowers_down_action1:
      "Check the last 7 days’ data and identify the two Posts with the highest unfollow count.",
    Statistics_UnFollowers_down_action2:
      "Publish an honest or behind-the-scenes Post and directly ask your audience for the reason.",
    Statistics_UnFollowers_down_action3:
      "Post an open Question Story asking “Why did you unfollow?” and categorize the responses.",
    Statistics_UnFollowers_down_urgency: "High",

    Statistics_UnFollowers_zero_title: "No activity recorded 💡No data to analyze",
    Statistics_UnFollowers_zero_summary:
      "Due to lack of activity, no signals are generated for analysis; you must restart your posting cycle first.",
    Statistics_UnFollowers_zero_action1: "Publish a value-driven Post to generate the first behavioral signal.",
    Statistics_UnFollowers_zero_action2:
      "Post two engagement-driven Stories (Poll or Question) to get initial reactions.",
    Statistics_UnFollowers_zero_action3: "Publish a short intro/update Post to trigger natural reach.",
    Statistics_UnFollowers_zero_urgency: "High",

    Statistics_Followers_up_title: "Increase in Followers 💡Greet New Entries Properly",
    Statistics_Followers_up_summary:
      "Your growth is rising; from the moment they enter, you must create a positive experience so they turn into active Followers.",
    Statistics_Followers_up_action1:
      "Create a welcome Highlight with the format “What you’ll find & how it helps you.”",
    Statistics_Followers_up_action2:
      "Plan two light collaborations or Mentions to keep the growth continuous and high-quality.",
    Statistics_Followers_up_action3: "Check the quality of Followers through campaign stats and Reels entry data.",
    Statistics_Followers_up_urgency: "Medium",

    Statistics_Followers_neutral_title: "Steady Growth 💡Time for Short Tests",
    Statistics_Followers_neutral_summary:
      "Page growth is stable; you need 7-day tests to learn what impacts attraction.",
    Statistics_Followers_neutral_action1: "Run a 7-day test on hashtags, posting time, and different covers.",
    Statistics_Followers_neutral_action2: "Record the results and turn the best combination into a fixed format.",
    Statistics_Followers_neutral_action3:
      "Publish a short intro video so new visitors quickly understand what to expect.",
    Statistics_Followers_neutral_urgency: "Medium",

    Statistics_Followers_down_title: "Drop in Attraction 💡Your Recent Content Likely Doesn’t Match the Persona",
    Statistics_Followers_down_summary:
      "A decrease in attraction means there's a mismatch signal between your recent content and your target audience.",
    Statistics_Followers_down_action1: "Find three mismatches between your persona and recent content, and fix them.",
    Statistics_Followers_down_action2: "Quickly rewrite and test your bio, CTA, and covers of recent Posts.",
    Statistics_Followers_down_action3: "Run a small collaboration or UGC campaign to reactivate your page perception.",
    Statistics_Followers_down_urgency: "High",

    Statistics_Followers_zero_title: "No Recent Activity 💡No Attraction Data Generated",
    Statistics_Followers_zero_summary:
      "Due to no posting or attraction actions, there are no signals for analysis; you must reactivate your attraction cycle.",
    Statistics_Followers_zero_action1: "Publish five short Reels with a 3-second hook to generate the first entries.",
    Statistics_Followers_zero_action2: "Publish an intro or update Post to initiate natural reach.",
    Statistics_Followers_zero_action3: "Run a small attraction campaign (even local) to restart the growth.",
    Statistics_Followers_zero_urgency: "High",

    Statistics_MediaFollows_up_title: "Explore Traffic Has Increased 💡Serial Content Is the Best Strategy",
    Statistics_MediaFollows_up_summary:
      "You have external referrals and traffic; turn your successful formats into a consistent series.",
    Statistics_MediaFollows_up_action1:
      "Split the successful format into 3 to 5 parts with a shared CTA in all episodes.",
    Statistics_MediaFollows_up_action2:
      "Choose a fixed cover and consistent schedule so the audience gets used to following the series.",
    Statistics_MediaFollows_up_action3:
      "Monitor distribution during the first days and focus on the source that brings fast traffic.",
    Statistics_MediaFollows_up_urgency: "Medium",

    Statistics_MediaFollows_neutral_title: "Moderate Referral 💡Time for A/B Testing on Cover and Source",
    Statistics_MediaFollows_neutral_summary:
      "To increase Explore input, the cover and referral source must be optimized.",
    Statistics_MediaFollows_neutral_action1: "Publish two A/B covers and compare their 48-hour performance.",
    Statistics_MediaFollows_neutral_action2: "List the sources that brought the most traffic and target them again.",
    Statistics_MediaFollows_neutral_action3: "Build a bank of successful formats to make repetition easier.",
    Statistics_MediaFollows_neutral_urgency: "Low",

    Statistics_MediaFollows_down_title: "Explore Reach Has Dropped 💡You Need More Engaging Content",
    Statistics_MediaFollows_down_summary: "For Explore reach, more practical or downloadable content performs better.",
    Statistics_MediaFollows_down_action1:
      "Create a downloadable PDF or checklist and provide a link for easier sharing.",
    Statistics_MediaFollows_down_action2: "Publish short educational content and test targeted promotion on it.",
    Statistics_MediaFollows_down_action3: "Check all links and referral paths technically to ensure nothing is broken.",
    Statistics_MediaFollows_down_urgency: "High",

    Statistics_MediaFollows_zero_title: "No Activity 💡No Explore Signal Has Been Built",
    Statistics_MediaFollows_zero_summary:
      "With no posting or growth actions, there’s no data to analyze; you must activate the content cycle first.",
    Statistics_MediaFollows_zero_action1:
      "Start being consistent with creating and publishing engaging content for users.",
    Statistics_MediaFollows_zero_action2:
      "Publish five short daily pieces of content to generate the first referral signals.",
    Statistics_MediaFollows_zero_action3: "Post a boosting Post on day one to generate initial traffic.",
    Statistics_MediaFollows_zero_urgency: "High",

    Statistics_Reach_up_title: "Reach Has Grown 💡Time to Scale",
    Statistics_Reach_up_summary: "Reach has increased; repeat your best formats to keep the growth wave going.",
    Statistics_Reach_up_action_1: "Repost two of the highest Reach formats during peak times.",
    Statistics_Reach_up_action_2: "Lock in effective hashtags and always include them in the caption.",
    Statistics_Reach_up_action_3: "Create Posts with high shareability to boost organic Reach.",
    Statistics_Reach_up_urgency: "Medium",

    Statistics_Reach_neutral_title: "Reach is Stable 💡Testing Needed",
    Statistics_Reach_neutral_summary:
      "To break the plateau, light collaboration or hashtag testing is the best approach.",
    Statistics_Reach_neutral_action_1: "Coordinate a cross-Post with a similar niche page.",
    Statistics_Reach_neutral_action_2: "Publish two educational or entertaining Reels and evaluate feedback.",
    Statistics_Reach_neutral_action_3: "Check your weekly hashtag list and find the best combination.",
    Statistics_Reach_neutral_urgency: "Low",

    Statistics_Reach_down_title: "Reach Dropped 💡Immediate Action Needed",
    Statistics_Reach_down_summary: "Reach has decreased; shareable content and short-term tests are the priority.",
    Statistics_Reach_down_action_1: "Run a 7-day test on high-potential Reels.",
    Statistics_Reach_down_action_2: "Create shareable Posts and boost them with a short ad.",
    Statistics_Reach_down_action_3: "Rewrite the title, cover, and hashtags, then repost.",
    Statistics_Reach_down_urgency: "High",

    Statistics_Reach_zero_title: "No Reach Recorded 💡Low Activity",
    Statistics_Reach_zero_summary:
      "Due to lack of posts or sufficient signals, no Reach data exists; content cycle must be activated.",
    Statistics_Reach_zero_action_1: "Check data collection (API/logs) to ensure proper function.",
    Statistics_Reach_zero_action_2: "Publish 5 trending Reels and boost one from day two.",
    Statistics_Reach_zero_action_3: "Test the publishing schedule system and reset if needed.",
    Statistics_Reach_zero_urgency: "High",

    Statistics_ProfileVisit_up_title: "Profile Visits High 💡Focus on Conversion",
    Statistics_ProfileVisit_up_summary:
      "Good incoming traffic; Bio and CTA must be optimized quickly to turn visits into follows and clicks.",
    Statistics_ProfileVisit_up_action_1: "Rewrite the Bio with a clear value proposition and a direct CTA.",
    Statistics_ProfileVisit_up_action_2: "Create key Highlights so users understand what they saw and what to expect.",
    Statistics_ProfileVisit_up_action_3: "Publish a Post with a special offer to increase link click-through rate.",
    Statistics_ProfileVisit_up_urgency: "High",

    Statistics_ProfileVisit_neutral_title: "Visits Present, Conversion Low 💡Generate Leads",
    Statistics_ProfileVisit_neutral_summary:
      "You have traffic but low conversion; a magnetic lead can change the flow.",
    Statistics_ProfileVisit_neutral_action_1: "Add a free file or checklist to Highlights.",
    Statistics_ProfileVisit_neutral_action_2: "Enhance captions with CTA related to the profile.",
    Statistics_ProfileVisit_neutral_action_3: "Increase inviting and profile-guiding Stories.",
    Statistics_ProfileVisit_neutral_urgency: "Medium",

    Statistics_ProfileVisit_down_title: "Profile Visits Dropped 💡Need a Stronger Hook",
    Statistics_ProfileVisit_down_summary:
      "Curiosity has decreased; caption starters and CTA should be more engaging and clear.",
    Statistics_ProfileVisit_down_action_1: "Rewrite captions with a 3-5 word hook.",
    Statistics_ProfileVisit_down_action_2: "Add guiding Stories and bold the link.",
    Statistics_ProfileVisit_down_action_3: "Publish an inviting Post to encourage users to visit the profile.",
    Statistics_ProfileVisit_down_urgency: "High",

    Statistics_ProfileVisit_zero_title: "No Profile Visits 💡Insufficient Activity",
    Statistics_ProfileVisit_zero_summary:
      "Due to lack of posting or signals, no profile visits recorded; the engagement cycle needs reactivation.",
    Statistics_ProfileVisit_zero_action_1: "Check account status to ensure it's public.",
    Statistics_ProfileVisit_zero_action_2: "Publish an inviting Post with a clear CTA.",
    Statistics_ProfileVisit_zero_action_3: "Update key Highlights to generate the first visit signal.",
    Statistics_ProfileVisit_zero_urgency: "High",

    Statistics_Likes_up_title: "Likes Are Good 💡Build a Habit",
    Statistics_Likes_up_summary: "Users are liking; now aim to turn this behavior into a consistent habit.",
    Statistics_Likes_up_action_1: "Document successful formats (cover, template, length).",
    Statistics_Likes_up_action_2: "Add a simple CTA for likes at the end of the Post (e.g., 'If you agree ❤').",
    Statistics_Likes_up_action_3: "Run a small A/B test for the cover and first 3 seconds.",
    Statistics_Likes_up_urgency: "Medium",

    Statistics_Likes_neutral_title: "Likes Can Increase 💡Improve Hook & Cover",
    Statistics_Likes_neutral_summary: "There’s potential; changing the cover and hook can boost the like rate.",
    Statistics_Likes_neutral_action_1: "Optimize and test the cover and first 3 seconds.",
    Statistics_Likes_neutral_action_2: "Use emotional or question-based CTAs to invite likes.",
    Statistics_Likes_neutral_action_3: "Run a small poll to understand audience visual preferences.",
    Statistics_Likes_neutral_urgency: "Low",

    Statistics_Likes_down_title: "Likes Dropped 💡Redesign Visual Identity",
    Statistics_Likes_down_summary: "The message or image may not be strong; focus on the first moment of content.",
    Statistics_Likes_down_action_1: "Rewrite the cover and the first line of the caption.",
    Statistics_Likes_down_action_2: "Run an A/B test for cover color/design.",
    Statistics_Likes_down_action_3: "Publish strong and relevant visual Posts.",
    Statistics_Likes_down_urgency: "High",

    Statistics_Likes_zero_title: "Zero Likes 💡Either No Data or No Content",
    Statistics_Likes_zero_summary: "If there’s content but no likes, check the data; otherwise, start producing.",
    Statistics_Likes_zero_action_1: "Verify data recording accuracy.",
    Statistics_Likes_zero_action_2: "If there’s no content, publish several Posts with strong covers.",
    Statistics_Likes_zero_action_3: "Use partner networks to gather feedback.",
    Statistics_Likes_zero_urgency: "High",

    Statistics_Comments_up_title: "Comments Increased 💡Take Conversations Seriously",
    Statistics_Comments_up_summary:
      "People are talking; leverage them by responding and turning comments into content.",
    Statistics_Comments_up_action1: "Reply to comments and turn the top 3 ideas into a Post.",
    Statistics_Comments_up_action2: "Highlight the best comments or feature them in a Story.",
    Statistics_Comments_up_action3: "Add a question in the caption that encourages people to answer.",
    Statistics_Comments_up_urgency: "Medium",

    Statistics_Comments_neutral_title: "Comments Low 💡Add a Stimulus",
    Statistics_Comments_neutral_summary: "To generate conversation, post simple and direct questions.",
    Statistics_Comments_neutral_action1: "Leave an open question at the end of the Post.",
    Statistics_Comments_neutral_action2: "Quickly reply to the first 5 comments to encourage others.",
    Statistics_Comments_neutral_action3: "Run a short challenge or poll.",
    Statistics_Comments_neutral_urgency: "Low",

    Statistics_Comments_down_title: "Comments Dropped 💡Add Clear Stimuli",
    Statistics_Comments_down_summary: "You need direct CTAs and invitations to start conversations.",
    Statistics_Comments_down_action1: "Post a challenge or request personal experiences.",
    Statistics_Comments_down_action2: "Include a clear CTA for comments in the caption (e.g., 'What’s your opinion?').",
    Statistics_Comments_down_action3: "Respond quickly to initial comments.",
    Statistics_Comments_down_urgency: "High",

    Statistics_Comments_zero_title: "No Comments 💡Be Inviting",
    Statistics_Comments_zero_summary: "Content isn’t prompting people to comment; make formats more inviting.",
    Statistics_Comments_zero_action1: "Design simple and engaging questions (e.g., choosing between two options).",
    Statistics_Comments_zero_action2: "Reply quickly to first comments to encourage others.",
    Statistics_Comments_zero_action3: "Use direct CTAs to invite comments.",
    Statistics_Comments_zero_urgency: "High",

    Statistics_Views_up_title: "Views Increased 💡Leverage the Traffic",
    Statistics_Views_up_summary: "Video views are good; use the end of the video for directing traffic (profile/save).",
    Statistics_Views_up_action1: "Add a clear CTA at the end of the video (e.g., 'Save for more').",
    Statistics_Views_up_action2: "Place a link to supplementary content in bio or highlights.",
    Statistics_Views_up_action3: "Create and publish a shorter version or teaser.",
    Statistics_Views_up_urgency: "Medium",

    Statistics_Views_neutral_title: "Views Stable 💡Strengthen Hook and Cover",
    Statistics_Views_neutral_summary: "Work on the first 3 seconds and the cover to improve view rate.",
    Statistics_Views_neutral_action1: "Rewrite the opening hook and cover.",
    Statistics_Views_neutral_action2: "Publish a shorter version for testing.",
    Statistics_Views_neutral_action3: "Collect visual feedback from the audience.",
    Statistics_Views_neutral_urgency: "Low",

    Statistics_Views_down_title: "Views Dropped 💡Strengthen the Hook",
    Statistics_Views_down_summary: "The video start is weak; start testing shorter, engaging versions.",
    Statistics_Views_down_action1: "Create 5 strong 15-second videos with a compelling hook.",
    Statistics_Views_down_action2: "Rewrite the video opening and run A/B tests.",
    Statistics_Views_down_action3: "Increase editing speed to maintain attention.",
    Statistics_Views_down_urgency: "High",

    Statistics_Views_zero_title: "Zero Views? 💡Publish Content ASAP",
    Statistics_Views_zero_summary: "Start producing content immediately at the earliest opportunity.",
    Statistics_Views_zero_action1: "Start by analyzing the page workflow only.",
    Statistics_Views_zero_action2: "If no videos are published, produce 3 short reels.",
    Statistics_Views_zero_action3: "Run a booster post to generate initial impressions.",
    Statistics_Views_zero_urgency: "High",

    Statistics_FollowerViews_up_title: "Followers Are Watching 💡Build Internal Engagement",
    Statistics_FollowerViews_up_summary: "Followers are active; use them for internal engagement (AMA, polls).",
    Statistics_FollowerViews_up_action1: "Ask questions or run polls in Stories for followers.",
    Statistics_FollowerViews_up_action2: "Publish exclusive content for followers (like AMA).",
    Statistics_FollowerViews_up_action3: "Check formats against personas to match their preferences more accurately.",
    Statistics_FollowerViews_up_urgency: "Medium",

    Statistics_FollowerViews_neutral_title: "Follower Views Are Average 💡Test Timing & Format",
    Statistics_FollowerViews_neutral_summary: "Posting time or content type might need adjustment; run simple tests.",
    Statistics_FollowerViews_neutral_action1: "Shift posting times and track the impact.",
    Statistics_FollowerViews_neutral_action2: "Test a new format specifically for followers.",
    Statistics_FollowerViews_neutral_action3: "Personalize content based on past audience behavior.",
    Statistics_FollowerViews_neutral_urgency: "Low",

    Statistics_FollowerViews_down_title: "Follower Views Dropped 💡Gather Feedback",
    Statistics_FollowerViews_down_summary:
      "Possible drift from persona; collect feedback and implement 3 quick changes.",
    Statistics_FollowerViews_down_action1: "Collect recent feedback and apply three rapid changes.",
    Statistics_FollowerViews_down_action2: "Post engaging Stories to reactivate the audience.",
    Statistics_FollowerViews_down_action3: "Test personalized content versions.",
    Statistics_FollowerViews_down_urgency: "High",

    Statistics_FollowerViews_zero_title: "Follower Views Zero 💡Ensure Active Followers First",
    Statistics_FollowerViews_zero_summary: "You might have few active followers; wake them up first, then engage.",
    Statistics_FollowerViews_zero_action1: "Publish several Stories and posts to activate the audience.",
    Statistics_FollowerViews_zero_action2: "Engage directly with 10 active followers.",
    Statistics_FollowerViews_zero_action3: "Create content based on previous interests.",
    Statistics_FollowerViews_zero_urgency: "High",

    Statistics_NonFollowerViews_up_title: "Non-Follower Views Up 💡New Growth Opportunity",
    Statistics_NonFollowerViews_up_summary:
      "People outside your followers are watching; each post needs a strong reason to follow.",
    Statistics_NonFollowerViews_up_action1:
      "Include a strong follow reason in the caption (e.g., series content or step-by-step tutorials).",
    Statistics_NonFollowerViews_up_action2: "Create trendy, engaging Reels to pull non-followers into interaction.",
    Statistics_NonFollowerViews_up_action3: "Use targeted hashtags and relevant collaborations.",
    Statistics_NonFollowerViews_up_urgency: "Medium",

    Statistics_NonFollowerViews_neutral_title: "Non-Follower Views Stable 💡Optimize Hashtags and Distribution",
    Statistics_NonFollowerViews_neutral_summary:
      "Optimizing hashtags and shareable content can increase non-follower traffic.",
    Statistics_NonFollowerViews_neutral_action1: "Identify effective hashtags and keep a few consistent.",
    Statistics_NonFollowerViews_neutral_action2: "Produce more shareable content.",
    Statistics_NonFollowerViews_neutral_action3: "Do a short collaboration with related pages.",
    Statistics_NonFollowerViews_neutral_urgency: "Low",

    Statistics_NonFollowerViews_down_title: "Non-Follower Views Down 💡Collaboration & Promo Needed",
    Statistics_NonFollowerViews_down_summary:
      "Explore reach is down; bring traffic back with collaboration or light promotion.",
    Statistics_NonFollowerViews_down_action1: "Set up a quick collaboration with a relevant page.",
    Statistics_NonFollowerViews_down_action2: "Create more shareable posts and publish a boosting post.",
    Statistics_NonFollowerViews_down_action3: "Run a small targeted ad to bring back traffic.",
    Statistics_NonFollowerViews_down_urgency: "High",

    Statistics_NonFollowerViews_zero_title: "Non-Follower Views Zero 💡Build Explore Signals",
    Statistics_NonFollowerViews_zero_summary: "For first traffic, trendy Reels and collaborations are the best start.",
    Statistics_NonFollowerViews_zero_action1: "Produce 3 trend-based Reels.",
    Statistics_NonFollowerViews_zero_action2: "Publish a boosting post to generate initial traffic.",
    Statistics_NonFollowerViews_zero_action3: "Start a quick collaboration with a relevant page.",
    Statistics_NonFollowerViews_zero_urgency: "High",

    Statistics_Shares_up_title: "Shares Up 💡Your Content Is Worth Spreading",
    Statistics_Shares_up_summary:
      "People are sharing your posts; the content has immediate value and can drive conversions.",
    Statistics_Shares_up_action1: "Analyze share feedback and identify patterns.",
    Statistics_Shares_up_action2: "Add a clear reason to share in the caption ('Send to your friend').",
    Statistics_Shares_up_action3: "Design a shareable educational series.",
    Statistics_Shares_up_urgency: "Medium",

    Statistics_Shares_neutral_title: "Shares Low or Stable 💡Just a Simple Trigger Needed",
    Statistics_Shares_neutral_summary: "Sometimes just a short CTA is enough to boost sharing.",
    Statistics_Shares_neutral_action1: "Add a very short CTA to share at the end of the post.",
    Statistics_Shares_neutral_action2: "Produce more saveable and shareable content.",
    Statistics_Shares_neutral_action3: "Run a test template 'Send to your friend'.",
    Statistics_Shares_neutral_urgency: "Low",

    Statistics_Shares_down_title: "Shares Down 💡More Practical Content Needed",
    Statistics_Shares_down_summary:
      "Content is less shareable; create something people actually want to send to others.",
    Statistics_Shares_down_action1: "Design checklists or step-by-step content.",
    Statistics_Shares_down_action2: "Publish short and concise tutorials.",
    Statistics_Shares_down_action3: "Add a clear CTA for sharing.",
    Statistics_Shares_down_urgency: "High",

    Statistics_Shares_zero_title: "No Shares 💡You Need a Starting Point",
    Statistics_Shares_zero_summary:
      "Either there’s no data or the content isn’t shareable; quickly design a distribution plan.",
    Statistics_Shares_zero_action1: "Produce several 5-tip or checklist content pieces.",
    Statistics_Shares_zero_action2: "Run a small boost to get the first signal.",
    Statistics_Shares_zero_action3: "Write a clear reason to share in the caption.",
    Statistics_Shares_zero_urgency: "High",

    Statistics_Engagement_up_title: "Engagement Growing 💡Lock the Formula",
    Statistics_Engagement_up_summary: "You've found a winning pattern; now repeat it and scale it up.",
    Statistics_Engagement_up_action1: "Record successful formats and timings precisely.",
    Statistics_Engagement_up_action2: "Add engagement-driving formats to the content calendar.",
    Statistics_Engagement_up_action3: "Test one new retention-focused format weekly.",
    Statistics_Engagement_up_urgency: "Medium",

    Statistics_Engagement_neutral_title: "Engagement Average 💡You Need a Fresh Trigger",
    Statistics_Engagement_neutral_summary:
      "To grow, introduce new triggers like questions, challenges, or comment invitations.",
    Statistics_Engagement_neutral_action1: "Publish one comment-inviting post per week.",
    Statistics_Engagement_neutral_action2: "Channel engagement and compare results across formats.",
    Statistics_Engagement_neutral_action3: "Design a few quick-interaction templates.",
    Statistics_Engagement_neutral_urgency: "Low",

    Statistics_Engagement_down_title: "Engagement Dropping 💡Rapid Redesign Needed",
    Statistics_Engagement_down_summary: "New tests must run immediately; a 14-day plan is the best start.",
    Statistics_Engagement_down_action1: "Execute a 14-day plan with 3 different formats.",
    Statistics_Engagement_down_action2: "Record data daily and pivot quickly.",
    Statistics_Engagement_down_action3: "Ask your audience directly what content they find engaging.",
    Statistics_Engagement_down_urgency: "High",

    Statistics_Engagement_zero_title: "Zero Engagement 💡A 7-Day Intensive Plan Needed",
    Statistics_Engagement_zero_summary:
      "You need to generate engagement signals fast; post interactive content daily and track the data.",
    Statistics_Engagement_zero_action1: "Publish polls, open questions, and small challenges.",
    Statistics_Engagement_zero_action2: "Test each format for 3 days.",
    Statistics_Engagement_zero_action3: "Respond quickly to comments and messages.",
    Statistics_Engagement_zero_urgency: "High",

    Statistics_Replies_up_title: "Story Replies High 💡Turn Them Into Content",
    Statistics_Replies_up_summary: "Your audience is writing; they’re craving interaction. This is content gold.",
    Statistics_Replies_up_action_1: "Pick 3 of the best replies and turn them into a post or Reel.",
    Statistics_Replies_up_action_2: "Create a Q&A or FAQ with the most common answers.",
    Statistics_Replies_up_action_3: "Show some replies in the next story to motivate others.",
    Statistics_Replies_up_urgency: "Medium",

    Statistics_Replies_neutral_title: "Replies Low 💡Add a Trigger",
    Statistics_Replies_neutral_summary: "Sometimes just a simple question is enough to get more answers.",
    Statistics_Replies_neutral_action_1: "Add a question sticker, poll, or quiz.",
    Statistics_Replies_neutral_action_2: "Ask short and engaging questions.",
    Statistics_Replies_neutral_action_3: "React quickly to answers to boost interaction.",
    Statistics_Replies_neutral_urgency: "Low",

    Statistics_Replies_down_title: "Replies Dropping 💡Increase Closeness",
    Statistics_Replies_down_summary: "Audience seems distant; reconnect with more personal content.",
    Statistics_Replies_down_action_1: "Post a few personal, experience-based, or emotional stories.",
    Statistics_Replies_down_action_2: "Ask questions that require personal experiences to answer.",
    Statistics_Replies_down_action_3: "Prioritize the first answers; react or reply to them.",
    Statistics_Replies_down_urgency: "High",

    Statistics_Replies_zero_title: "Zero Replies 💡Direct Invitation Needed",
    Statistics_Replies_zero_summary: "When no one responds, you need to ask tempting, direct questions.",
    Statistics_Replies_zero_action_1: "Post very simple and engaging questions (like choosing between two options).",
    Statistics_Replies_zero_action_2: "Highlight the responses you get to encourage others.",
    Statistics_Replies_zero_action_3: "Run a light interactive story daily.",
    Statistics_Replies_zero_urgency: "High",

    Statistics_TotalTime_up_title: "Watch Time Increased 💡Give Deeper Content",
    Statistics_TotalTime_up_summary: "Audience is investing time; they're ready for longer, chaptered content.",
    Statistics_TotalTime_up_action_1: "Create longer videos with intro/middle/conclusion structure.",
    Statistics_TotalTime_up_action_2: "Add links to supplementary content in bio or highlights.",
    Statistics_TotalTime_up_action_3: "Segment the video clearly to boost retention.",
    Statistics_TotalTime_up_urgency: "Medium",

    Statistics_TotalTime_neutral_title: "Watch Time Normal 💡Strengthen Structure",
    Statistics_TotalTime_neutral_summary: "Audience stays, but doesn’t lock in; improve structure to retain them.",
    Statistics_TotalTime_neutral_action_1: "Implement a three-layer structure for videos.",
    Statistics_TotalTime_neutral_action_2: "Highlight key points so viewers know what to expect.",
    Statistics_TotalTime_neutral_action_3: "Create a summary version for testing and comparison.",
    Statistics_TotalTime_neutral_urgency: "Low",

    Statistics_TotalTime_down_title: "Watch Time Dropped 💡Weak First Hook",
    Statistics_TotalTime_down_summary:
      "The first 3 seconds need a strong hook; make it faster, punchier, and more engaging.",
    Statistics_TotalTime_down_action_1: "Rewrite the first 3 seconds and test multiple versions.",
    Statistics_TotalTime_down_action_2: "Create very short 15–30 second versions.",
    Statistics_TotalTime_down_action_3: "Sharpen editing rhythm, cuts, and music.",
    Statistics_TotalTime_down_urgency: "High",

    Statistics_TotalTime_zero_title: "Watch Time Zero 💡Haven’t Published Yet?",
    Statistics_TotalTime_zero_summary: "If the video exists but no time is recorded, check for technical issues first.",
    Statistics_TotalTime_zero_action_1: "Ensure the content is actually published.",
    Statistics_TotalTime_zero_action_2: "If unpublished, post 3 short reels back-to-back.",
    Statistics_TotalTime_zero_action_3: "Run a boost or initial display to gather data.",
    Statistics_TotalTime_zero_urgency: "High",

    Statistics_ReachMonth_up_title: "Monthly Reach Up 💡Lock the Patterns",
    Statistics_ReachMonth_up_summary: "Successful months are clear; note the patterns and plan for the next month.",
    Statistics_ReachMonth_up_action_1: "Analyze high-performing months and record the patterns.",
    Statistics_ReachMonth_up_action_2: "Update the content calendar with these patterns.",
    Statistics_ReachMonth_up_action_3: "Repost winning formats for the next month.",
    Statistics_ReachMonth_up_urgency: "Medium",

    Statistics_ReachMonth_neutral_title: "Monthly Reach Stable 💡Time for Testing & Growth",
    Statistics_ReachMonth_neutral_summary: "To boost monthly reach, run a short campaign or limited ad.",
    Statistics_ReachMonth_neutral_action_1: "Launch a joint campaign or a limited ad.",
    Statistics_ReachMonth_neutral_action_2: "Record, compare results, and optimize.",
    Statistics_ReachMonth_neutral_action_3: "Boost previous successful posts again.",
    Statistics_ReachMonth_neutral_urgency: "Low",

    Statistics_ReachMonth_down_title: "Monthly Reach Down 💡Recreate Content",
    Statistics_ReachMonth_down_summary: "To restore reach, reshare or rebuild key posts.",
    Statistics_ReachMonth_down_action_1: "Reshare or recreate key posts.",
    Statistics_ReachMonth_down_action_2: "Run a 14-day content production and promotion campaign.",
    Statistics_ReachMonth_down_action_3: "Review hashtags and tags again.",
    Statistics_ReachMonth_down_urgency: "High",

    Statistics_ReachMonth_zero_title: "Monthly Reach Zero 💡Check Data First",
    Statistics_ReachMonth_zero_summary: "No or incomplete data; check technical issues first, then run a 14-day plan.",
    Statistics_ReachMonth_zero_action_1: "Check data connections and registrations.",
    Statistics_ReachMonth_zero_action_2: "Implement a 14-day content production plan.",
    Statistics_ReachMonth_zero_action_3: "Track daily results.",
    Statistics_ReachMonth_zero_urgency: "High",

    Statistics_MonthEngagement_up_title: "Monthly Engagement Up 💡Scale It",
    Statistics_MonthEngagement_up_summary: "Record positive monthly patterns and repeat them.",
    Statistics_MonthEngagement_up_action_1: "Document successful templates and formats.",
    Statistics_MonthEngagement_up_action_2: "Set clear KPIs and plans for next month.",
    Statistics_MonthEngagement_up_action_3: "Run small weekly tests to improve engagement.",
    Statistics_MonthEngagement_up_urgency: "Medium",

    Statistics_MonthEngagement_neutral_title: "Monthly Engagement Neutral 💡Add a Challenge Element",
    Statistics_MonthEngagement_neutral_summary: "A weekly challenge or question can boost engagement.",
    Statistics_MonthEngagement_neutral_action_1: "Publish one challenging or question-based content weekly.",
    Statistics_MonthEngagement_neutral_action_2: "Record and compare results.",
    Statistics_MonthEngagement_neutral_action_3: "Create a weekly engagement series.",
    Statistics_MonthEngagement_neutral_urgency: "Low",

    Statistics_MonthEngagement_down_title: "Monthly Engagement Down 💡Launch a 14-Day Plan",
    Statistics_MonthEngagement_down_summary: "Review formats and execute a 14-day plan.",
    Statistics_MonthEngagement_down_action_1: "Run a 14-day plan with 3 different formats.",
    Statistics_MonthEngagement_down_action_2: "Analyze results daily.",
    Statistics_MonthEngagement_down_action_3: "Collect direct feedback from the audience.",
    Statistics_MonthEngagement_down_urgency: "High",

    Statistics_MonthEngagement_zero_title: "Monthly Engagement Zero 💡Immediate 7-Day Program",
    Statistics_MonthEngagement_zero_summary: "Publish 7 quick interactive posts and monitor daily.",
    Statistics_MonthEngagement_zero_action_1: "Create 7 interactive posts.",
    Statistics_MonthEngagement_zero_action_2: "Review results daily.",
    Statistics_MonthEngagement_zero_action_3: "Engage with the audience via DMs and comments.",
    Statistics_MonthEngagement_zero_urgency: "High",

    Statistics_MonthView_up_title: "Monthly Views Up 💡Lock the Structure",
    Statistics_MonthView_up_summary: "Video strategy is working; publish these formats consistently.",
    Statistics_MonthView_up_action_1: "Document your video strategy.",
    Statistics_MonthView_up_action_2: "Turn consistent production into a standard format.",
    Statistics_MonthView_up_action_3: "Review and record key monthly metrics.",
    Statistics_MonthView_up_urgency: "Medium",

    Statistics_MonthView_neutral_title: "Monthly Views Stable 💡Try Format Mix",
    Statistics_MonthView_neutral_summary: "Mixing Reels and Stories can create new traffic channels.",
    Statistics_MonthView_neutral_action_1: "Create mixed Reels+Stories content.",
    Statistics_MonthView_neutral_action_2: "Record and compare performance.",
    Statistics_MonthView_neutral_action_3: "Add video-guiding captions.",
    Statistics_MonthView_neutral_urgency: "Low",

    Statistics_MonthView_down_title: "Monthly Views Down 💡Focus on Reels",
    Statistics_MonthView_down_summary: "Short Reels with catchy covers are the fastest way to regain views.",
    Statistics_MonthView_down_action_1: "Create 15–30 second Reels.",
    Statistics_MonthView_down_action_2: "Design attractive covers.",
    Statistics_MonthView_down_action_3: "Run timing tests.",
    Statistics_MonthView_down_urgency: "High",

    Statistics_MonthView_zero_title: "Monthly Views Zero 💡Check Technical Issues First",
    Statistics_MonthView_zero_summary:
      "Data or publishing might have issues; check tech first, then start a 14-day plan.",
    Statistics_MonthView_zero_action_1: "Check video data technically.",
    Statistics_MonthView_zero_action_2: "Run a 14-day content production plan.",
    Statistics_MonthView_zero_action_3: "Monitor results daily.",
    Statistics_MonthView_zero_urgency: "High",
    Statistics_RePosts_up_title: "Reposts Are Increasing 💡 Use It",
    Statistics_RePosts_up_summary: "Your audience is sharing your posts; this means your content is worth spreading.",
    Statistics_RePosts_up_action_1: 'Add a clear reason to repost in the caption ("Send this to a friend").',
    Statistics_RePosts_up_action_2: "Design shareable educational series.",
    Statistics_RePosts_up_action_3: "Analyze repost feedback and find patterns.",
    Statistics_RePosts_up_urgency: "Medium",
    Statistics_RePosts_neutral_title: "Reposts Are Low or Stable 💡 You Just Need a Simple Trigger",
    Statistics_RePosts_neutral_summary: "Sometimes a short CTA is enough to increase reposts.",
    Statistics_RePosts_neutral_action_1: "Add a very short repost CTA at the end of the Post.",
    Statistics_RePosts_neutral_action_2: "Create more saveable and shareable content.",
    Statistics_RePosts_neutral_action_3: 'Run a test format like "Send this to a friend".',
    Statistics_RePosts_neutral_urgency: "Low",
    Statistics_RePosts_down_title: "Reposts Have Dropped 💡 You Need More Practical Content",
    Statistics_RePosts_down_summary:
      "Your content is less shareable; you need to create something people want to send to others.",
    Statistics_RePosts_down_action_1: "Design a checklist or step-by-step content.",
    Statistics_RePosts_down_action_2: "Publish short and concise tutorials.",
    Statistics_RePosts_down_action_3: "Add a clear CTA for repost.",
    Statistics_RePosts_down_urgency: "High",
    Statistics_RePosts_zero_title: "No Reposts Recorded 💡 You Need to Create a Starting Point",
    Statistics_RePosts_zero_summary:
      "Either there is no data or the content isn’t repostable; quickly design a distribution plan.",
    Statistics_RePosts_zero_action_1: "Create several 5-point or checklist-style contents.",
    Statistics_RePosts_zero_action_2: "Run a small boost to get the first signal.",
    Statistics_RePosts_zero_action_3: "Write a clear reason for repost in the caption.",
    Statistics_RePosts_zero_urgency: "High",

    // statistics suggestions box
    // 4️⃣ Page -> tools
    pageTools_hashtags: "Hashtags",
    pageTools_MyList: "Hashtags List",
    pageTools_CreateNewListexplain: "Create # list & use for creating posts",
    Analyzer: "Analyzer (AI)",
    pageTools_CreateNewList: "Create New List",
    pageTools_CustomFont: "Custom Font",
    pageTools_CustomFontExplain: "Use custom font for your posts and instagram support it !",
    pageToolspopup_CreateNewListexplain:
      "Press <Enter> or <Space> to create a new hashtag. Click on any hashtag to remove it.",
    pageToolspopup_Listname: "List Name",
    pageToolspopup_hashtags: "Hashtags",
    pageToolspopup_typehere: "Type Here",
    pageTools_hashtagList: "Hashtag List",
    pageTools_CreateNewListpic: "New picture Analyzer",
    pageTools_CreateNewListpicexplain: "Generate hashtags related to image",
    pageTools_CreateNewListpage: "New page Analyzer",
    pageTools_CreateNewListpageexplain: "Generating hashtags related to instagram page URL",
    pageToolspopup_pageURL: "instagram ID",
    pageToolspopup_HideLikeandViewCounts: "Hide Like & View Counts",
    pageToolspopup_TurnoffCommenting: "Turn off Commenting",
    pageToolspopup_TurnoffCommentingExplain: "Commenting on this Post will be disabled",
    pageToolspopup_TurnoffCommentingexplainforlottery:
      "Commenting on this Post will be disabled while the Lottery is being held",
    pageToolspopup_TopHashtag: "Top Hashtag",
    pageToolspopup_TopHashtagexplain: "This is how many times you've used this hashtag on the page.",
    pageToolspopup_allRepliedcomments: "All Replied Comments",
    noresult: "No Result",
    viewreplies: "View Replies",
    allRepliedcomments: "All Replied Comments",
    Followers: "Followers",
    NonFollowers: "Non Followers",
    pageToolspopup_ViewersLikes: "Viewers & Likes",
    supportedformat: "Supported Format",
    limitsize: "Limit Size",
    TagMention: "Tag & Mention",
    cover: "Cover",
    Pleaseselect: "Please select",
    replace: "Replace",
    Album: "Album",
    SavedHashtagList: "Saved Hashtag List",
    SavedHashtagListexplain: "Select Hashtag for add to End of caption",
    FirstComment: "First Comment",
    PinFirstComment: "Pin First Comment",
    areyousure: "Are you sure !?",
    shouldFollower: "The user must follow the page",
    draftexplain: "You are attempting to save as draft",
    deletedraftexplain: "You are attempting to delete draft",
    deleteorderexplain: "You are trying to delete an order",

    Addpeopleexplain: "*After tagging people, Adjust Tag or Double Click to remove",
    AdvanceSettings: "Advance Settings",
    sharepreviewtofeed: "Share Preview to Feed",
    Videocopyrightbypass: "Video copyright bypass",
    SetScheduledPost: "Schedule Post",
    SetScheduledPostexplain: "This post will be published at the specified time",
    SetScheduledStoryexplain: "This story will be published at the specified time",
    addtoproduct: "Add to Products",
    addtoproductexplain: "This post will be added as a product to your product list",
    TurnoffCommentingexplain: "Commenting on this post will be disabled",
    RecommendedDateTime: "Recommended Date & Time",
    RecommendedDateTimeexplain: "These times are based on your page analysis",
    publish: "Publish",
    pageTools_global: "Global",
    pageTools_FA_AR: "Farsi / Arabic",
    pageTools_Overall: "Overall",
    pageTools_year: "Year",
    pageTools_Month: "Month",
    pageTools_Week: "Week",
    pageTools_Day: "Day",
    pageTools_hashtag: "Hashtag",
    pageTools_USED: "Used",
    pageTools_SearchedHashtag: "Searched Hashtag",
    pageTools_TrendHashtags: "Trend Hashtags",
    pageTools_AutoInterAction: "Auto Interaction with Followers",
    pageTools_AcceptPendingRequests: "Accept Follow Requests",
    pageTools_LikeAllNewComments: "Like New Comments",
    pageTools_LikeNewFollowersPosts: "Like Latest Posts of New Followers",
    pageTools_RemoveAllFollowings: "Remove All Followings",
    pageTools_WinnerPicker: "Lottery (Winner Picker)",
    pageTools_DayEvents: "Day Events",
    pageTools_EventDateRange: "Date Range",
    pageTools_EventLanguage: "Language",
    pageTools_EventSelectDate: "Select Date Range",
    pageTools_EventSearch: "Search Events",
    pageTools_EventEmpty: "No events found for the selected range",
    pageTools_EventReligious: "Religious",
    pageTools_EventIdeas: "Event Ideas",
    pageTools_IdeaCreate: "Generate Event Ideas",
    pageTools_IdeaExplain: "Get AI-powered content ideas based on upcoming events and occasions",
    pageTools_CreateEventIdea: "Generate Event Ideas",
    pageTools_CreateEventIdeaPrompt: "Topic / Prompt",
    pageTools_CreateEventIdeaPromptPlaceholder: "e.g. shoes, fitness, travel... (leave empty for all topics)",
    pageTools_CreateEventIdeaOptional: "optional",
    pageTools_CreateEventIdeaSubmit: "Generate",
    pageTools_CreateEventIdeaCancel: "Cancel",
    pageTools_EventIdeasLanguage: "Language",
    pageTools_EventIdeasFetch: "Load Ideas",
    pageTools_EventIdeasEmpty: "No event ideas found",
    pageTools_EventIdeasLoadMore: "Load More",
    pageTools_EventIdeasIdea: "Idea",
    pageTools_EventIdeasCountry: "Country",
    pageTools_EventIdeasPrompt: "Topic",
    pageTools_EventIdeasCreatedTime: "Created At",
    pageTools_CustomEvent: "Custom Event",
    pageTools_exportcomments: "All comments are exported as an Excel file and can be downloaded and shared",

    pageTools_Lottery: "Create a Score Lottery",
    pageTools_emptylotteryList: "You have not created any Lottery yet",

    pageTools_LotteryExplain: "Based on user scores in a post",
    pageTools_fromFollowers: "From Followers",
    pageTools_FromFollowersExplain: "Randomly from all followers",
    pageTools_Result: "Result",
    pageTools_ResultExplain: "Status of previous lottery",
    pageTools_popup_detail: "Detail",
    pageTools_popup_history: "History",
    pageTools_LikeAllNewCommentsExplain:
      "When one of your followers leaves a comment on any post, it will automatically be liked.",
    pageTools_AcceptType: "Activation type",
    pageTools_popup_AlwaysActive: "Always Active",
    pageTools_popup_JustOnce: "Just Once",
    pageTools_AcceptPendingRequestsexplain: "Accept automatically all follow requests from individuals.",
    pageTools_onlyprivate: "*Only work with private page.",
    pageTools_MaxLike: "Number of posts that will be liked",
    pageTools_Reacceptfollower: "Re-follow After Unfollow",
    pageTools_Reacceptfollowerexplain:
      "If someone has previously followed and then unfollows and requests to follow again, the system will accept.",
    waitday: "Waiting Time",
    waitdayexplain:
      "If a person is followed by you or the system, they will be removed after the specified waiting period.",
    waitdayexplain2:
      "The waiting number is in terms of days. If this number is 0, the action will be executed instantly.",
    pageTools_LikeNewFollowersPostsexplain:
      "When someone new follows you, their latest post will be automatically liked.",
    pageTools_RemoveAllFollowingsexplain: "This option automatically removes all your followings from the page.",
    pageTools_progress: "This process may take up to several days, depending on the number of your followers.",
    pageTools_JustUnfollowwho: "Just Unfollow who has not follow me Back",
    pageTools_AllmyFollowings: "All my Followings",
    pageTools_pageanAnalyzer: "Page Analyzer",
    pageTools_pictureanAnalyzer: "Picture Analyzer",
    pageTools_StartAnalysis: "Start Analyze",
    pageLottery_Step: "Step",
    pageLottery_Specifications: "Specifications",
    pageLottery_SelectaPost: "Select a Post",
    pageLottery_SetDateTime: "Set Date & Time",
    pageLottery_WinnersTasks: "Winners Tasks",
    pageLottery_WinnersTasksexplain: "The tasks that each of the participants must complete to enter the lottery.",
    pageLottery_NumberofWinners: "Number of Winners",
    pageLottery_SetScoreForLottery: "Mention People",
    pageLottery_SetScoreForLotteryexplain: "Users must mention others to participate in the Lottery",

    pageLottery_MinimumMention: "Minimum Mention",
    pageLottery_MinimumMentionexplain: "The count of people must be mentioned",
    pageLottery_FollowedPage: "Followed Page",
    pageLottery_FollowedPageexplain: "People must Follow your page and/or pages you choose to enter the giveaway",
    pageLottery_FollowmyPage: "Follow my Page",
    pageLottery_FollowalternativePages: "Follow alternative Pages",
    pageLottery_Termsconditions: "Terms & conditions",
    pageLottery_publishTermsconditions: "Publish Terms & conditions",
    pageLottery_previewTermsconditionsexplain: "This story will be shown as a story to the participants.",
    pageLottery_Termsconditionsbanner: "Terms & conditions banner",
    pageLottery_Termsconditionsbannerexplain:
      "Choose a banner to announce terms and conditions of winner picker to your followers",
    pageLottery_model: "Model",
    pageLottery_Solid: "Solid",
    pageLottery_Radial: "Radial",
    pageLottery_Linear: "Linear",
    pageLottery_Background: "Background",
    pageLottery_Color: "Color",
    pageLottery_Position: "Position",
    pageLottery_Degree: "Degree",
    pageLottery_TextBox: "Text Box",
    pageLottery_Opacity: "Opacity",
    pageLottery_Blur: "Blur",
    pageLottery_Font: "Font",
    pageLottery_Winnerannouncement: "Winner announcement",
    pageLottery_participants1: "🎉 from 999,999 participants 🎉",
    pageLottery_participants2: "🥳 here are the lucky ones: 🥳",
    pageLottery_participantsexplain:
      "*The system automatically adjusts the number of participants and the number of winners and assigns their IDs after each @ character.",
    pageLottery_Addtocaption: "Add to caption after Lottery done",
    pageLottery_Publishasstory: "Publish winner list as story",
    pageLottery_deleteexplain: "It will permanently delete the Lottery, and it cannot be undone.",
    pageLottery_Winnerpickersstatus: "Lottery status",
    pageLottery_scoreLotteryWinners: "Lottery Winners",
    pageLottery_NoWinners: "No winners found",
    pageLottery_RandomFollowersWinners: "Random Followers Winners",
    pageLottery_specifickeywordexplain:
      "Users must include a specific keyword in their Comment to participate in the Lottery",
    pageLottery_FollowmyPageexplain: "Users must Follow the page to be entered into the Lottery",

    pageLottery_ShareRemainingTime: "Share Remaining Time",
    ShareTermsAndCondition: "Share Terms & Condition",
    pageLottery_LotteryRemainingTime: "Lottery Remaining Time",
    pageLottery_Winnerpickerisrunning: "Lottery is running",
    pageLottery_ViewandEditDetails: "View & Edit Details",
    pageLottery_ActiveWinnerpickers: "Active Lottery",
    pageTools_WinnerPickertooltip24hour: "The lottery can be held once every 24 hours",
    specifickeywordstooltip: "The system automatically detects emojis and Persian, Arabic, and English numbers",
    pageLottery_FilterKeywords: "The system randomly selects and displays comments containing your specified keyword",
    pageLottery_NumberofWinnersexplain: "Specify the number of lottery winners. The maximum number of winners is 100",
    pageLottery_permanentlinktooltip: "This link is permanent, but it will be deleted when a new lottery is drawn",
    pageLottery_permanentlinkexplain:
      "You can share this link with users to verify the integrity and authenticity of the lottery",
    pageTools_randomly: "Randomly",
    pageTools_BestEngagement: "Best Engagement",
    pageTools_BestEngagementexplain: "Select from followers who had the most likes and comments",
    // #endregion page Section
    // // #region 3️⃣ Message Section
    message_youareattemptingto: "You are attempting to",
    message_blockexplain:
      "They won't be able to find your profile, posts, or story on Instagram. Instagram won't let them know you blocked them.",
    message_deleteexplain: "It will permanently delete the chat, and it cannot be undone.",
    message_block: "Block",
    notactivemessage: "This chat has been temporarily deactivated. Please send your response via the Instagram app.",
    notactivemessageexplain:
      "Please note that if no response is sent within 24 hours, the chat will become inaccessible. To reactivate, you can either reply via the Instagram app or wait for the other party to send you a new message.",
    waitingforconnection: "Waiting for connection...",
    message_unblock: "Unblock",
    messagesetting_goodbye: "Goodbye",
    messagesetting_welcome: "Welcome",
    messagesetting_welcomingmessage: "welcoming message",
    messagesetting_Activewelcomemessageexplain:
      "This message will be sent in Instagram Direct as a <Greetings message> to people who follow you.",
    messagesetting_Sentmessages: "Sent message",
    message: "message",
    receivedmessage: "The received message",
    Messageresponse: "Message response",
    receivedcomment: "Received Comment",
    commentresponse: "Comment Response",
    Likethereceivedcomment: "Like the received comment",
    unreadmessage: "Unread Messages",
    specifickeywords: "specific keyword",
    unreadcomment: "Unread Comments",
    hiddencommenttooltip: "This comment has been hidden from view. Only admins can see hidden comments.",
    vanishmode: "Hidden Mode",
    vanishmodeexplain:
      "In Hidden Mode, messages that have not been answered and have not been ignored or hidden will be shown.",
    totalcomments: "Total Comments",
    unansweredcomments: "Unanswered Comments",
    totalcommenters: "Total Commenters",
    commentmanagement: "Welcome to Comment Management",
    ticketmanagement: "Welcome to the Customer Ticket Management Section",
    flowmanagement: "Create a Flow and make your Instagram replies smart and automatic",

    QuickReplyexplain: "All received comments are automatically replied to.",
    autocommentReply: "Auto Comment Reply",
    Sendresponseifthepageisfollowed: "Send response if the page is followed",
    Likethereceivedmessage: "Like the received message",
    messagesetting_Activewelcomingmessage: "Greetings message",
    messagesetting_welcometext:
      "Hello! 🌟\nWelcome to our world! 🎉 We are so happy that you've joined our community of followers. We're sure that together we'll have amazing moments. 🤗\n\nWe hope that the content of this page will be interesting and useful for you, and that you'll stay with us. If you have any questions or suggestions, we would be more than happy to assist you. 😊\n\nThank you for choosing our page and being with us. We can't wait to join you in our amazing world.✨\n\nWith respect and appreciation 💫",
    messagesetting_goodbyetext:
      "Hello! 👋\nWe're sorry to see that you've left our page. 😢 We value each and every one of our followers, and your feedback and suggestions are very important to us.\n \nIf there was a specific reason for this decision, we would be happy if you shared it with us. We're ready to listen to your thoughts and suggestions so we can improve and provide a better experience for our followers. 🫡\n\nIn any case, we wish you all the best and hope you'll join us again in the future. 💫",
    messagesetting_ActiveFarewellmessage: "Farewell message",
    messagesetting_ActiveFarewellmessageexplain:
      "This message will be sent in Instagram Direct as a <Farewell message> to people who Unfollow you.",
    messagesetting_businessmessagefilter: "Business Message Filter",
    messagesetting_businessmessagefiltering: "Business Messages Filtering",
    messagesetting_businessmessagefilteringexplain:
      "The desired chat will be automatically sent to the <Bussiness messages> section in Direct Tab",
    messagesetting_specificwords: "custom words",
    messagesetting_autofiltering: "automatic filtering (AI)",
    messagesetting_specificwordsexplain: "You can have multiple Words, Separate each Word with <Enter> character.",
    messagesetting_Createanewsupportticket: "Create a Support Ticket",
    messagesetting_CreateanewsupportticketExplain:
      "Users can use this option to create a support ticket in their Direct. You can also respond to it via the Brancy panel or directly in Direct.",
    messagesetting_Changeapplicationlanguage: "Change Direct Language Options",
    messagesetting_ChangeapplicationlanguageExplain:
      "By enabling this option, users can view all Direct features in seven languages (English, Persian, Arabic, French, Russian, Turkish, and German). The system will intelligently handle the necessary translations.",
    messagesetting_ViewStoreandproducts: "View Store Products",
    messagesetting_ViewStoreandproductsExplain:
      "With this option, users can view your product catalog as a list or album, along with details such as stock, price, and other specifications.",
    messagesetting_Visityourwebsite: "Visit Website",
    messagesetting_VisityourwebsiteExplain:
      "Users can use this option to see your website address and a summary of it, and if needed, directly visit the site. (The loading speed of this page will be very fast.)",
    messagesetting_Viewuserrolesandpermissions: "Business Rules & Regulations",
    messagesetting_ViewuserrolesandpermissionsExplain:
      "By enabling this option, users can view the rules, regulations, and restrictions of your business as defined in the Brancy settings.",
    messagesetting_Viewbusinesshourschart: "Business Hours",
    messagesetting_ViewbusinesshourschartExplain:
      "Users can use this option to check your business hours. This feature helps reduce messages sent outside of working hours.",
    messagesetting_Viewpricinginformation: "Advertising Service Pricing",
    messagesetting_ViewpricinginformationExplain:
      "By enabling this option, users can view up-to-date prices for each of your advertising services. This feature helps reduce repetitive inquiries.",
    messagesetting_Searchforproducts: "Search for Products",
    messagesetting_SearchforproductsExplain:
      "Users can send the product name, post number, or part of a caption to receive full product details and, if interested, make a direct purchase. This feature positively impacts sales growth.",
    messagesetting_addautomaticreplysystemsystem: "A Unified System Reply for All Sections of the Page",
    messagesetting_HideRobotReply: "Hide Automated and Bot Messages",
    messagesetting_HideRobotReplyExplain:
      "Automated bot messages are hidden, and only real messages are displayed in Direct",
    messagesetting_LikeRobotReply: "Auto Like Story Comments",
    messagesetting_HideRobotReplytooltip:
      "Messages are not deleted; they are only hidden to make Direct management easier",
    messagesetting_LikeRobotReplyExplain:
      "Story comments are automatically liked to increase engagement and respond faster",
    messagesetting_automaticreplysystem: "Automatic Reply Control",
    messagesetting_automaticreplysystemforallpost: "Enable or disable automatic comment replies for all posts",
    messagesetting_automaticreplysystemforallposttooltip:
      "If you have configured automatic comment replies for different posts, you can enable or disable them all at once with this option. To configure replies, you must visit each post's page individually",

    messagesetting_messagePanellanguage: "Default Direct Language",
    messagesetting_messagePanellanguageExplain: "The default language of the direct bot for replying to messages.",
    messagesetting_AutoReplyPerFollow: "Custom FollowUp Template",
    messagesetting_AutoReplyPerFollowExplain: "Use this template when asking a user to follow the page.",
    messagesetting_AutoReplyPerFollowtooltip:
      "Users who do not follow you will first receive a follow request. After following your page, the automatic message will be sent to them",
    messagesetting_AutoReplyPerFollowtitle: "Message Text",
    messagesetting_AutoReplyPerFollowtitlesample: "Example: Follow our page first to receive the message",
    messagesetting_AutoReplyPerFollowbtn: "Button Text",
    messagesetting_AutoReplyPerFollowbtnsample: "Example: I Followed, Send the Message",
    messagesetting_automaticreplysystemexplain:
      "The system automatically responds with a preset message whenever a message or comment is received in any section of the page (Feed, Story, Reels, Live, etc.).",
    messagesetting_KeywordSensitive: "Keyword Sensitive",
    messagesetting_KeywordsSensitive: "Keywords Sensitive",
    sendreplydirectedsuccessfully: "Confirmation message sent in the comment after Direct",

    autoReplyFor: "Auto-reply In",
    messagesetting_selectedwords: "Selected Items",
    autocommentReplyExplain: "The system automatically replies to received comments and messages.",
    selectnewmessage: "To send a reply, please select a message.",
    sendreplyticket: "Send Replies",
    emptyticketdirect: "No tickets received from your page’s Direct messages",
    emptysystemticket: "No tickets received from Brancy system customers",
    emptycomment: "No comments to display yet",
    emptydirect: "No Direct messages to display yet",
    respondToAllComments: "Respond to All Comments",
    sensitiveToSpecificKeywords: "Sensitive to Specific Keywords",
    sensitiveToSpecificKeywordsExplain:
      "If these keywords appear anywhere in the comment text, the system automatically replies to that comment",
    contain: "Contain",
    containExplain:
      "When enabled, a reply is sent if the comment contains the keyword. When disabled, a reply is sent only when the entire comment matches the keyword.",
    replyMethod: "Reply Method",
    respondInSameComment: "Respond in the Same Comment",
    respondDirectly: "Respond via Direct",
    ticketID: "Ticket ID",
    Ticketclosedby: "Ticket closed by",
    noNewAnsweredTickets: "You have no newly answered tickets",
    noNewPendingTickets: "You have no new pending tickets",
    noNewClosedTickets: "You have no closed tickets",

    waitingforuserresponse: "Waiting for user response",
    inactiveticketexpired: "This ticket has been deactivated due to inactivity in the past 24 hours.",
    automaticreply: "Automatic Reply",
    autodirectexplain:
      "When a specific keyword is received in Direct, your predefined response will be automatically sent in Direct",
    adddirectexplain: "Add direct automatic replies",
    autocommentexplain:
      "When a specific keyword is received in a comment, your predefined response will be automatically sent in the same comment",
    addcommentexplain: "Add comment automatic replies",
    messagesetting_icebreaker: "Quick chat start button",
    messagesetting_addNewButton: "Add New Button",
    messagesetting_icebreakerexplain:
      "When the user enters Direct for the first time, four buttons are displayed, and selecting each one sends the corresponding response.",
    messagesetting_addicebreakerexplain: "Add up to 4 quick chat start buttons",
    messagesetting_PersistentMenu: "Persistent Direct Menu",
    messagesetting_PersistentMenuexplain:
      "A menu that is always available, making customer interaction with your brand fast, easy, and without the need for typing.",
    messagesetting_addPersistentMenuexplain: "Add up to 3 persistent menu buttons",
    Welcometodirectmessages: "Welcome to Instagram Direct Messages!",
    messagesetting_UseSystemButtonsExplain:
      "Use ready-made system buttons to provide standard information such as View Shop, Support Ticket, and Language Change",
    messagesetting_UseAIPromptsExplain:
      "Use AI prompts to deliver smart and personalized replies to users with your own tone and interaction style",
    messagesetting_ButtonTitle: "Button Title",
    messagesetting_NoPromptsFound: "No prompts found. You will be redirected to the create page to build a new prompt.",
    messagesetting_CreateNewPrompt: "Create New Prompt",
    messagesetting_SelectYourPrompt: "Select Your Prompt",
    messagesetting_DefineCustomResponseExplain:
      "Define your custom reply text so it will be automatically sent to users",
    messagesetting_SpecifyProductResponseExplain: "Specify a product to be automatically sent to users",
    messagesetting_ProductResponseExplain: "Connect the current product to the user",
    ConnectProduct: "Direct Product Connection",
    messagesetting_ConnectProductResponseExplain: "Connect your product to the story or live ",
    messagesetting_SelectPredefinedFlowExplain:
      "Select a predefined flow to start an automated and smart conversation with the user",
    messagesetting_NoFlowsFound: "No flows found. You will be redirected to the create page to build a new flow.",
    messagesetting_CreateNewFlow: "Create New Flow",
    messagesetting_SelectFlow: "Select Flow",
    messagesetting_ViewFlow: "View Flow",
    messagesetting_UseGeneralAIExplain: "Use general AI for open and unrestricted interaction with users",
    tool_token_usage_guide: "Approximate token usage when running this tool",
    tool_how_use: "How to use the tool",
    tool_how_work: "How the tool works",
    send_sms_ir_code_description: "Send SMS to the user's mobile via SMS.ir platform",
    send_sms_ir_code_completeDescription:
      "This tool is used to send SMS messages to users, such as verification codes, registration, or notifications. It allows you to receive users’ mobile numbers and use them in your SMS service.",
    send_sms_ir_code_howUse: `1- Get your ApiKey from SMS.ir platform and enter it.
2- Enter your SMS template in TemplateId field.
3- Wherever {CODE} appears in the template, the system will automatically replace it with a one-time OTP code.
`,
    send_sms_ir_code_howWork: `1- The user sends their mobile number in Direct.
2- SMS is sent to the user's mobile. If the message contains {CODE}, the system automatically replaces it with a one-time OTP code.
3- The user sends the code back to the AI.
4- The AI verifies the code and confirms the mobile number.
`,

    send_to_telegram_description: "Send message to Telegram via bot",
    send_to_telegram_completeDescription:
      "This tool is used to send messages to Telegram using a Telegram bot. Messages are sent via Bot Token to a specific channel or chat and are useful for notifications, alerts, and data delivery.",
    send_to_telegram_howUse:
      "1- Enter your Telegram bot Token.\n2- Enter chat ID or channel ID.\n3- Run the tool to send the message.",
    send_to_telegram_howWork:
      "1- User enters Token and Channel.\n2- System prepares request using Telegram Bot API.\n3- Message is sent to the specified chat or channel via bot.",

    sender_username_description: "Use sender username in prompt",
    sender_username_completeDescription:
      "This tool allows you to use the sender's username inside your AI prompts. By adding {SENDER_USERNAME}, the system automatically replaces it with the username of the message sender.",
    sender_username_howUse:
      "1- Insert {SENDER_USERNAME} anywhere in your prompt where you want the sender username to appear.\n2- During execution, the system replaces it with the actual username and uses it in AI responses.",
    sender_username_howWork:
      "1- User places {SENDER_USERNAME} in prompt.\n2- System detects and replaces it with sender username during processing.\n3- AI generates responses using the sender’s username.",
    // #endregion Message Section
    // #region 5️⃣market Section
    // 5️⃣ Market -> home
    filter_most_expensive: "Most Expensive",
    filter_cheapest: "Cheapest",
    filter_newest: "Newest",
    filter_highest_discount: "Highest Discount",
    filter_all_products: "All Products",
    filter_only_available: "Only Available Items",
    filter_reset: "Reset",
    filter_sortby: "Sort by",
    filter_category: "Category",
    filter_price: "Price",
    Pricerange: "Price Range",
    from: "From",
    to: "To",
    filter_rating: "Rating",
    filter_followers: "followers",

    default: "Default",
    lowtohigh: "Low to High",
    hightolow: "High to Low",
    biolinkHomerating: "Rate",
    biolinkHomefollower: "Follower",
    biolinkHomepost: "Post",
    biolinkHomeAllMarkets: "All",
    biolinkHomeAdvertise: "Advertiser",
    biolinkHomeStore: "Store",
    // 5️⃣ Market -> statistics
    biolinkStatisticsAllLinkclicks: "All Link clicks",
    biolinkStatisticsMarketviews: "Market views",
    biolinkStatisticsmostview: "most view",
    biolinkStatisticscouponcodeused: "coupon code used",
    biolinkStatisticslastupdate: "last update",
    biolinkStatisticsAllsearches: "All searches",
    biolinkStatisticsfeatures: "features",
    biolinkStatisticsVisits: "Visits",
    biolinkStatisticsClicksAndInteractions: "Clicks and interactions",
    biolinkStatisticsVisitsConverted: "Visits converted to clicks",
    biolinkStatisticsQuickUserExitAfterEntry: "Quick user exit after entry",
    biolinkStatisticsNoInteractionExit: "Exit without interaction",
    biolinkStatisticsMaxClicksPerVisit: "Most clicks by one user in a single visit",
    biolinkStatisticsAvgClicksAndInteractionsPerVisitor: "Average clicks and interactions per visitor",
    biolinkStatisticsTotalVisitTime: "Total visit time",
    biolinkStatisticsAvgVisitTime: "Average visitor stay time",
    biolinkStatisticsVideoPlatformsComparison: "Video platform comparison",
    biolinkStatisticsYoutube: "YouTube",
    biolinkStatisticsAparat: "Aparat",
    biolinkStatisticsTwitch: "Twitch",
    biolinkStatisticsPlatformEntry: "Platform entry",
    biolinkStatisticsRedirectEvent: "Redirect event",
    biolinkStatisticsPlayVideo: "Video playback",
    biolinkStatisticsPlayEvent: "Playback event",
    biolinkStatisticsUniqueVisit: "Unique visit",
    biolinkStatisticsDedicatedLinkVisits: "Dedicated link visits",
    biolinkStatisticsCombinedLinkVisits: "Combined link visits",
    // 5️⃣ Market -> Properties
    biolinkPropertiesfeatures: "Features",
    biolinkPropertiesProfileInfoBanner: "Profile Info & Banner",
    biolinkPropertiesFeaturebox: "Feature Box",
    biolinkPropertiesTermsAndActiveTime: "Terms & Business Hours",
    biolinkPropertiesFeatureboxexplain:
      "By enabling each feature, you can display important information to visitors of your link page",
    biolinkPropertiesBanner: "Banner",
    biolinkPropertiesFeaturesBox: "Features Box",
    biolinkPropertiesReviews: "Reviews",
    biolinkPropertiesAnnouncements: "Announcements",
    biolinkPropertiesAnnouncementsexplain:
      "You can write descriptions in this section to inform visitors of your link page about important information",

    biolinkPropertiesOnlineStream: "Online Stream",
    biolinkPropertiesOnlineStreamexplain:
      "By enabling this option, whenever you start a live stream on your channel, it will automatically be displayed on your dedicated link",

    biolinkPropertiesLastVideo: "Last Video",
    biolinkPropertiesLastVideoexplain:
      "By enabling this option, whenever you publish a new video on your channel, the latest video will automatically be displayed on your dedicated link and will always stay updated",

    biolinkPropertiesProducts: "Products",
    biolinkPropertiesProduct: "Product",
    biolinkProperties_showLast10Products: "Show last 10 products",
    biolinkProperties_showBestSellingProducts: "Show best-selling products",
    biolinkPropertiesAdsTimeline: "Ads Timeline",
    biolinkPropertiesQandABox: "Q and A Box",
    biolinkPropertiesLinkShortcut: "Link Shortcut",
    biolinkPropertiesContactAndMap: "Contact and Map",
    biolinkPropertieslinks: "Links",
    clickonstreamvideo: "Click on the video to watch the live stream",
    livestarted: "Live Broadcast is Running",
    live: "Live",
    biolinkPropertiesaddnew: "Add New Link",
    biolinkProperties_DomainManager: "Domain Management",
    biolinkProperties_DomainManagerexplain: "Your dedicated website",
    biolinkProperties_DomainManagerexplain2: "You can put this link in your Instagram Bio or share it with other users",

    biolinkProperties_explain: "When the Instagram username is changed, this link will automatically update.",
    biolinkProperties_rejected: "Your domain has been rejected (please contact with us)",
    customDomain_inactive_title: "Custom domain is inactive",
    customDomain_inactive_desc:
      "Your domain is currently inactive. Please submit a support ticket to get it activated.",
    customDomain_noPackage_title: "Custom domain package not found",
    customDomain_noPackage_desc:
      "Your current package does not include custom domain support. Please upgrade your package to use this feature.",

    customDomain_rule_validChars: "Only letters and numbers are allowed",
    customDomain_rule_noUnderscore: "The (_) and (-) characters are not allowed",
    customDomain_rule_noSubdomain: "Subdomains are not allowed",
    biolinkProperties_Request: "Request",
    biolinkProperties_Connect: "Connect",
    biolinkProperties_Requested: "Requested",
    biolinkProperties_Checking: "Checking",
    biolinkProperties_yourstore: "Store (your store link)",
    biolinkProperties_yourads: "Advertise Order Link",
    biolinkProperties_yourlottery: "Your completed lotteries",
    biolinkProperties_yourtariff: "Tariff (your price chart)",
    biolinkProperties_yourBusinesshours: "Your Active Business Hours",
    biolinkProperties_yourBusinessTerms: "Your Business Terms",
    biolinkProperties_defaultAddress: "Default Domain Address",
    biolinkProperties_CustomAddress: "Your Custom Domain Address",
    biolinkPropertiespopup_GeneralCustom: "General",
    biolinkPropertiespopup_socialmedia: "Social Media",
    biolinkPropertiespopup_mediastream: "Media & Stream",
    biolinkPropertiespopup_clouddrivecontent: "Cloud Drive Content",
    biolinkPropertiespopup_Finance: "Finance",
    biolinkProperties_followersrate: "Follower Count",
    biolinkProperties_followersrateExplain: "Displays the number of followers of your Instagram page",
    biolinkProperties_successRating: "Success Rating",
    biolinkProperties_successRatingExplain: "Displays your success score in completing orders",
    biolinkProperties_bussinessHours: "Active Business Hours",
    biolinkProperties_bussinessHoursExplain: "Displays your business working hours",
    biolinkProperties_Enamadverified: "E-Namad Verification",
    biolinkProperties_EnamadverifiedExplain: "Displays the verification status of your E-Namad trust badge",
    biolinkProperties_BusinessTerms: "Business Terms",
    biolinkProperties_BusinessTermsExplain: "Displays your business terms and conditions",
    biolinkProperties_tariff: "Tariff",
    biolinkProperties_TariffExplain: "Displays your service pricing and tariffs",
    biolinkProperties_StartADS: "Start Advertising Request",
    biolinkProperties_StartADSExplain: "Users can start their advertising based on your pricing",
    biolinkProperties_StartSALES: "Start Purchase Request",
    biolinkProperties_StartSALESExplain: "Users can start purchasing based on your products",
    biolinkProperties_NameServers: "Domain Name Servers",
    biolinkProperties_NameServersExplain: "Register these name servers in your domain provider's control panel",
    customDomain_dnsError:
      "The domain name servers have not been registered with your domain provider yet. Please try again",
    customDomain_active_desc:
      "To change or remove this domain, submit your request through the Support Ticket section in Settings",
    biolinkProperties_NameServerstooltip:
      "Your request may take up to 12 hours for the name servers to propagate across the Internet and for your domain to become active.",
    linkURL: "link URL",
    searchID: "Add Channel",
    searchIDexplain: "Enter the user ID or channel name you want to add",

    Browse: "Browse",
    biolinkPropertiespopup_yourcustomIcon: "your custom Icon",
    Boldit: "Grab Attention!",

    Scheduletime: "Auto-Remove Schedule time",
    biolinkPropertiespopup_ProfileInfo: "Profile Info",
    biolinkPropertiespopup_Banner: "Banner",
    biolinkPropertiespopup_Personal: "Personal",
    biolinkPropertiespopup_SameasInstagramProfile: "Same as Instagram Profile",
    marketpropertise_aboutus: "This site was created using the Brancy platform",
    marketpropertise_copyright: "All rights to this site belong to",
    marketpropertise_aboutusslogan:
      "Brancy is the best choice for creating a smart Biolink and managing your Instagram page",
    marketpropertise_madeby: "Made with 🤍 by",

    custom: "Custom",
    advertiseProperties_biography: "Biography",
    uploadbannerexplain: "Uploading multiple images can affect the loading speed.",
    Embed: "Embed video",
    Embedexplain:
      "By enabling this option, the video will be displayed and played directly on your dedicated link, allowing users to watch it without leaving the page or being redirected to another platform",

    notfound: "notfound",
    showsavecontactbutton: "show save contact button",
    Map: "Map",
    Contact: "Contact",
    Showmap: "Show map",
    location: "Location",
    phone: "Phone",
    invalidphone: "Invalid phone",
    email: "Email",
    invalidemail: "Invalid email",
    Address: "Address",
    // #endregion Market Section
    // #region 6️⃣advertise Section
    advertise_ADDetail: "AD Detail",
    content: "content",
    advertise_orderdate: "order date",
    advertise_duration: "duration",
    Remaining: "Remaining ",
    ago: "ago",
    // advertise -> calendar
    advertisecalendar_calendar: "Calendar",
    advertisecalendar_nextday: "Next Ads For This Day",
    advertisecalendar_Timeline: "Timeline",
    advertisecalendar_TODAY: "TODAY",
    advertisecalendar_BookaTime: "Book a Time",
    advertisecalendar_TIMELINEZOOM: "TIMELINE ZOOM",
    // advertise -> statistics
    advertisestatistics_lasttwomonth: "last two month",
    advertisestatistics_lastmonth: "last month",
    advertisestatistics_thismonth: "this month",
    advertisestatistics_ads: "ad",
    advertisestatistics_fromlast: "% From last month",
    advertisestatistics_totalADSstatistics: "Total Ads Statistics",
    advertisestatistics_TotalAds: "Total Ads",
    advertisestatistics_TotalIncome: "Total Income",
    advertisestatistics_totaladsreport: "Total Ads Report",
    advertisestatistics_adno: "Ad No.",
    advertisestatistics_advertiser: "Advertiser",
    advertisestatistics_type: "Type",
    advertisestatistics_status: "Status",
    advertisestatistics_price: "Price",
    advertisestatistics_date: "Date",
    advertisestatistics_share: "Share",
    // advertise -> adlist
    advertiseadlist_activeAd: "Published Ads",
    advertiseadlist_AwaitingApproval: "Pending Ads",
    advertiseadlist_AwaitingPublication: "Scheduled Ads",
    advertiseadlist_rejectedlist: "Rejected Ads",
    // advertise -> Properties
    advertiseProperties_Concurrentads: "Concurrent Ads",
    advertiseProperties_Concurrentadsexplain: "Number of active ads at a given time",
    advertiseProperties_numberofads: "Number of Ads Pages",
    advertiseProperties_numberofadsexplain: "Number of active ads throughout the day",
    advertiseProperties_campaign: "Campaign",
    advertiseProperties_campaignexplain: "Ability to participate in advertising campaigns by Brancy",
    advertiseProperties_adsoptions: "Ads Options",
    advertiseProperties_rejectreasonheader1: "Reason 1 (Unrelated Content)",
    advertiseProperties_rejectreasonheader2: "Reason 2 (Unhealthy Content)",
    advertiseProperties_rejectreasonheader3: "Reason 3 (Policy Violation)",
    advertiseProperties_rejectreasonheader4: "Reason 4 (Negative Feedback)",
    advertiseProperties_rejectreason1:
      "Unfortunately, the provided content does not align with our page values and goals, is irrelevant to our general audience, or lacks essential information. Therefore, we cannot accept this advertisement.",
    advertiseProperties_rejectreason2:
      "Unfortunately, the provided content may be unhealthy, misleading, or contain complex information for our audience. It requires extensive changes, so we cannot accept this advertisement.",
    advertiseProperties_rejectreason3:
      "Unfortunately, the provided content does not comply with our regulations or Instagram's guidelines and may be deemed unreasonable, offensive, controversial, or criminal. Therefore, we cannot accept this advertisement.",
    advertiseProperties_rejectreason4:
      "Unfortunately, due to the high volume of similar ads, scheduling conflicts, negative user feedback from previous experiences, or low quality of the provided content, we cannot accept this advertisement.",
    advertiseProperties_AdvertisingTerms: "Advertising Terms",
    advertiseProperties_AdvertisingTermsexplain:
      "Advertisers must accept these rules in order to advertise on your page.",
    advertiseProperties_AdvertisingTerm1: "Your page term 1",
    advertiseProperties_AdvertisingTerm2: "Your page term 2",
    advertiseProperties_AdvertisingTerm3: "Your page term 3",
    advertiseProperties_AdvertisingTerm4: "Your page term 4",
    advertiseProperties_AdvertisingTermsave: "Save",
    advertiseProperties_businesshours: "Admin Active Business Hours",
    advertiseProperties_24hours: "24 Hours Active",
    advertiseProperties_close: "Inactive",
    advertiseProperties_notifications: "Notifications",
    advertiseProperties_notificationsSMS: "SMS",
    advertiseProperties_notificationsEmail: "Email",
    advertiseProperties_notificationssystem: "System Notification",
    advertiseProperties_notificationsinstagramdirect: "Instagram Direct",
    advertiseProperties_notificationssystemticket: "Ticket",
    advertiseProperties_advertisetariff: "Advertise Tariff",
    advertiseProperties_onlyToday: "Only for Today",
    advertiseProperties_onlyTodayexplain: "Advertising price tariff only for today",
    advertiseProperties_tariff12hours: "12 Hours",
    advertiseProperties_tariff24hours: "24 Hours",
    advertiseProperties_otherdays: "Basic (Other Days)",
    advertiseProperties_otherdaysexplain: "Advertising price tariff for other days",
    advertiseProperties_Campaign: "Campaign",
    advertiseProperties_Campaignexplain: "Advertising price tariff for Campaign",
    advertiseProperties_lastModified: "Last Modified",
    advertiseProperties_userreport: "User Report",
    advertiseProperties_userID: "User ID",
    advertiseProperties_reportexplain: "Your report will be sent to Brancy support.",
    advertiseProperties_reportsubmit: "Submit",
    Apply: "Apply",
    signinyouradvertise: "Activate Advertising",
    signinyouradvertiseExplain: "Activate your advertising in just a few clicks",

    // #endregion advertise Section
    // #region 7️⃣Store Section
    // Store -> product
    Storeproduct_activatestore: "Activate your store",
    signinyourstore: "Create Your Store",
    signinyourstoreExplain: "Build your store in just a few clicks",
    Storeproduct_needyourID: "Identity Verification",
    Storeproduct_needyourIDExplain: "Upload your ID card",
    Storeproduct_successyourID: "Your identity has been successfully verified",
    Storeproduct_NationalCardexplain:
      "This card must belong to the person who registered with their mobile number on Brancy.",
    Storeproduct_addcreditnumber: "Financial Information",
    Storeproduct_addcreditnumberExplain: "Enter your bank card",
    Storeproduct_successnumber: "Your banking information was successfully verified",
    Storeproduct_shippingmethod: "Shipping Method",
    Storeproduct_shippingmethodExplain: "Select your preferred shipping method",
    Storeproduct_shippingmethodsuccess: "The selected shipping method has been successfully registered",
    Storeproduct_shippingmethodtooltip:
      "Recommended methods have been selected based on your location. You can edit and change them later in store settings.",
    Storeproduct_uploadimagefirst: "Please upload your national ID card photo first",
    Storeproduct_creditcardsameidcard: "The bank card number must belong to the national ID card holder",
    Storeproduct_postalcode: "Business Address",

    Storeproduct_postalcodeExplain: "Enter the postal code",
    Storeproduct_postalcodesuccess: "The address and location have been successfully registered",
    Storeproduct_postalcodeinputExplain:
      "Shipping cost is calculated based on this address, please enter the postal code accurately.",
    Storeproduct_TermsAndCondition: "Terms and Conditions",
    Storeproduct_TermsAndConditionExplain: "Read and accept the terms",
    Storeproduct_TermsAndConditionesuccess: "Terms and conditions accepted successfully",
    Storeproduct_AcceptTermsAndCondition:
      "I have read and accept all the rules and regulations for creating a store in Brancy",
    Storeproduct_notyet: "You haven't added any products yet!",
    Storeproduct_addnow: "ADD PRODUCTS NOW",
    Storeproduct_addexplain: "They will be added from your Instagram Page automatically.",
    Storeproduct_productlist: "Product List",
    Storeproduct_search: "Search 'Product Name' or 'PID'",
    Storeproduct_importproduct: "Import Product",
    Storeproduct_importfrominsta: "Import from Your Instagram",
    Storeproduct_newproduct: "New Product",
    Storeproduct_addnewproduct: "Add a New Product",
    Storeproduct_name: "Product Name",
    Storeproduct_weight: "Weight",
    Storeproduct_size: "Size",
    Storeproduct_color: "Color",
    Storeproduct_stock: "Stock",
    Storeproduct_price: "Price",
    Storeproduct_active: "Active",
    Storeproduct_gram: "Gram",
    bulkProduct: {
      title: "Manage selected products",
      selectedCount: "{{count}} selected products",
      priceChange: "Change price",
      valueType: "Value type",
      amount: "Amount",
      increase: "Increase",
      decrease: "Decrease",
      applyAll: "Apply the same change to all",
      applyIndividual: "Set each product individually",
      allProducts: "Apply to all {{count}} products",
      discountAllHint: "Set one percentage or fixed discount for every selected product.",
      priceAllHint: "Increase or decrease all selected product prices by a percentage or fixed amount.",
      currentDiscount: "Current",
      saving: "Saving...",
    },
    loadingmoreproducts: "Loading more products...",
    noMoreProducts: "No more products found",
    // Store -> order
    storestatistics_lasttwomonth: "Last Two Months",
    storestatistics_lastmonth: "Last Month",
    storestatistics_thismonth: "This Month",
    storestatistics_sales: "Sales",
    storestatistics_fromlast: "% from Last Month",
    storestatistics_totalSalesstatistics: "Overall Sales Statistics",
    storestatistics_TotalSales: "Total Sales",
    storestatistics_TotalIncome: "Total Revenue",
    storestatistics_totalsalesreport: "Top Buyers",
    storestatistics_buyer: "Buyer Information",
    storestatistics_totalPurchases: "Total Purchases",
    storestatistics_totalAmount: "Total Purchase Amount",
    storestatistics_lastPurchase: "Last Purchase Date",
    storestatistics_saleno: "Sale Number",
    storestatistics_seller: "Seller",
    storestatistics_type: "Type",
    storestatistics_status: "Status",
    storestatistics_price: "Price",
    storestatistics_date: "Date",
    storestatistics_share: "Share",
    storestatistics_couponTitle: "Discounts",
    storestatistics_addCoupon: "Add discount code",
    storestatistics_noCoupons: "No discount codes have been created yet.",
    storestatistics_couponCode: "Discount code",
    storestatistics_discountPercent: "Discount percentage",
    storestatistics_maxUses: "Maximum uses",
    storestatistics_phoneNumber: "Phone number",
    storestatistics_maxDiscountOptional: "Maximum discount (optional)",
    storestatistics_couponExpiry: "Expiration time (must be at least 1 hour from now)",
    storestatistics_showInBio: "Show in bio",
    storestatistics_couponDeleted: "Deleted",
    storestatistics_couponExpired: "Expired",
    storestatistics_couponExhausted: "Used up",
    storestatistics_couponActive: "Active",
    storestatistics_unlimited: "Unlimited",
    storestatistics_couponUsage: "{{used}} of {{max}} used",
    storestatistics_discountValue: "{{discount}}% discount",
    storestatistics_maxDiscountValue: "Maximum: {{value}}",
    storestatistics_expiryValue: "Expires: {{date}}",
    storestatistics_private: "Private",
    storestatistics_public: "Public",
    incartcount: "In Cart",
    addtocart: "Add to Cart",
    AllProducts: "All Products",
    Storeproduct_inQueue: "Pending",
    Storeproduct_inprogress: "In Progress",
    Storeproduct_pickingup: "Picking Up",
    Storeproduct_sent: "Sent",
    Storeproduct_delivered: "Delivered",
    Storeproduct_failed: "Failed",
    Storeproduct_canceledbyuser: "Canceled by Buyer",
    Storeproduct_canceledbyadmin: "Canceled by Admin",

    Storeproduct_returned: "Returned",
    Storeproduct_yourcartisempty: "Your Cart Is Empty",
    Storeproduct_noitemfounded: "No Item Found",
    Storeproduct_incart: "In Cart",
    ShowUnprocessedItemsOnly: "Unprocessed Items",
    pageStatistics_fromstore: "From Store",
    ordernumber: "Order Number",
    order_addressSubject: "Home, Workplace",
    order_addressReceiver: "Recipient's name at this address",
    order_addressNote: "Address note",

    Storeorder_all: "All",
    Storeorder_ORDERID: "Order ID",
    Storeorder_CUSTOMER: "Customer",
    Storeorder_ITEMS: "Items",
    Storeorder_ITEM: "Item",
    Storeorder_PRICE: "Price",
    Storeorder_OrderDATE: "Order Date",
    copytrackingcode: "Copy Tracking Code",
    Storeorder_SentDATE: "Sent Date",
    Storeorder_deliverdate: "Deliver Date",
    Storeorder_DELIVERY: "Sent via",
    Storeorder_bymyself: "Sent by Myself",
    Storeorder_Envelope: "Envelope",

    Storeorder_Invoice: "Invoice",
    Storeorder_DeliveryAmount: "Delivery Amount",
    Storeorder_InsuranceAmount: "Insurance Amount",
    Storeorder_Coupon: "Coupon Code",
    Storeorder_RemoveCoupon: "Remove Coupon",
    Storeorder_Productsinyourshoppingcart: "Products in your shopping cart",
    Storeorder_SendtotheAddress: "Send to the Address",
    Storeorder_changeofaddress: "Change of Address",

    Storeorder_postparselbox: "Postal Box",
    Storeorder_pocketenveloptitle: "Number of Items per Envelope",
    Storeorder_pocketenveloptitleExplain:
      "Please specify how many of this product fit into a standard envelope (or your regular packaging), This helps us make more accurate calculations for inventory, packaging, and shipping.",
    Storeorder_Destination: "Destination",
    Storeorder_STATUS: "Status",
    Storeorder_DETAILS: "Details",
    Storeorder_PickupRequest: "Pickup Request",
    Storeorder_PrintWaybill: "Print Waybill",
    Storeorder_Waybill: "Waybill",
    Storeorder_WaybillExplain:
      "Please print the waybill and firmly attach it to the package in a clear and flat manner before submitting the pickup request.",
    Storeorder_noneSendExplain:
      "Since this package could not be sent through Brancy’s delivery system and you have shipped it personally at your own responsibility, you need to confirm this step. By confirming, the buyer will be notified that the package has been sent.",
    Storeorder_ManualTrackingExplain:
      "Since you have delivered the package directly to the shipping company, please enter the tracking code in the relevant field after receiving it and confirm this step. By doing so, Brancy will automatically notify the buyer of the tracking code and shipping information.",
    Storeorder_SendExplain: "This section's information will be updated automatically",

    Storeorder_requestedpickup: "Awaiting Pickup",
    Storeorder_TrackingCode: "Tracking Code",
    Storeorder_PostMan: "Postman",
    Storeorder_from: "Sent from",
    Storeorder_currentLocation: "Current location",
    Storeorder_lastUpdateTime: "Last updated",
    Storeorder_sender: "Sender",

    Storeorder_Pickedup: "Picked up",
    Storeorder_IssuingTrackingCode: "Issuing Tracking Code",
    Storeorder_orderDetailsStep: "Order Information",
    Storeorder_orderconfirmStep: "Package Size and Waybill",
    Storeorder_orderlist: "Order List",
    Storeorder_singleorder: "Order",
    Storeorder_quantityorder: "Quantity",
    Showmore: "Show More",
    totalprice: "Total Price",
    note: "Note",
    navbar_PaymentNumber: "Payment Tracking Code",
    Storeorder_receiver: "Receiver",
    Storeorder_AcceptthisOrder: "Confirm This Order",
    Storeorder_ParselisConfirmed: "I confirm that the entered details are correct",
    Storeorder_ParselisConfirmedExplain: "Incorrect size or weight entry may result in penalties and package return",
    Storeorder_CancelOrder: "Cancel Order",
    Storeorder_nextWaybill: "Continue (Receive Waybill)",
    SelectProduct: "Select Product",
    SelectedPosts: "Selected Posts:",
    product_BasicDetail: "Basic Detail",
    BacktoProductList: "Back to Product List",
    Backtocart: "Back To Cart",
    product_ProductID: "Product ID",
    product_Producttitle: "Product Title",
    product_Product: "Products",
    product_Categories: "Categories",
    product_MainCategory: "Main Category",
    product_Subcategory: "Sub category",
    product_Subset: "Subset",
    product_Group: "Group",
    product_Branch: "Branch",
    product_Subbranch: "Sub branch",
    product_Dependency: "Dependency",
    product_Brand: "Brand",
    product_instagramcaption: "Instagram Caption",
    product_productDescription: "Product Description",
    product_Informationplaceholder:
      "In this section, you can write the product description.\n\n This description can include complete and attractive information such as\n features, benefits, key details about the product, or how to use it, ingredients\n expressed briefly and effectively.\n\n Customers will become more familiar with the product features, and the chances of selling the product will increase.",
    product_General: "General",
    product_Specifications: "Specifications",
    product_Information: "Information",
    product_addNewTable: "Add New Table",
    product_EditTable: "Edit Table",
    product_PreviewTable: "Table",
    product_addtable: "Create Table",
    product_tabletitle: "Table Title (Optional)",
    product_tabletitleExplain: "For example: Size Chart",
    product_tableheaderoption: "First Row as Header",
    product_AddColumn: "Add Column Next to This",
    product_DeleteColumn: "Delete This Column",
    product_AddRow: "Add Row Below This",
    product_DeleteRow: "Delete This Row",
    rowheader: "Header",
    cell: "Cell",
    Nodescriptionavailable: "No description available",
    NoSpecificationsavailable: "No specifications available",
    product_Media: "Media",
    product_Properties: "Properties",
    product_Setting: "Setting",
    product_productdeleted: "Product Deleted",
    product_SetProperties: "Set Properties",
    product_SetPropertiesexplain: "You can select 1-3 properties and one of them can define custom",
    product_AddNewproperty: "Add New Property",
    product_Nopropertyisset: "No property is set",
    product_Variation: "Variation",
    product_Discount: "Discount",
    product_PricewithDiscount: "Price with Discount",
    product_AddNewVariation: "Add New Variation",
    product_Definenew: "Define new (Custom)",
    product_systemlist: "Smart Default List",
    product_itemlist: "Item List",
    product_Available: "Available",
    product_supplying: "Supplying",
    product_OutOfStock: "Out of Stock",
    product_Stoppedsale: "Stopped Sale",
    product_draft: "Draft",
    product_Amount: "Amount",
    product_NUMBEROFUSES: "Number of Usages",
    product_UNLIMITED: "Unlimited",
    product_LIMITED: "Limited",
    product_USINGTIMES: "Usage Duration",
    product_UNLIMITEDTIME: "Unlimited Time",
    permanent: "Permanent",
    product_LIMITEDTIME: "Limited Time",
    product_mediatitle: "Manage Picture and Videos of Product",
    product_clicktoupload: "Click to Upload",
    product_SuggestedImages: "Suggested Images",
    product_SuggestedImagesExplain: "Enhance your product gallery using suggested images or upload your desired images",
    product_ordragdrop: "or Drag and Drop",
    product_productspecifications: "product specifications",
    product_choosesystemlist: "choose from system list",
    product_choosesystemlistexplain: "Search and select any specs you need",
    product_Definenewexplain: "If you can’t find specs create that",
    product_importbatch: "import batch",
    product_importbatchexplain: "Add all specs from previous product",
    Value: "Value",
    Undefined: "Undefined",
    product_original: "Original",
    product_HighCopy: "High Copy",
    product_notoriginal: "Not Original",
    product_Corporate: "Corporate",
    product_Miscellaneous: "Miscellaneous",
    product_fake: "Fake",
    tomorrow: "Tomorrow",
    NotSet: "Not Set",
    Yes: "Yes",
    No: "No",
    "Video generation request sent.": "Video generation request sent.",
    "Image generation request sent.": "Image generation request sent.",
    ", Image generation failed.": ", Image generation failed.",
    "Create and manage AI-generated images and videos.": "Create and manage AI-generated images and videos.",
    Storeproduct_OutOfStandardSize: "Out Of Standard Size",
    product_box: "Box Size",
    Product_Availablity: "Availability",
    Product_maxincart: "Max in Cart",
    Product_originality: "Originality",
    Product_preperingforship: "Preparing for Ship",
    Product_Evat: "Evat",
    Product_Evatcount: "Evat value",
    Product_Guarantee: "Guarantee",
    Product_Guaranteelength: "Guarantee Length",
    Product_packageshipping: "Package & Shipping",
    Product_packageshippingexplain:
      "By disabling this option, product shipping and related services will be your responsibility",
    Product_titleExplain:
      "Suggested titles are provided based on your product's features and the average titles in the market to increase its visibility in searches and similar products. \n(These titles may contain errors)",
    Product_Breakable: "Breakable",
    Product_Luquid: "Luquid",
    Product_sack: "Sack / Bag",
    Product_sackExplain:
      "If your product is shipped in a sack, bag, tote, or other soft and flexible packaging, choose this option. This helps us better manage the layout, transport, and packaging process.",
    Product_Productweights: "Product Weights",
    Product_Productweightsexplian: "Net weight of the product without packaging",
    Product_packaging: "Packaging",
    Product_packagingexplian:
      "The weight of the product packaging without internal contents, including the packaging cardboard, tape, and shipping label, calculated by the system",
    Product_shippingSize: "Shipping Size",
    product_SuggestedPrice: "Price analysis of this product across the entire market",
    product_MinimumPrice: "Minimum Price",
    product_AveragePrice: "Average Price",
    product_MaximumPrice: "Maximum Price",
    length: "Length",
    width: "Width",
    height: "Height",
    Weight: "Weight",
    finalWeight: "Final Weight",
    product_deleteproductexplain: "You are attempting to delete this product.",
    // #endregion Store Section
    // #region 8️⃣Setting Section
    // Setting -> General -> System
    SettingGeneralSystemTitle: "System",
    SettingGeneralSystemlanguage: "Language",
    SettingGeneralSystemcalendar: "Calendar",
    SettingGeneralSystemGregorian: "Gregorian",
    SettingGeneralSystemshamsi: "Shamsi",
    SettingGeneralSystemHijri: "Hijri",
    SettingGeneralSystemHindi: "Hindi",
    SettingGeneralSystemStartWeek: "Start Week",
    SettingGeneralSystemsaturday: "Saturday",
    SettingGeneralSystemmonday: "Monday",
    SettingGeneralSystemtuesday: "Tuesday",
    SettingGeneralSystemwednesday: "Wednesday",
    SettingGeneralSystemthursday: "Thursday",
    SettingGeneralSystemfriday: "Friday",
    SettingGeneralSystemsunday: "Sunday",
    SettingGeneralSystemtheme: "Theme",
    SettingGeneralSystemDarkmode: "Dark Mode",
    SettingGeneralSystemlightmode: "Light Mode",
    SettingGeneralSystemPrice: "Price Model",
    SettingGeneralSystemDollar: "Dollar",
    SettingGeneralSystemeuro: "Euro",
    SettingGeneralSystempound: "Pound",
    SettingGeneralSystemrial: "Rial",
    SettingGeneralSystemtoman: "Toman",
    // Setting -> General -> AI Models
    SettingGeneralAiModelsTitle: "AI Models",
    SettingGeneralAiModelsTextModels: "Text Models",
    SettingGeneralAiModelsVoiceModels: "Voice to Text Models",
    SettingGeneralAiModelsDirectVoiceSupport: "Direct Voice Support",
    // Setting -> General -> Profile
    SettingGeneralProfileTitle: "profile",
    SettingGeneral_activedevice: "Active Devices",
    SettingGeneral_leatestentery: "User Activity History",
    SettingGeneral_cantdeletesession: "Sessions created less than 24 hours ago cannot be deleted.",
    SettingGeneral_deletesession: "You are attempting to delete this session.",
    SettingGeneral_addSubAdmin: "Add Sub-Admin",
    SettingGeneral_addSubAdminExplain: "Add a sub-admin with limited access",
    SettingGeneral_addSubAdminExplain2:
      "Invite an Admin with Limited and Secure Access, without Logging into Instagram.",

    SettingGeneral_addSubAdmintitleExplain:
      "Enter the new admin’s number to send the invitation. Once confirmed, access will be granted.",
    SettingGeneral_accesslevel: "Access Level",
    SettingGeneral_access: "Access",
    SettingGeneral_partnertitle: "Collaborator Admin Title",
    SettingGeneral_partnernumberexplain:
      "An invitation will be sent to this number, and the collaborator admin must confirm it in their panel (the admin must register in Brancy to accept the invitation).",
    SettingGeneral_contentTooltip: "Posts, Stories, Reels, IGTV, and Carousels.",
    SettingGeneral_publishTooltip: "Create posts and stories, and create content. This requires Content access.",
    SettingGeneral_automaticsTooltip: "AI, Flow, and automated processes and tasks. This requires Content access.",
    SettingGeneral_messageTooltip: "Instagram Direct, internal messages, and related tools.",
    SettingGeneral_commentTooltip: "Comments, replies, and related tools.",
    SettingGeneral_transactionTooltip: "Payment account management, transactions, wallet, and related tools.",
    SettingGeneral_adsTooltip: "Calendar management, advertiser management, ad approval, pricing, and related tools.",
    SettingGeneral_ordersTooltip: "Products, prices, warehouse stock, orders, waybills, and related tools.",
    SettingGeneral_bioTooltip: "Bio content and arrangement, links, and third-party content shortcuts.",
    SettingGeneral_ticketTooltip: "CRM, system tickets, and support.",
    SettingGeneral_productsTooltip: "Product management tools.",

    // Setting -> General -> support
    SettingGeneral_GeneralSupport: "General Support",
    SettingGeneral_Customerservices: "Customer Services",
    SettingGeneral_ReportBug: "Report Bug",
    SettingGeneral_Advertise: "Advertise",
    SettingGeneral_Store: "Store",
    SettingGeneral_biolink: "Bio Link",
    SettingGeneral_Walletandfinance: "Wallet and Finance",
    SettingGeneral_MessageingandComment: "Messaging and Comment",
    SettingGeneral_Support: "Support",
    SettingGeneral_Department: "Department",
    SettingGeneral_Title: "Title",
    SettingGeneral_Description: "Description",
    SettingGeneral_Send: "Send",
    // 6 notifications
    // #endregion Setting Section
    // // #region userpanel Section
    userpanel_market: "Market",
    userpanel_order: "Order",
    userpanel_Messages: "Messages",
    userpanel_Settings: "Settings",
    userpanel_PersonalInfo: "Personal Info",
    userpanel_UploadNewPicture: "Upload New Picture",
    userpanel_Instagramid: "Instagram id",
    userpanel_Nameandfamily: "Name & family",
    userpanel_NationalCode: "National Code",
    userpanel_BirthDay: "Birth Day",
    userpanel_MobileNumber: "Mobile Number",
    userpanel_Email: "Email",
    userpanel_CreditNumber: "Credit Number",
    userpanel_Addresses: "Addresses",
    userpanel_AddNewAddress: "Add New Address",
    userpanel_ZipCode: "Zip Code",
    userpanel_Address: "Address",
    userpanel_EditAddress: "Edit Address",
    userpanel_AddNewAddressexplain: "Your package will be delivered to this address and person",
    // #endregion userpanel Section
    startbusiness: "Start Business",
    AI: "AI",
    ExtraTokens: "Extra Tokens",
    TokenUsage: "Token Usage",
    AdvancedAnalytics: "Advanced Analytics",
    AIResponse: "AI IG Replies",
    CustomSupport: "Custom Support",
    CustomDomain: "Custom Domain",
    WinnerPicker: "Winner Picker",
    WinnerPickerReserve: "Reserve Lottery",

    dataTable1_feature1: "Post Management and Pro Analytics",
    dataTable1_tooltip1:
      "Easily schedule your Posts. Detailed charts and analytics for each Post including: (Like, Share, Comment, Save, Engagement Rate, Reach, Impression, Plays, Retention, Follow/Unfollow, Profile Activity, Used Hashtags), and much more...",

    dataTable1_feature2: "Create New Post",
    dataTable1_tooltip2:
      "Suggests best time and date based on your page. Post scheduling. Save hashtags for reuse. Auto-reply to Comments. Save Post as draft, and more.",

    dataTable1_feature3: "Story Management and Detailed Analytics",
    dataTable1_tooltip3:
      "Story scheduling. Full chart-based analytics for each Story: (Like, Share, Comment, Save, Engagement Rate, Reach, Impression, Plays, Retention, Follow/Unfollow, Profile Activity, Direct, Screenshot), and more...",

    dataTable1_feature4: "Create New Story",
    dataTable1_tooltip4:
      "Suggests best time and date based on your page. Story scheduling. Auto-reply to Comments. Save Story as draft, and more.",

    dataTable1_feature5: "Page Overview Analytics",
    dataTable1_tooltip5:
      "Number of Posts and Stories. Sort by most and least Views, Comments, and Likes. Detect best/worst posting times (with charts). History of Likes, Follow/Unfollow, Views, Comments, Ghost Viewers. Identify top Followers. Compare with past stats, and much more...",

    dataTable1_feature6: "Hashtag Management",
    dataTable1_tooltip6:
      "Create unlimited hashtag lists. Smart hashtag generation via image analysis (AI). Smart hashtag generation via page analysis (AI). View used hashtags. Trending hashtags list (daily, weekly, monthly by language: English, Persian, Arabic, etc.), and more features...",

    dataTable1_feature7: "Auto Like New Comments",
    dataTable1_tooltip7: "Automatically like new Followers’ Comments on each Post. View history as charts and lists.",

    dataTable1_feature8: "Random Lottery Among Followers",
    dataTable1_tooltip8:
      "Select best Follower by Likes and Comments. Randomly pick winners. Set number of winners. Auto-create and publish Story to announce winners. Track Lottery history via unique code, and more...",

    dataTable1_feature9: "Point-Based Lottery Among Followers",
    dataTable1_tooltip9:
      "Assign tasks for Lottery (Like, Comment, Mention, Follow). Set number of winners. Auto-create and publish Story for conditions. Auto-reminders. Auto-create and publish Story to announce results. Track Lottery history via unique code, and much more...",
    WithStrongCallToAction: "With Strong Call To Action",
    WithProsAndCons: "With Pros And Cons",
    ForComparison: "For Comparison",
    WithKeyPoints: "With Key Points",
    ForPromotionalPost: "For Promotional Post",
    WithDetailedExplanation: "With Detailed Explanation",
    PersuasiveStyle: "With Persuasive Style",
    ForProductIntroduction: "For Product Introduction",
    LongText: "As Long Text",
    Aipromptexplain:
      "Brancy analyzes your page content to understand your tone and writing style; no extra explanation needed!",
    ImagineSomething: "Imagine something... ✦",
    Generating: "Generating...",
    AccessAndManageComments: "Access and Manage Comments",
    AccessAndManageMessages: "Access and Manage Messages",
    AccessAndPublishContent: "Access and Publish Content",
    AccessAndManageInsights: "Access and Manage Insights",
    AccessAndManageCommentsExplain:
      "To view and manage Instagram comments, click 'Enable Permission' and approve it on the opened page.",
    AccessAndManageMessagesExplain:
      "To manage Instagram messages, click 'Enable Permission' and approve it on the opened page.",
    AccessAndPublishContentExplain:
      "To view and publish Instagram content, click 'Enable Permission' and approve it on the opened page.",
    AccessAndManageInsightsExplain:
      "To view and manage Instagram insights, click 'Enable Permission' and approve it on the opened page.",

    EnablePermission: "Enable Permission",
    instagramTutorialTitle: "Instagram Connection Guide",
    instagramTutorialStep1Title: "Step 1: Secure Login to Instagram",
    instagramTutorialStep1Text:
      "To connect securely, click 'Connect Instagram Account'. You’ll be redirected to instagram.com, log in to your account. This ensures your data’s security and a valid connection.",
    instagramTutorialStep2Title: "Step 2: Grant Access",
    instagramTutorialStep2Text:
      "After logging in, Instagram will request permissions to access your public account info. Approve all to ensure proper system functionality.",
    instagramremoveStep1Title: "Step 3: Check Permissions",
    instagramremoveStep1text: "Go to settings to view all active permissions for your account.",
    instagramremoveStep2Title: "Step 4: Manage & Remove Extra Access",
    instagramremoveStep2text:
      "Since Brancy is an official Instagram partner, no other services are needed. For security, remove unnecessary accesses.",

    understood: "Got it",
    previous: "Previous",
    connectTutorial: "Connection Tutorial",
    invalidcode: "Invalid Code",
    wearesorry: "We are sorry!",
    PaymentFailed: "Payment Failed!",
    thankyou: "Thank you!",
    Paymentsuccess: "Payment Successful!",
    TransactionNumber: "Transaction Number:",
    TransactiontrackingNumber: "Transaction Tracking Number:",
    InvoiceNumber: "Invoice Number:",

    mainSubscriptionPlan: "Main Subscription",
    Tokens: "Tokens",
    tokenExplain:
      "A token is the unit of AI services consumption; on average, processing 100 requests requires about 1,000 tokens.",
    ReserveToken: "Reserve Token",
    packageTokenExplain:
      "Free tokens that are activated with the package and can be used until the package expires; after that, they expire.",
    ReserveTokenExplain: "Purchased reserve tokens that do not expire over time.",

    pageTools_Months: "Months",
    subscriptionExpired: "Your subscription has expired, Please renew it",
    subscriptionExpireSoon: "Your subscription will expire soon",
    subscriptionManagement: "Subscription Management",
    subscription: "Subscription",
    AIAssisment: "AI Assistant",
    timeperiod: "Remaining Time Period",
    domain: "Domain",
    winnerpickerexpired: "You can no longer run a lottery, please recharge",
    winnerpickerexpiresoon: "Your lottery attempts are running out",
    Aiexpired: "You no longer have access to AI. Please recharge.",
    Aiexpiresoon: "Your AI tokens are about to run out.",

    followercount: "Follower Count",
    yourCurrentSubscription: "Your Current Subscription",
    noItemsAvailableContactSupport:
      "This section is currently unavailable. Please contact Brancy support by submitting a ticket.",

    // #region AIFlow Section
    AIAssismentexplain:
      "Using Brancy’s AI assistant, you can create smart conversation flows to automatically reply to Instagram messages and comments",
    livetest: "Live Test",
    testlab: "Test Lab",
    promptmode: "Prompt Mode",
    promptanalysis: "Prompt Analysis",
    promptanalysisExplain:
      "Enter your prompt in detail; Brancy will analyze it based on your character, tone, and interaction style.",
    promptanalysisplaceholder: "Enter at least 20 characters for prompt analysis",
    reanalyze: "Reanalyze",
    shouldFollowerexplain: "Replies are sent only to users who follow you",
    RenewForThread: "Renew Conversation Flow",
    RenewForThreadexplain:
      "In each conversation, if the user sends a new message, the conversation flow starts from the beginning",
    prompt: "Prompt",
    promptanalysisexplain: "Brancy analyzes your Prompt and suggests the best settings for smart replies",

    autosave: "Autosave",
    Restrictorzoom: "Restrict Zoom",
    snapGrid: "Snap to Grid",
    PanningBoundary: "Panning Boundary",
    Flow: "Flow",
    flowtitle: "Flow Title",
    AIFlow_input: "Input",
    AIFlow_input_message_block: "User Input Message",
    AIFlow_output: "Output",
    AIFlow_output_title: "Output Title",
    AIFlow_text: "Text",
    AIFlow_item_text: "Item",
    AIFlow_block_title_required: "Please Enter Block Title (Required)",
    AIFlow_item_title: "Item Title:",
    AIFlow_show_graph: "Show Flow Graph",
    AIFlow_connect_post: "Connect to a post",
    AIFlow_connect_post_access: "Comment and message permissions, plus Automation and Comment access, are required.",
    AIFlow_connect_post_save_first: "Save this flow before connecting it to a post.",
    AIFlow_connect_post_confirm:
      "This replaces the post's current automatic reply with this flow and activates it. Existing keywords and matching settings are kept; without keywords, the flow responds to all comments.",
    AIFlow_connect_post_resume: "The flow connection was saved, but activation failed. Try activating it again.",
    AIFlow_connect_post_incompatible:
      "This flow is not compatible with private comment replies. Edit and save the flow before connecting it.",
    AIFlow_retry: "Try again",
    AIPrompt_connect_post_access: "Instagram comment permission and Automation and Comment access are required.",
    AIPrompt_connect_post_confirm:
      "This replaces the post's current automatic reply with this AI prompt and activates it. Existing keywords and matching settings are kept; without keywords, all comments receive a reply. Private delivery is kept only when message permission is available; otherwise replies are sent as comments.",
    AIPrompt_connect_post_resume: "The AI connection was saved, but activation failed. Try activating it again.",
    messagesetting_PhoneNumbers: "Phone Numbers",
    messagesetting_PhoneNumbersExplain: "Phone numbers collected from your customers through Flows",
    messagesetting_PhoneNumbersEmpty: "No phone numbers have been collected yet",
    AIFlow_item_subtitle: "Item Subtitle:",
    AIFlow_option_title: "Option Title",
    AIFlow_option_default: "Option",
    AIFlow_quick_reply: "Quick Reply",
    AIFlow_quick_reply_validation_error: "All Quick Reply Fields Must Be Filled!",
    AIFlow_quick_reply_block_title_empty: "Block {label}\n No Title Entered",
    AIFlow_quick_reply_option_title_empty: "Block {label}\n Option {index} Has No Title",
    AIFlow_delete_image: "🗑️ Delete Image",
    AIFlow_delete_image_button_text: "🗑️ Delete Image",
    AIFlow_delete_all_block: "🗑️ Delete Block",
    AIFlow_delete_all_blocks: "Delete Entire Flow",
    AIFlow_save_all_blocks: "Save Entire Flow",
    AIFlow_delete: "🗑️ Delete",
    AIFlow_upload_image: "📷 Upload Image",
    AIFlow_image_uploaded: "Image Uploaded ✓",
    AIFlow_add_image: "📷 Add Image",
    AIFlow_voice_recorded: "🎵 Recorded Voice",
    AIFlow_record_voice: "🎤 Record Voice",
    AIFlow_record_voice_confirm: "Ready to Record? (Minimum 3 Seconds)",
    AIFlow_play_voice: "▶️ Play Voice",
    AIFlow_add_output: "Add New Output",
    AIFlow_add_subtitle: "➕ Add Subtitle",
    AIFlow_subtitle_input: "Please Enter Subtitle:",
    AIFlow_link: "Link:",
    AIFlow_general_block: "General Block",
    AIFlow_text_block: "Text Block",
    AIFlow_image_block: "Image Block",
    AIFlow_voice_block: "Voice Block",
    AIFlow_quick_reply_block: "Quick Reply Block",
    AIFlow_weblink_block: "Weblink Block",
    AIFlow_add_text_block: "Add Text Block",
    AIFlow_add_image_block: "Add Image Block",
    AIFlow_add_voice_block: "Add Voice Block",
    AIFlow_add_quick_reply_block: "Add Quick Reply",
    AIFlow_add_general_block: "Add General Block",
    AIFlow_add_weblink_block: "Add Weblink",
    AIFlow_generic_block: "Generic Sub Block",
    AutoLayout_block: "Auto Layout Layers",
    AIFlow_live_test_block: "Live Flow Test",

    AIFlow_Deleteallblocks_alert: "Are you sure you want to delete the entire flow?",
    AIFlow_add_output_error_alert: "Error adding output: {error}",
    AIFlow_unknown_block_type_alert: "Unknown block type:",
    AIFlow_multiple_flow_for_private_reply_alert: "Multiple flows found for private reply",
    AIFlow_empty_title_for_flow_alert: "Flow title is empty",
    AIFlow_weblink_has_hyphen_alert: "Block {label}\n Link must not contain '-'",
    AIFlow_min_output_required: "At least one output must remain",
    AIFlow_max_quick_reply_outputs: "Maximum 15 outputs are allowed",
    AIFlow_max_generic_outputs: "Maximum 10 outputs are allowed",
    AIFlow_generic_item_connection_only: "This block only connects to generic blocks",
    AIFlow_weblink_generic_item_only: "This block only connects to generic sub-items",
    AIFlow_voice_record_failed: "❌ Voice recording failed (no sound recorded)",
    AIFlow_voice_upload_failed: "✅ Recording was successful but upload failed",
    AIFlow_voice_record_empty: "❌ Voice recording is empty",
    AIFlow_voice_record_start: "🎙️ Recording started...",
    AIFlow_session_invalid: "Invalid user session, please log in again",
    AIFlow_no_on_message_node: "No start message node found!",
    AIFlow_validation_warning: "⚠️ Validation Warning",
    AIFlow_generic_item_validation_error: "Please complete all fields of the generic block",
    AIFlow_weblink_validation_error_alert: "All link fields must be filled",
    AIFlow_generic_item_title_empty_alert: "Item {label}\n Title is empty",
    AIFlow_generic_item_output_title_empty_alert: "Item {label}\n Output {index} has no title",
    AIFlow_weblink_empty_alert: "Block {label}\n Link is empty",

    AIFlow_weblink_incomplete_alert: "Block {label}\n Link is incomplete (only protocol entered)",
    AIFlow_weblink_invalid_format_alert: "Block {label}\n Link format is invalid",
    AIFlow_weblink_non_english_alert: "Block {label}\n Link must be in English",
    AIFlow_editor_init_error: "❌ Error initializing editor",
    AIFlow_unexpected_error: "⚠️ An unexpected error occurred",
    AIFlow_server_error: "❌ Server error",
    AIFlow_connection_error: "⚠️ Connection issue",
    AIFlow_generic_connection_error: "Error connecting generic block to sub-item",
    AIFlow_weblink_connection_error: "Error connecting node",
    AIFlow_voice_fetch_error: "Error fetching audio file",
    AIFlow_voice_record_error: "Error recording voice",
    AIFlow_voice_play_error: "Error playing voice",
    AIFlow_media_recorder_error: "Error in media recorder",
    AIFlow_upload_error: "❌ Upload error",
    AIFlow_add_output_error: "❌ Error adding output",
    AIFlow_json_parse_error: "Error parsing JSON",
    AIFlow_position_error: "Error processing start message position",
    AIFlow_node_remove_error: "Error removing node",
    AIFlow_node_connection_warning: "Cannot establish connection:",
    AIFlow_unknown_value_type: "Unknown value type in button",
    AIFlow_success: "✅ Operation completed successfully",
    AIFlow_subtitle_success: "✓ Subtitle added successfully",
    AI_live_test: "Test your AI prompts in real-time",
    //tutorials

    // #region AIFlow Section

    New_Flow_input_message_block: "User Input Message",
    New_Flow_general_block: "General Block",
    New_Flow_text_block: "Text Block",
    New_Flow_voice_block: "Voice Block",
    New_Flow_imageorvideo_block: "Image / Video Block",
    New_Flow_quick_reply_block: "Quick Reply Block",
    New_Flow_weblink_block: "Link Block",
    New_Flow_phonenumbergrabber_block: "Phone Number Grabber",
    New_Flow_ai_block: "AI",
    New_Flow_ai_select: "Select an AI",
    New_Flow_ai_livetest: "Your AI block is being executed here",
    New_Flow_masterflow_block: "Sub Flow",
    New_Flow_masterflow_select: "Select a flow",
    New_Flow_masterflow_livetest: "The selected sub flow continues from here",
    New_Flow_Tutorials_buttongroup_title: "Button Group Block",
    New_Flow_Tutorials_buttongroup_description:
      "This block sends a message with up to three buttons; each button has its own output, and the block also has a regular output that continues the flow.",
    New_Flow_Tutorials_buttongroup_usageType:
      "Suitable for offering a few clear choices, menus, quick navigation, and guiding users to links or next steps.",
    New_Flow_Tutorials_buttongroup_feature_1: "Message text of up to 640 characters",
    New_Flow_Tutorials_buttongroup_feature_2: "Up to 3 buttons, each with an independent output",
    New_Flow_Tutorials_buttongroup_feature_3: "A regular output continues the flow without waiting for a button click",
    New_Flow_Tutorials_buttongroup_tip_1: "Write the message and button labels clearly and briefly",
    New_Flow_Tutorials_buttongroup_tip_2: "Connect each button to the block that should follow its choice",
    New_Flow_Tutorials_buttongroup_tip_3: "Only the button outputs can be connected to a Web Link block",
    New_Flow_Tutorials_buttongroup_limitation_1: "Maximum 3 buttons",
    New_Flow_Tutorials_buttongroup_limitation_2: "Message text: Max 640 characters",
    New_Flow_Tutorials_buttongroup_limitation_3: "Button title: Max 20 characters",
    New_Flow_Tutorials_buttongroup_limitation_4: "Deleting the last button removes the block",
    New_Flow_Tutorials_ai_title: "AI Block",
    New_Flow_Tutorials_ai_description:
      "This block hands the conversation over to one of the AIs you have created; select the AI from the list inside the block.",
    New_Flow_Tutorials_ai_usageType:
      "Suitable for answering open-ended customer questions, support, consultation, and sales conversations automatically.",
    New_Flow_Tutorials_ai_feature_1: "Lists all the AIs you have created so you can pick one",
    New_Flow_Tutorials_ai_feature_2: "The selected AI takes over the conversation from this point of the flow",
    New_Flow_Tutorials_ai_tip_1: "Create and configure your AI first so it appears in the list",
    New_Flow_Tutorials_ai_tip_2: "Place it after a message block that introduces the conversation",
    New_Flow_Tutorials_ai_limitation_1: "Has an input only and no output, so it ends the flow",
    New_Flow_Tutorials_ai_limitation_2: "Only one AI can be selected per block",
    New_Flow_Tutorials_ai_limitation_3: "Cannot be the first block of the flow",
    New_Flow_Tutorials_masterflow_title: "Sub Flow Block",
    New_Flow_Tutorials_masterflow_description:
      "Sends the conversation to another flow you have already created when the user taps a button.",
    New_Flow_Tutorials_masterflow_usageType: "Reuse an existing flow as the continuation of a button",
    New_Flow_Tutorials_masterflow_feature_1: "Lists all the flows you have created so you can pick one",
    New_Flow_Tutorials_masterflow_feature_2: "The selected flow continues the conversation from this point",
    New_Flow_Tutorials_masterflow_tip_1: "Create and save the target flow first so it appears in the list",
    New_Flow_Tutorials_masterflow_tip_2: "Use it to share common paths (such as support or pricing) between flows",
    New_Flow_Tutorials_masterflow_limitation_1: "Has an input only and no output, so it ends this flow",
    New_Flow_Tutorials_masterflow_limitation_2: "Can only be connected to buttons, not to regular outputs",
    New_Flow_Tutorials_masterflow_limitation_3: "The flow you are editing cannot be selected",
    New_Flow_Tutorials_masterflow_connection_1: "Quick Reply block buttons",
    New_Flow_Tutorials_masterflow_connection_2: "Button Group block buttons",
    New_Flow_Tutorials_masterflow_connection_3: "Gallery sub block buttons",
    New_Flow_generic_block: "Gallery Block (Carousel)",
    New_Flow_add_general_block: "Add Gallery Block",
    New_Flow_add_text_block: "Add Text Block",
    New_Flow_add_image_block: "Add Image Block",
    New_Flow_add_voice_block: "Add Voice Block",
    New_Flow_add_quick_reply_block: "Add Quick Reply",
    New_Flow_add_weblink_block: "Add Link",
    New_Flow_upload_imageorvideo: "Upload Image or Video",
    New_Flow_upload_image: "Upload Image",
    New_Flow_upload_unsupported_media: "Unsupported media format",
    New_Flow_uploadmaxsizeexceeded: "File size must not exceed 50MB",
    New_Flow_uploadfilefailed: "File upload failed, please try again",
    invalidFlowDetected: "Invalid flow detected! Some blocks have no input, or the message block is isolated.",

    New_Flow_unsupportedbrowser: "Your browser does not support video playback",
    New_Flow_micphoneaccessdenied: "Enable microphone access",
    New_Flow_upload_audio: "Upload Audio File",
    New_Flow_record_voice: "Record Voice",
    New_Flow_stop_record_voice: "Stop Recording",
    New_Flow_areyoureadytorecord: "Are you ready to record?",

    New_Flow_voice_recording_started: "Recording voice...",
    New_Flow_add_generic_sub_block: "Add Sub-Block",
    New_Flow_generic_sub: "Sub-Block",
    New_Flow_add_button: "Add Button",
    New_Flow_quick_reply_title_placeholder: "Quick Reply Option Title",
    New_Flow_buttongroup_block: "Button Group Block",
    New_Flow_add_buttongroup_block: "Add Button Group",
    New_Flow_buttongroup_title_placeholder: "Button Group Message Text",
    New_Flow_imagegallery_block: "Image Gallery Block",
    New_Flow_add_imagegallery_block: "Add Image Gallery",
    New_Flow_imagegallery_max_reached: "You can add up to {{max}} images to this block",
    New_Flow_Tutorials_imagegallery_title: "Image Gallery Block",
    New_Flow_Tutorials_imagegallery_description:
      "This block is used to upload and send multiple images (up to {{max}}) to users via direct messages.",
    New_Flow_Tutorials_imagegallery_usageType:
      "Suitable for showcasing multiple products, photo albums, before/after photos, and image collections.",
    New_Flow_Tutorials_imagegallery_feature_1: "Accepts up to {{max}} images in a single block",
    New_Flow_Tutorials_imagegallery_limitation_1:
      "Maximum {{max}} images per block (this limit may increase in the future)",
    New_Flow_message_title: "Message Title",
    New_Flow_message_description: "Message Description",
    New_Flow_live_test_block: "Live Flow Test",
    New_Flow_delete_all_blocks: "Delete Entire Flow",
    New_Flow_shortcuts_explain: "Keyboard shortcuts to increase speed and mastery in managing workflows.",
    New_Flow_Tutorials_Not_Available: "Tutorial Not Available",
    New_Flow_Tutorials_Not_Available_Description: "No tutorial is available for this node.",
    New_Flow_Tutorials_Usage_Type: "Usage Type",
    New_Flow_Tutorials_Features: "Features",
    New_Flow_Tutorials_Tips: "Practical Tips",
    New_Flow_Tutorials_Limitations: "Limitations",
    New_Flow_Tutorials_Connections: "Connections",
    New_Flow_unsavedChanges: "You have unsaved changes",
    New_Flow_addedNodes: "Added Nodes",
    New_Flow_removedNodes: "Removed Nodes",
    New_Flow_modifiedNodes: "Modified Nodes",
    New_Flow_invalidFlow_explain: "The flow is not valid. Please check the nodes for any errors before saving",
    sendsms: "Send SMS to User",
    sendtotelegram: "Redirect User to Telegram",
    senderusername: "Mention User by Name",
    addtools: "Add Tool",
    generatebyai: "Generate by AI",

    //tutorials
    New_Flow_Tutorials_onmessage_title: "Your Flow Starting Point",
    New_Flow_Tutorials_onmessage_description:
      "This block is the starting point of your flow. When a user sends a message to your Instagram direct, this block is triggered and the flow starts. It is always the first block in any automation and cannot be deleted.",
    New_Flow_Tutorials_onmessage_feature_1: "Single output to connect to the next block",
    New_Flow_Tutorials_onmessage_tip_1:
      "Connect this block’s output to any other block. The flow starts when the user sends any type of message (text, image, video, audio, etc.)",
    New_Flow_Tutorials_onmessage_connection_1: "Connectable to the following blocks:",
    New_Flow_Tutorials_onmessage_connection_2: "❌ Web Link Block",
    New_Flow_Tutorials_onmessage_connection_3: "✅ Voice Message Block",
    New_Flow_Tutorials_onmessage_connection_4: "✅ Text Message Block",
    New_Flow_Tutorials_onmessage_connection_5: "✅ Quick Reply Block",
    New_Flow_Tutorials_onmessage_connection_6: "✅ Image & Video Block",
    New_Flow_Tutorials_onmessage_connection_7: "✅ Gallery Block",

    New_Flow_Tutorials_text_title: "Text Message Block",
    New_Flow_Tutorials_text_description: "This block is used to send text messages to users.",
    New_Flow_Tutorials_text_usageType:
      "Suitable for welcome messages, product explanations, FAQs, notifications, and guiding users.",
    New_Flow_Tutorials_text_feature_1: "Supports all languages",
    New_Flow_Tutorials_text_feature_2: "Ability to use emojis and special characters",
    New_Flow_Tutorials_text_tip_1: "Keep messages short and clear",
    New_Flow_Tutorials_text_tip_2: "Use emojis moderately",
    New_Flow_Tutorials_text_tip_3: "Split long texts into multiple sections",
    New_Flow_Tutorials_text_tip_4: "Maintain a friendly and approachable tone",
    New_Flow_Tutorials_text_tip_5: "Use proper paragraph formatting",
    New_Flow_Tutorials_text_limitation_1: "Maximum 2200 characters",
    New_Flow_Tutorials_text_limitation_2: "Text only (no files or media)",
    New_Flow_Tutorials_text_limitation_3: "No formatting options (Bold, Italic)",
    New_Flow_Tutorials_text_connection_1: "✅ Message Input Block",
    New_Flow_Tutorials_text_connection_2: "❌ Web Link Block",
    New_Flow_Tutorials_text_connection_3: "✅ Voice Message Block",
    New_Flow_Tutorials_text_connection_4: "✅ Text Message Block",
    New_Flow_Tutorials_text_connection_5: "✅ Quick Reply Block",
    New_Flow_Tutorials_text_connection_6: "✅ Image & Video Block",
    New_Flow_Tutorials_text_connection_7: "❌ Gallery Block",
    New_Flow_Tutorials_text_connection_8: "✅ Gallery Sub-branch Block",

    New_Flow_Tutorials_image_title: "Image & Video Block",
    New_Flow_Tutorials_image_description:
      "This block is used to upload and send images and videos to users via direct messages.",
    New_Flow_Tutorials_image_usageType:
      "Suitable for showcasing products, image galleries, logos, promotional banners, educational and introductory videos.",
    New_Flow_Tutorials_image_feature_1: "Supports images: JPEG, PNG, GIF, WebP, SVG",
    New_Flow_Tutorials_image_feature_2: "Supports videos: MP4, WebM, OGG, MOV, AVI, MKV",
    New_Flow_Tutorials_image_feature_3: "Automatic file type detection",
    New_Flow_Tutorials_image_tip_1: "Use high-quality images",
    New_Flow_Tutorials_image_tip_2: "Compress large files before uploading",
    New_Flow_Tutorials_image_tip_3: "Standard dimensions: 1080×1080 or 1080×1350",
    New_Flow_Tutorials_image_tip_4: "Keep videos under 30 seconds",
    New_Flow_Tutorials_image_tip_5: "Use JPEG for regular images, PNG for transparent backgrounds",
    New_Flow_Tutorials_image_limitation_1: "Maximum size: 50 MB",
    New_Flow_Tutorials_image_limitation_2: "One file per block",
    New_Flow_Tutorials_image_limitation_3: "Unusual formats may not be supported",
    New_Flow_Tutorials_image_connection_1: "✅ Message Input Block",
    New_Flow_Tutorials_image_connection_2: "❌ Web Link Block",
    New_Flow_Tutorials_image_connection_3: "✅ Voice Message Block",
    New_Flow_Tutorials_image_connection_4: "✅ Text Message Block",
    New_Flow_Tutorials_image_connection_5: "✅ Quick Reply Block",
    New_Flow_Tutorials_image_connection_6: "✅ Image & Video Block",
    New_Flow_Tutorials_image_connection_7: "❌ Gallery Block",
    New_Flow_Tutorials_image_connection_8: "✅ Gallery Sub-block",

    New_Flow_Tutorials_voice_title: "Voice Message Block",
    New_Flow_Tutorials_voice_description:
      "This block is used to upload and send audio files or live recordings to users.",
    New_Flow_Tutorials_voice_usageType:
      "Suitable for personal voice messages, narrated tutorials, short podcasts, and voice guides.",
    New_Flow_Tutorials_voice_feature_1: "Supports formats: MP3, M4A, WAV, OGG, AAC",
    New_Flow_Tutorials_voice_feature_2: "Direct microphone recording",
    New_Flow_Tutorials_voice_feature_3: "Upload pre-recorded audio files",
    New_Flow_Tutorials_voice_tip_1: "Record in a quiet environment",
    New_Flow_Tutorials_voice_tip_2: "Short messages (under 1 minute) are preferable",
    New_Flow_Tutorials_voice_tip_3: "Check audio quality before sending",
    New_Flow_Tutorials_voice_tip_4: "Prepare your script before recording",
    New_Flow_Tutorials_voice_limitation_1: "Maximum size: 50 MB",
    New_Flow_Tutorials_voice_limitation_2: "Microphone access required for recording",
    New_Flow_Tutorials_voice_limitation_3: "One file per block",
    New_Flow_Tutorials_voice_connection_1: "✅ Message Input Block",
    New_Flow_Tutorials_voice_connection_2: "❌ Web Link Block",
    New_Flow_Tutorials_voice_connection_3: "✅ Voice Message Block",
    New_Flow_Tutorials_voice_connection_4: "✅ Text Message Block",
    New_Flow_Tutorials_voice_connection_5: "✅ Quick Reply Block",
    New_Flow_Tutorials_voice_connection_6: "✅ Image & Video Block",
    New_Flow_Tutorials_voice_connection_7: "❌ Gallery Block",
    New_Flow_Tutorials_voice_connection_8: "✅ Gallery Sub-block",

    New_Flow_Tutorials_quickreply_title: "Quick Reply Block",
    New_Flow_Tutorials_quickreply_description:
      "This block is used to create one-time selectable Quick Reply buttons for users, where each button guides the user along a specific flow path.",
    New_Flow_Tutorials_quickreply_usageType:
      "Suitable for selection menus, product categories, multiple-choice questions, polls, and search filters.",
    New_Flow_Tutorials_quickreply_feature_1: "Up to 10 buttons per block",
    New_Flow_Tutorials_quickreply_feature_2: "Each button has an independent output",
    New_Flow_Tutorials_quickreply_feature_3: "Ability to delete and edit buttons",
    New_Flow_Tutorials_quickreply_tip_1: "Write button text clearly and practically",
    New_Flow_Tutorials_quickreply_tip_2: "3 to 5 buttons for better experience",
    New_Flow_Tutorials_quickreply_tip_3: "Keep labels short (under 20 characters)",
    New_Flow_Tutorials_quickreply_tip_4: "Use the title field for guidance",
    New_Flow_Tutorials_quickreply_tip_5: "Prioritize buttons based on importance",
    New_Flow_Tutorials_quickreply_limitation_1: "Maximum 10 buttons",
    New_Flow_Tutorials_quickreply_limitation_2: "Button title: Max 40 characters",
    New_Flow_Tutorials_quickreply_limitation_3: "Description: Max 140 characters",
    New_Flow_Tutorials_quickreply_limitation_4: "At least one button required",
    New_Flow_Tutorials_quickreply_connection_1: "✅ Message Input Block",
    New_Flow_Tutorials_quickreply_connection_2: "❌ Web Link Block",
    New_Flow_Tutorials_quickreply_connection_3: "✅ Voice Message Block",
    New_Flow_Tutorials_quickreply_connection_4: "✅ Text Message Block",
    New_Flow_Tutorials_quickreply_connection_5: "✅ Quick Reply Block",
    New_Flow_Tutorials_quickreply_connection_6: "✅ Image & Video Block",
    New_Flow_Tutorials_quickreply_connection_7: "❌ Gallery Block",
    New_Flow_Tutorials_quickreply_connection_8: "✅ Gallery Sub-Block",

    New_Flow_Tutorials_generic_title: "Gallery (Carousel) Block",
    New_Flow_Tutorials_generic_description: "Create a horizontally scrollable gallery (carousel) of items.",
    New_Flow_Tutorials_generic_usageType:
      "Suitable for displaying products, service menus, categories, team introduction, portfolio, and option comparisons.",
    New_Flow_Tutorials_generic_tip_1: "Use images with the same dimensions (e.g., 1:1)",
    New_Flow_Tutorials_generic_tip_2: "Keep the number of items between 3 and 5",
    New_Flow_Tutorials_generic_tip_3: "Write titles short and clearly",
    New_Flow_Tutorials_generic_tip_4: "Suitable for similar products or comparisons",
    New_Flow_Tutorials_generic_limitation_1: "Maximum 10 items per carousel",
    New_Flow_Tutorials_generic_connection_1: "✅ Message Input Block",
    New_Flow_Tutorials_generic_connection_2: "✅ Gallery Sub-Block",
    New_Flow_Tutorials_generic_connection_3: "❌ Web Link Block",
    New_Flow_Tutorials_generic_connection_4: "❌ Voice Message Block",
    New_Flow_Tutorials_generic_connection_5: "❌ Text Message Block",
    New_Flow_Tutorials_generic_connection_6: "❌ Quick Reply Block",
    New_Flow_Tutorials_generic_connection_7: "❌ Image & Video Block",

    New_Flow_Tutorials_genericitem_title: "Carousel Item",
    New_Flow_Tutorials_genericitem_description:
      "An item inside a carousel including image, title, description, link, and up to 3 buttons",
    New_Flow_Tutorials_genericitem_usageType:
      "Suitable for showcasing product details, service introductions, team display, portfolios, and pricing packages.",
    New_Flow_Tutorials_genericitem_feature_1: "Optional web link",
    New_Flow_Tutorials_genericitem_feature_2: "Optional image: JPEG, PNG, GIF",
    New_Flow_Tutorials_genericitem_feature_3: "Video: MP4, WebM, OGG",
    New_Flow_Tutorials_genericitem_feature_4: "Up to 3 buttons with independent outputs",
    New_Flow_Tutorials_genericitem_tip_1: "Add an attractive image for each item",
    New_Flow_Tutorials_genericitem_tip_2: "Title for main message, description for details",
    New_Flow_Tutorials_genericitem_tip_3: "Test links before sending",
    New_Flow_Tutorials_genericitem_tip_4: "Keep button text short and clear",
    New_Flow_Tutorials_genericitem_tip_5: "Prefer using shortened links",
    New_Flow_Tutorials_genericitem_limitation_1: "Title: max 140 characters",
    New_Flow_Tutorials_genericitem_limitation_2: "Description: max 140 characters",
    New_Flow_Tutorials_genericitem_limitation_3: "Maximum 3 buttons",
    New_Flow_Tutorials_genericitem_limitation_4: "Button title: max 40 characters",
    New_Flow_Tutorials_genericitem_limitation_5: "File size: max 50MB",
    New_Flow_Tutorials_genericitem_limitation_6: "At least one button required",
    New_Flow_Tutorials_genericitem_connection_1: "❌ Message Input Block",
    New_Flow_Tutorials_genericitem_connection_2: "✅ Gallery Block",
    New_Flow_Tutorials_genericitem_connection_3: "✅ Web Link Block",
    New_Flow_Tutorials_genericitem_connection_4: "✅ Voice Message Block",
    New_Flow_Tutorials_genericitem_connection_5: "✅ Text Message Block",
    New_Flow_Tutorials_genericitem_connection_6: "✅ Quick Reply Block",
    New_Flow_Tutorials_genericitem_connection_7: "✅ Image & Video Block",

    New_Flow_Tutorials_weblink_title: "Web Link Block",
    New_Flow_Tutorials_phonenumbergrabber_title: "Phone Number Grabber Block",
    New_Flow_Tutorials_phonenumbergrabber_description:
      "This block waits to receive a phone number and, once received, registers it as a valid number.",
    New_Flow_Tutorials_phonenumbergrabber_usageType:
      "Suitable for collecting customer contact numbers, sign-ups, order follow-ups, consultations, and sales contact.",
    New_Flow_Tutorials_phonenumbergrabber_feature_1: "Waits for the user's reply until a phone number is received",
    New_Flow_Tutorials_phonenumbergrabber_feature_2: "Automatically validates and registers the received number",
    New_Flow_Tutorials_phonenumbergrabber_tip_1:
      "Before this block, use a text block to ask the user for their phone number",
    New_Flow_Tutorials_phonenumbergrabber_tip_2: "Tell the user the expected number format (e.g., with country code)",
    New_Flow_Tutorials_phonenumbergrabber_tip_3: "After this block, send a confirmation or thank-you message",
    New_Flow_Tutorials_phonenumbergrabber_limitation_1: "Cannot be the first block of the flow",
    New_Flow_Tutorials_phonenumbergrabber_limitation_2: "Has only one input and one output",
    New_Flow_Tutorials_phonenumbergrabber_limitation_3: "Only valid phone numbers are registered",
    New_Flow_Tutorials_phonenumbergrabber_connection_3: "❌ Gallery Sub-branch Block",
    New_Flow_Tutorials_phonenumbergrabber_connection_2: "❌ Quick Reply Block",
    New_Flow_Tutorials_phonenumbergrabber_connection_1: "❌ Message Input Block (cannot be the first block)",
    New_Flow_Tutorials_weblink_description: "Send a clickable web link that opens in the user's browser",
    New_Flow_Tutorials_weblink_usageType:
      "Suitable for directing to websites, product pages, stores, registration forms, landing pages, and articles.",
    New_Flow_Tutorials_weblink_feature_1: "Automatic URL validation",
    New_Flow_Tutorials_weblink_feature_2: "Supports links with/without WWW",
    New_Flow_Tutorials_weblink_tip_1: "Prefer using a link shortener",
    New_Flow_Tutorials_weblink_tip_2: "Test links before sending",
    New_Flow_Tutorials_weblink_tip_3: "Links should be mobile-friendly",
    New_Flow_Tutorials_weblink_tip_4: "Avoid excessive redirects",
    New_Flow_Tutorials_weblink_tip_5: "Prefer HTTPS",
    New_Flow_Tutorials_weblink_limitation_1: "Only http:// or https:// is valid",
    New_Flow_Tutorials_weblink_limitation_2: "Cannot add description",
    New_Flow_Tutorials_weblink_limitation_3: "Internal links (file://) are not supported",
    New_Flow_Tutorials_weblink_connection_1: "⬅️ Input from: Gallery Sub-Block",
    New_Flow_Tutorials_weblink_connection_2: "❌ No output (flow endpoint)",

    // #region Notification Section
    Notify_Ok: "Operation completed successfully",
    Notify_InternalException: "A system error has occurred",
    Notify_CannotSendSmsNow: "Unable to send SMS at the moment",
    Notify_InvalidPhoneNumber: "The entered phone number is invalid",
    Notify_InvalidCountryCode: "The entered country code is invalid",
    Notify_PhoneNumberNotAvailableInThisCountry: "This phone number cannot be used in the selected country",
    Notify_InstagramerIdNotExist: "Instagram user not found",
    Notify_EmptyProductList: "Product list is empty",
    Notify_InvalidVerificationCode: "The entered verification code is incorrect",
    Notify_LowQuality: "Content quality is low",
    Notify_CannotEmptyChildren: "Cannot delete sub-items",
    Notify_InvalidAspectRatio: "The entered aspect ratio is invalid",
    Notify_InvalidMediaCodec: "Media codec is not supported",
    Notify_InvalidMediaType: "Media type is not supported",
    Notify_MediaUrlNotAccessible: "Media URL is not accessible",
    Notify_CannotCreatePrePostNow: "Cannot create pre-post at the moment",
    Notify_InvalidMediaContent: "Media content is invalid",
    Notify_Unexpected: "An unexpected error has occurred",
    Notify_TooManyRequestForImageHashtagGenerator: "Too many requests for image hashtag generation",
    Notify_LoginFailed: "Login failed, please try again",
    Notify_NullUserId: "User ID not provided",
    Notify_RealtimeSocketNotExist: "Connection to the server is not established",
    Notify_PushSocketNotExist: "Connection is not established",
    Notify_InstaApiNotFoundForConnect: "Connection to Instagram servers is not established",
    Notify_EmptyHashtagList: "Hashtag list is empty",
    Notify_InvalidHashtagListId: "Hashtag list ID is invalid",
    Notify_DeleteHashtagFail: "Failed to delete hashtag",
    Notify_InvalidBase64Content: "Base64 content is invalid",
    Notify_InvalidTermsAndConditionSvgType: "Terms and conditions are invalid",
    Notify_InvalidLotteryAnnouncementBannerId: "Lottery announcement banner ID is invalid",
    Notify_InvalidLotteryAnnouncementBannerStr: "Lottery announcement banner text is invalid",
    Notify_InvalidPostId: "Post ID is invalid",
    Notify_TooSoonLotteryInfo: "Lottery information sent too early",
    Notify_InvalidDirectParams: "Direct parameters are invalid",
    Notify_NoInstagramerExists: "No Instagram account found",
    Notify_PropertyNotFoundOrNull: "Item not found or is empty",
    Notify_ReachNumberOfPinDirect: "Reached maximum number of pinned messages",
    Notify_InvalidStoryId: "Story ID is invalid",
    Notify_MaxPrePostReach: "Reached maximum number of pre-posts",
    Notify_InvalidDraftId: "Draft ID is invalid",
    Notify_InvalidPrePostId: "Pre-post ID is invalid",
    Notify_ReachHashtagListLimit: "Reached maximum number of hashtag lists",
    Notify_EmptyUsername: "Username not provided",
    Notify_TooManyRequestForPageHashtagAnalysis: "Too many requests for page hashtag analysis",
    Notify_PasswordRequired: "Password is required",
    Notify_PackageRequiredInThisTime: "An active package is required",
    Notify_FeatureRequiredInThisTime: "This feature needs to be active",
    Notify_NoShopperExist: "No shopper found",
    Notify_FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount:
      "Random follower lottery without login is not allowed for private or verified accounts",
    Notify_FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount:
      "Follower engagement lottery without login is not allowed for private accounts",
    Notify_InvalidLinkId: "Link ID is invalid",
    Notify_ReachMaxBioLink: "Reached maximum number of bio links",
    Notify_OnlyBusinessAccountHasThisAccess: "This access is only available for business accounts",
    Notify_NoYoutubeChannelFound: "No YouTube channel found",
    Notify_CannotGetYoutubeRightNow: "Cannot retrieve YouTube information right now",
    Notify_AparatUsernameNotFound: "Aparat username not found",
    Notify_AparatChannelHasNotAnyVideo: "Aparat channel has no videos",
    Notify_InvalidYoutubeChannelId: "YouTube channel ID is invalid",
    Notify_NoAparatChannelFound: "No Aparat channel found",
    Notify_CannotGetAparatRightNow: "Cannot retrieve Aparat information right now",
    Notify_NotSettedCustomDomain: "Custom domain not set",
    Notify_CannotStoryWithoutWinnerBanner: "Cannot create story without winner banner",
    Notify_ExceedMaxStoryWinnerLotteryBanner: "Number of story winner lottery banners exceeds limit",
    Notify_LotteryOnProcessingOrEnded: "Lottery is processing or has ended",
    Notify_CannotAbortLotteryOneHourBefore: "Cannot cancel lottery less than one hour before execution",
    Notify_CannotAbortFollowerLottery: "Cannot cancel follower lottery",
    Notify_InvalidImageOrExceedMaxSize: "Image is invalid or exceeds maximum size",
    Notify_ExceedLoginAttempt: "Exceeded maximum login attempts",
    Notify_NotExistComment: "Comment not found",
    Notify_UserNotFound: "User not found",
    Notify_ExistInstagramerBefore: "This Instagram account has already been registered",
    Notify_CannotChangeBusinessAccountType:
      "Changing the business account type is not possible, please contact support via ticket",
    Notify_InvalidProductId: "The entered product ID is not valid",
    Notify_InvalidTrendHashtagPeriod: "The selected period for the trend hashtag is not valid",
    Notify_InvalidLanguageId: "The language ID is not valid",
    Notify_CannotStoryWithoutTermsBanner: "Cannot create a Story without a terms banner",
    Notify_ExceedMaxStoryTermsLotteryBanner: "The number of Story lottery terms banners exceeds the allowed limit",
    Notify_LotteryTermsIsNull: "Lottery terms have not been registered",
    Notify_CanShareTermsBefore6HoursOfStartLottery:
      "Terms can only be shared up to 6 hours before the start of the lottery",
    Notify_CanShareTermForOnlyDefinedStatusLotteries: "Sharing terms is only active for lotteries in defined status",
    Notify_SharedRemainingTimeBefore: "Remaining time has already been shared",
    Notify_ShareRemainingTimeOnlyActiveForScoreLottery: "Sharing remaining time is only active for score lotteries",
    Notify_CanShareTermsBefore1HoursOfStartLottery:
      "Terms can only be shared up to 1 hour before the start of the lottery",
    Notify_InvalidSubProductIds: "Sub-product IDs are not valid",
    Notify_ReachMaxProductMedia: "You have reached the maximum number of media for this product",
    Notify_InvalidMediaProductId: "Media product ID is not valid",
    Notify_AccountNotABusiness: "This account is not a business account",
    Notify_NotFoundProductWithThisTempId: "No product found with this temporary ID",
    Notify_InvalidAvailabilityStatus: "The entered availability status is not valid",
    Notify_InvalidIbanNumber: "The entered IBAN number is not valid",
    Notify_ExistedIbanNumber: "This IBAN number has already been registered",
    Notify_IbanMethodNotAvailableForNotTomanPriceUser: "IBAN method is not available for users with non-Toman currency",
    Notify_SearchQueryIsEmpty: "Search query is empty",
    Notify_ExceedMaxInEachCard: "The number of items in each card exceeds the allowed limit",
    Notify_ProductNotAlbumPost: "This product is not registered as an album Post",
    Notify_InvalidChildrenId: "Child ID is not valid",
    Notify_NotAvailableProduct: "The product is currently not available",
    Notify_ExceedStockCount: "Selected quantity exceeds stock",
    Notify_CannotUnloadAnInstanceProduct: "Cannot unload an instance of the product",
    Notify_InvalidCategoryId: "Category ID is not valid",
    Notify_NotFoundAnyProductOnThisCategory: "No product found in this category",
    Notify_NotFoundAnyNextProduct: "No next product found",
    Notify_NotFoundAnyPreviousProduct: "No previous product found",
    Notify_InvalidItemId: "Item ID is not valid",
    Notify_IpInvalid: "The entered IP is not valid",
    Notify_InstagramRedirectInTenSeconds: "You will be redirected to Instagram automatically in 10 seconds",
    Notify_InstagramRedirect: "Redirecting to Instagram",
    Notify_InstagramRedirectExplain: "Make sure your VPN is enabled, as your IP address is not valid",

    Notify_ThisInstagramAccountAddedBefore: "This Instagram account has already been added",
    Notify_InvalidTicketId: "The ticket ID is not valid",
    Notify_ExpiredSignature: "Signature has expired",
    Notify_Forbidden: "Unauthorized access",
    Notify_ConnectedInstagramPageNotFound: "Connected Instagram page not found",
    Notify_AllInstagramAccountConnectedAddedBefore: "All connected Instagram accounts have already been added",
    Notify_SelectInstagramPageToConnect: "Please select the Instagram page to connect",
    Notify_InstagramRedirectRoleNotFound: "Instagram redirect role not found",
    Notify_FacebookLoginNotFound: "Facebook login not found",
    Notify_SelectedPageNotFound: "Selected page not found",
    Notify_ShouldConnectInstaPageAgain: "You need to reconnect the Instagram page",
    Notify_InvalidProductSuggestionId: "Product suggestion ID is not valid",
    Notify_NotSavedSuggestions: "Suggestions have not been saved",
    Notify_ExistedSuggestedMedia: "This suggested media has already been registered",
    Notify_InvalidUploadMediaUrl: "Media upload URL is not valid",
    Notify_SuggestedPostAutoReplyKeyNotExist: "Suggested Post auto-reply key not found",
    Notify_UploadingTimeIsSoSoon: "Uploading time is too soon",
    Notify_InvalidPreStoryId: "Pre-Story ID is not valid",
    Notify_NotProvidedInstagramerId: "Instagramer ID not provided",
    Notify_InvalidInstagramerId: "Instagramer ID is not valid",
    Notify_InvalidThreadId: "Thread ID is not valid",
    Notify_InvalidLiveMediaId: "Live media ID is not valid",
    Notify_NotCreatedExportComment: "Comment export not created",
    Notify_CreateExportAvailableWith24HourPeriod: "Export can be created once every 24 hours",
    Notify_NotSetted: "Not set",
    Notify_ExceedGeneralAutoReplyCount: "General auto-reply count exceeds the limit",
    Notify_InvalidTransactionId: "Transaction ID is not valid",
    Notify_CannotRenewalPackageWith1MonthTimeExist: "Cannot renew a 1-month package at the moment",
    Notify_CannotDeleteCurrentSession: "Cannot delete the current session",
    Notify_InvalidSessionId: "Session ID is not valid",
    Notify_CannotDeleteCurrentSessionForNewSessionFor1Day:
      "Cannot delete current session to create a new session for 1 day",
    Notify_UpgradedBefore: "This account has been upgraded before",
    Notify_PermissionNotExist: "Permission does not exist",
    Notify_NotExistUser: "User not found",
    Notify_UserAlreadyAsPartner: "User is already registered as a partner admin",
    Notify_ReachMaxPartnerCount: "Reached maximum number of partner admins",
    Notify_InvalidPartnerRoleProvided: "Provided partner admin role is not valid",
    Notify_PartnerRolesLengthIsZero: "No role defined for partner admin",
    Notify_PartnerNotExist: "Partner admin not found",
    Notify_CannotMakeYourSelfPartnerAsPartnerForYourSelf: "You cannot select yourself as your own partner admin",
    Notify_PartnerExpireTimeMustBeBiggerThan1HourFromNow:
      "Partner admin expiration time must be at least 1 hour from now",
    Notify_PartnerNameCannotExceed100: "Partner admin name cannot exceed 100 characters",
    Notify_ProductIsMultiSubproducted: "This product contains multiple subproducts",
    Notify_InvalidSubProductId: "Subproduct ID is not valid",
    Notify_ProductIdOutOfStock: "The product is out of stock",
    Notify_SubProductIdRequired: "Subproduct ID is required",
    Notify_CardIsEmpty: "The card is empty",
    Notify_InvalidAddressId: "Address ID is not valid",
    Notify_ExceedTotalCreateAddress: "Exceeded the maximum number of allowed addresses",
    Notify_NotSupportedCountry: "The selected country is not supported",
    Notify_CannotFetchAddressInThisEndpoint: "Cannot fetch address at this endpoint",
    Notify_InvalidPostalCode: "Postal code is not valid",
    Notify_NeedCompleteAddress: "Complete address entry is required",
    Notify_CannotBuyFromYourSelf: "You cannot buy from yourself",
    Notify_AllReadyIsBusiness: "This account is already registered as business",
    Notify_InvalidBusinessType: "Business account type is not valid",
    Notify_UserAlreadyAuthorized: "User has already been authorized",
    Notify_InstagramerNotInfluencer: "The Instagramer is not an influencer",
    Notify_InstagramerNotShopper: "The Instagramer is not a seller",
    Notify_AuthorizedInstagramerBefore: "This Instagramer has already been authorized",
    Notify_UserNotAuthorizedYet: "User has not been authorized yet",
    Notify_InstagramerNotAuthorized: "Instagramer is not authorized",
    Notify_InvalidBankCardNumber: "Bank card number is not valid",
    Notify_TheOwnerOfPhoneNumberNotBlongsNationalNumber: "Phone number owner does not match national ID",
    Notify_CouponCodeAlreadyExists: "Coupon code already exists",
    Notify_InvalidCouponId: "Coupon ID is not valid",
    Notify_CannotChangeShowPrivateCouponInBio: "Cannot change display of private coupon in bio",
    Notify_InvalidCouponCode: "Coupon code is not valid",
    Notify_CouponForAnotherPerson: "Coupon belongs to another person",
    Notify_CouponExpired: "Coupon has expired",
    Notify_CouponDeleted: "Coupon has been deleted",
    Notify_CouponUsedUp: "Coupon has been used up",
    Notify_InvalidUsernameSearchQuery: "Invalid username search query",
    Notify_PreviouslyAddedShopAddress: "This shop address has been added before",
    Notify_NotSettedShopperAddress: "Shopper address is not set",
    Notify_NotExistAnyLogesticInYourCountry: "No logistic system exists in your country",
    Notify_InvalidLogesticIds: "Logistic IDs are invalid",
    Notify_LogsticsNotSetted: "Logistics not set",
    Notify_NotCommpletedAllBusinessVerification: "All business verifications are not completed",
    Notify_ThisParcelNotSupportedByAnySelectedAvailableLogestic:
      "This parcel is not supported by any selected available logistics",
    Notify_NotSupportedLogestic: "Selected logistic is not supported",
    Notify_ExceedLogesticHeight: "Parcel height exceeds logistic limit",
    Notify_ExceedLogesticWidth: "Parcel width exceeds logistic limit",
    Notify_ExceedLogesticLength: "Parcel length exceeds logistic limit",
    Notify_ExceedLogesticTotalLength: "Parcel total length exceeds logistic limit",
    Notify_ExceedLogesticWeight: "Parcel weight exceeds logistic limit",
    Notify_UserAddressesIsEmptyOrNotSetDefaultAddress: "User addresses are empty or default address is not set",
    Notify_NotSupportedBoxByThisDimensions: "Box with these dimensions is not supported",
    Notify_CannotAvailableOutOfStackProduct: "Cannot make product available out of stock",
    Notify_YouAreDeadInCivilRegistration: "You are recorded as deceased in civil registration",
    Notify_InstagramerAlreadyAuthorized: "Instagramer is already authorized",
    Notify_ThreadShouldBeActiveForSendMessage: "Thread should be active to send a message",
    Notify_PreviouslyClosedTicket: "Ticket has been previously closed",
    Notify_NotMatchedCart: "Cart does not match",
    Notify_PhoneNumberNotBlongsNationalNumber: "Phone number does not match national number",
    Notify_NotMatchedCardNumberAndIdentity: "Card number and identity information do not match",
    Notify_SuspendedShop: "This shop is suspended, please contact support",
    Notify_LogesticIdNotSpecifiedForaPostParcel: "Logistic ID not specified for postal parcel",
    Notify_LogesticNotInAvailableLogestics: "Selected logistic is not in available logistics list",
    Notify_ExceedProductReportForLast24Hour: "Product report count in the last 24 hours exceeds limit",
    Notify_PreviouslyReportedThisProduct: "You have previously reported this product",
    Notify_InvalidOrderId: "Order ID is invalid",
    Notify_NotPendingPayRequest: "Payment request is not pending",
    Notify_NotExistShopAddress: "Shop address not found",
    Notify_InvalidOrderStatus: "Order status is invalid",
    Notify_CancelInvoiceFailed: "Canceling invoice failed",
    Notify_PaymentSystemNotSupportedThisPriceType: "Payment system does not support this price type",
    Notify_InvalidSentOrderType: "Sent order type is invalid",
    Notify_InvalidParcelId: "Parcel ID is invalid",
    Notify_AddedParcelIdBefore: "Parcel ID has been added before",
    Notify_InvoiceNotOnPaid: "Invoice has not been paid yet",
    Notify_CreatedSystemTicketOnOrderBefore: "System ticket for this order has already been created",
    Notify_PaymentServiceNotResponding: "Payment service is not responding at the moment",
    Notify_YouAreNotAdmin: "You are not an admin",
    Notify_YouAreNotASubAdmin: "You are not a sub-admin",
    Notify_InvalidFbId: "Invalid Facebook ID",
    Notify_InvalidFeatureId: "Invalid feature ID",
    Notify_InActiveFeature: "This feature is inactive",
    Notify_FeaturePaused: "This feature has been paused",
    Notify_InvalidPromptInput: "Invalid prompt input",
    Notify_PromptNotGenerated: "Prompt not generated",
    Notify_AIGeneratorFailed: "AI generator encountered an error",
    Notify_NotExecutedPromptForCommentYet: "Prompt for comment has not been executed yet",

    Notify_InstagramPermissionNotExist: "Instagram permission does not exist",
    Notify_InvalidTimeZone: "Invalid timezone",
    Notify_PromptCaptionExampleNotGenerated: "Prompt caption example has not been generated",
    Notify_InvalidMasterFlowId: "Invalid master flow ID",
    Notify_InvalidFlowId: "Invalid flow ID",
    Notify_EmptySubFlows: "Sub-flows are empty",
    Notify_InvalidFlowObject: "Invalid flow object",
    Notify_InvalidMasterFlowTitle: "Invalid master flow title",
    Notify_InvalidPromptId: "Invalid prompt ID",
    Notify_ExceedThreadTokenLimit: "Thread token limit exceeded for this conversation",
    Notify_InvalidMediaId: "Invalid media ID",
    Notify_InvalidLotteryId: "Invalid lottery ID",
    Notify_CannotAbortNonUpcomingLottery: "Cannot abort non-upcoming lotteries currently",
    Notify_CommentCountExceedFreeExport: "Comment count exceeds the allowed limit for free lottery",
    Notify_InvalidReserveFeatureId: "Invalid reserve feature ID",
    Notify_CannotRenewalThisFeatureNow: "Cannot renew this feature currently",
    Notify_InvalidLotteryStatus: "Lottery status is not valid for change",
    Notify_PublishedLotteryBannerBefore: "Lottery banner was published before",
    Notify_LotteryWinnerBannerIsNull: "Lottery winner banner does not exist",
    Notify_InvalidCustomPromptSigniture: "Invalid custom prompt signature",
    Notify_ServiceTemporarilyUnavailable: "Service is temporarily unavailable",
    Notify_PageSummaryNotGenerated: "Brancy needs more data to analyze your page.\nPlease be patient.",
    Notify_GenerateAIFail: "AI generation failed",
    Notify_InvalidPageAnalysis: "Invalid page analysis",
    Notify_InvalidCustomPrompt: "Invalid custom prompt",
    Notify_AIModelNotSupportImage: "AI model does not support images",
    Notify_PromptNotSupportImage: "Prompt does not support images",
    Notify_AIModelNotSupportAudio: "AI model does not support audio",
    Notify_PromptNotSupportVoice: "Prompt does not support voice",
    Notify_AIModelNotSupportVideo: "AI model does not support video",
    Notify_InvalidPrompt: "Invalid prompt",
    Notify_InvalidImageGeneratorInput: "Invalid image generator input",
    Notify_InSuffcientNumberOfImage: "Insufficient number of images",
    Notify_CreateImageExceedLimit: "Image creation limit exceeded",
    Notify_InvalidPromptType: "Invalid prompt type",
    Notify_UnSupportedAIInputType: "Unsupported AI input type",
    Notify_UnSupportedOrientationType: "Unsupported orientation type",
    Notify_SoraFailedAiCall: "Sora AI call failed",
    Notify_AIVideoSecondNotSupported: "AI video duration not supported",
    Notify_FailedToTraslateDescription: "Failed to translate description",
    Notify_FailedToGenerateEmbedVector: "Failed to generate embed vector",
    Notify_NotGeneratedSummaryYet: "Summary has not been generated yet",
    Notify_NoEventsFoundForTheGivenTimeRange: "No events found for the given time range",
    Notify_NoEventsFoundForThisPrompt: "No events found for this prompt",
    Notify_PageAnalysisNotExist: "Page analysis does not exist",
    Notify_NoEventIdeaGenerated: "No event idea generated",
    Notify_PhoneNumberAddedBefore: "This phone number has already been added",
    Notify_WhatsAppCodeSendedBeforeAndWait1Day: "A WhatsApp code was already sent. Please wait one day",
    Notify_WhatsAppCodeNotRequested: "No WhatsApp verification code was requested",
    Notify_WhatsAppCodeMaxInvalidCountReach: "Maximum invalid WhatsApp code attempts reached",
    Notify_UserWithThisPhoneNumberAlreadyExist: "A user with this phone number already exists",
    Notify_InvalidAIToolId: "Invalid AI tool ID",
    Notify_AIToolParameterRequired: "AI tool parameter is required",
    Notify_AIToolParameterNotRequired: "This AI tool does not accept a parameter",
    Notify_ExceedDailyLimit: "Daily limit exceeded",
    Notify_CannotGetTwitchRightNow: "Cannot retrieve Twitch data right now",
    Notify_InvalidTwitchChannelId: "Invalid Twitch channel ID",
    Notify_PhoneNumberRequired: "Phone number is required",
    Notify_NotVerifiedHost: "Host is not verified",
    Notify_NotBusinesser: "This user is not a business owner",
    Notify_NotFoundAnySuggestedCategory: "No suggested category was found",
    Notify_NoInvoiceExist: "No invoice exists",
    Notify_InvalidMediaAiCreatorKey: "Invalid AI model",
    Notify_InvalidMediaAiVersionKey: "Invalid AI version",
    Notify_InvalidMediaAiRequestModel: "Invalid AI media request model",
    Notify_MediaAIError: "An error occurred while generating the AI media",
    Notify_TwitchChannelDoestHaveAnyVideo: "This Twitch channel doesn't have any videos",
    Notify_CouponAlreadyDeleted: "This coupon has already been deleted",
    Notify_CouponNotDeleted: "This coupon is not deleted",
    Notify_ExceedSubFlowCount: "The maximum number of sub-flows has been exceeded",
    Notify_ExceedFlowDepth: "The maximum flow depth has been exceeded",
    Notify_ExceedFlowItemCount: "The maximum number of flow items has been exceeded",
    Notify_ExceedFlowMediaAudioCount: "The maximum number of media and audio items in the flow has been exceeded",
    Notify_OneFlowButtonHasEmptyItem: "One of the buttons has no flow",
    InternalNotify_Ok: "Operation completed successfully",
    InternalNotify_RepetitiveHashtagInput: "The entered hashtag is repetitive",
    InternalNotify_NotFoundDevice: "Device not found",
    InternalNotify_EmptyHashtagList: "Cannot create an empty list",
    InternalNotify_CannotCreatePrePostNow: "Cannot create a pre-post at the moment",
    InternalNotify_PrivateAccountSelectedForCheckHashtag: "Cannot select a private account for analysis",
    InternalNotify_InstagramLoginRequired: "This option requires Instagram login",
    InternalNotify_InstagramLoginRequiredForVerifiedAccount:
      "This option requires Instagram login for verified accounts",
    InternalNotify_PrivateOrVerifiedSponsor: "Cannot select a private or verified account as sponsor",
    InternalNotify_StartUploadingPost: "Post is uploading",
    InternalNotify_UploadingPostError: "Error occurred while uploading post",
    InternalNotify_PostUploaded: "Post uploaded, refresh the page to view",
    InternalNotify_ExceededMedia: "Number of media exceeded the limit",
    InternalNotify_More4IceBreaker: "You cannot have more than 4 quick conversations",
    InternalNotify_CopyLink: "Your link has been copied",
    InternalNotify_copy: "Information copied successfully",
    InternalNotify_CopyTrackingpost: "Your package tracking code has been copied",
    InternalNotify_Network: "Network connection error",
    InternalNotify_TimeExpire: "Cannot register, time has expired",
    InternalNotify_ExceedPermittedHashtagNumber: "Number of hashtags exceeds the permitted limit",
    InternalNotify_UnexpectedError: "An unexpected error occurred",
    InternalNotify_CopyToClipboard: "Your information has already been copied to the clipboard",
    InternalNotify_ExceedPermittedUploadMedia: "The number of media exceeds the permitted limit",
    InternalNotify_FillRedBorderFields: "Please fill in the red-bordered fields",
    InternalNotify_RepeatedVariation: "At least two items are repeated",
    InternalNotify_NeedOneProduct: "At least one product is required",
    InternalNotify_UploadMedia: "There is a problem uploading media",
    InternalNotify_TurnOnProxy: "You must use a valid IP",
    InternalNotify_ExceedPermittedLiveTime: "Live time has exceeded the permitted limit",
    InternalNotify_CommentDisabled: "You cannot perform actions when comments are disabled",
    InternalNotify_ExceedSelectedCollaboratorPage: "Number of selected collaborator pages exceeds the permitted limit",
    InternalNotify_RepetitiveCollaboratorPage: "This username has already been selected",
    InternalNotify_ExceedPermittedSizeOfImage: "Image size exceeds the permitted limit",
    InternalNotify_ExceedPermittedAspectRatioAlbum: "Album video aspect ratio exceeds the permitted limit",
    InternalNotify_ExceedPermittedSizeOfVideoAlbum: "Album video size exceeds the permitted limit",
    InternalNotify_ExceedPermittedDurationOfVideoAlbum: "Album video duration exceeds the permitted limit",
    InternalNotify_ExceedPermittedAspectRatioReels: "Reels aspect ratio exceeds the permitted limit",
    InternalNotify_ExceedPermittedSizeOfVideoReels: "Reels size exceeds the permitted limit",
    InternalNotify_ExceedPermittedDurationOfVideoReels: "Reels duration exceeds the permitted limit",
    InternalNotify_NotPermittedMediaType: "Media type is not permitted",
    InternalNotify_InvalidMetaData: "Metadata is invalid",
    InternalNotify_ExceedSelectedMaxTaggedPeople: "Number of tagged people exceeds the permitted limit",
    InternalNotify_ExceedSelectedMaxHashtags: "Number of selected hashtags exceeds the permitted limit",
    InternalNotify_ExistedInCollaborate:
      "This username already exists in collaborators and cannot be in the first slide",
    InternalNotify_ExceedPermittedAspectRatioStory: "Story aspect ratio exceeds the permitted limit",
    InternalNotify_ExceedPermittedSizeOfVideoStory: "Story video size exceeds the permitted limit",
    InternalNotify_ExceedPermittedWidthOfVideo: "Video width exceeds the permitted limit",
    InternalNotify_ExceedPermittedDurationOfVideoStory: "Story video duration exceeds the permitted limit",
    InternalNotify_BelowMinimumDurationOfVideoStory: "Story video must be at least 3 seconds long",
    InternalNotify_ExceedPermittedSpecificWordForAutoreply:
      "Number of specific words for auto-reply exceeds the permitted limit",
    InternalNotify_ExceedPermittedAspectRatioImage: "Image aspect ratio exceeds the permitted limit",
    InternalNotify_Success: "Operation completed successfully",
    InternalNotify_CreateExportAvailableWith24HourPeriod: "Creating export with 24-hour period is available",
    InternalNotify_SaveIceBreaker: "Successfully added",
    InternalNotify_deleteIceBreaker: "Successfully deleted",
    InternalNotify_SavePersistenceMenu: "Persistence menu added successfully",
    InternalNotify_SelectLanguage: "Language changed successfully",
    InternalNotify_SaveFollowTemplate: "Follow template saved successfully",
    InternalNotify_AutoReplyOn: "Auto-reply activated successfully",
    InternalNotify_AutoReplyOff: "Auto-reply deactivated successfully",
    InternalNotify_AutoGeneralOn: "General auto-reply activated successfully",
    InternalNotify_AutoGeneralOff: "General auto-reply deactivated successfully",
    InternalNotify_MaxInEachCard: "Maximum in each card",
    InternalNotify_ExceedStockCard: "Requested quantity exceeds card stock",
    InternalNotify_DefaultAddress: "You cannot delete the default address",
    InternalNotify_FetchingYourData: "Fetching your data, please wait...",
    InternalNotify_EmptyTitleInQuickReply: "Quick reply title is empty",
    InternalNotify_EmptyTitleForOutputsInQuickReply: "Output titles in quick reply are empty",
    InternalNotify_EmptyTitleForFlow: "Flow title is empty",
    InternalNotify_MultipleFlowForPrivateReply: "You cannot have multiple flows for private reply",
    InternalNotify_NotPermittedForDownload: "You are not allowed to download this content",
    InternalNotify_NotFeature: "You have problem in features",
    InternalNotify_ExceedBasefeatureTime: "It is more than the base feature time",
    InternalNotify_ChannelIdNotStartedWithUC: "Channel ID must start with 'UC'",
    InternalNotify_PageAnalysisNotCompleted: "Unfortunately, your page has not been analyzed by AI yet",
    JustCreated: "Ticket has been registered",
    AdminReplied: "Support has replied",
    UserReplied: "User has replied",
    AdminClosed: "Ticket has been closed by support",
    UserClosed: "Ticket has been closed by the user",
    TimerClosed: "Ticket has been closed automatically",
    closethisticket: "Close this ticket",

    Create: "Create",
    image: "image",
    video: "video",
    Images: "Images",
    Videos: "Videos",
    "Generated artwork and visuals": "Generated artwork and visuals",
    "AI motion and clips": "AI motion and clips",
    "Media type": "Media type",

    "Generated AI video preview": "Generated AI video preview",

    Close: "Close",
    Prompt: "Prompt",
    Metadata: "Metadata",
    Creator: "Creator",
    Version: "Version",
    Status: "Status",
    "Image ID": "Image ID",
    "Video ID": "Video ID",
    "Job ID": "Job ID",
    "Download image": "Download image",
    "Download video": "Download video",
    "Your browser does not support video playback.": "Your browser does not support video playback.",

    Uploading: "Uploading",
    "Add video": "Add video",
    "Add audio": "Add audio",
    "Add reference image": "Add reference image",
    model: "model",
    models: "models",
    "resize aspect ratio": "resize aspect ratio",
    "Video models": "Video models",
    "Image models": "Image models",
    "Cost level {level}": "Cost level {level}",
    "Calculating...": "Calculating...",
    "Search from People or Keyword": "Search from People or Keyword",
    "Create new Flow": "Create new Flow",
    "Welcome illustration": "Welcome illustration",
    "Untitled generation": "Untitled generation",
    "No images yet": "No images yet",
    "No videos yet": "No videos yet",
    "Your successful image generations will appear here.": "Your successful image generations will appear here.",
    "Your successful video generations will appear here.": "Your successful video generations will appear here.",
    "Create your first image": "Create your first image",
    "Create your first video": "Create your first video",
    "Generating image": "Generating image",
    "Generating video": "Generating video",
    "In progress": "In progress",
    "Create video": "Create video",
    "Create image": "Create image",
    "Just now": "Just now",
    "Waiting for the result": "Waiting for the result",

    "Try again": "Try again",

    "AI provider": "AI provider",

    "Choose a model": "Choose a model",
    "Describe the subject, setting, light, composition, and style...":
      "Describe the subject, setting, light, composition, and style...",
    "Use at least {count} characters.": "Use at least {count} characters.",

    "Video creator is unavailable": "Video creator is unavailable",
    "Image creator is unavailable": "Image creator is unavailable",
    "No video models found": "No video models found",
    "No image models found": "No image models found",
    "There are no video generation models available for this account.":
      "There are no video generation models available for this account.",
    "There are no image generation models available for this account.":
      "There are no image generation models available for this account.",
    "Not available": "Not available",
    // #endregion Notification Section

    how: "How",
    SharedRemainingTimeBefore: "You should wait 24 hours before resharing again.",
    economy: "Economy",
    Retry: "Retry",

    // #region wallet
    createdtime: "Created At",
    BankCards: "Bank Cards",
    Transactions: "Transactions",
    Settlements: "Settlements",
    AddNewBankCard: "Add New Bank Card",
    RegisterANewCard: "Register New Card",
    CardBankNumber: "Bank Card Number",
    CardNumberExplain:
      "Enter your card number. The bank card must be registered in the name of the person who signed up.",
    RegisterBankCard: "Register Bank Card",
    CardNumber: "Card Number",
    DefaultBankCard: "Default Bank Card",
    SetAsDefaultBankCard: "Set as Default Bank Card",
    Type: "Type",
    Suspended: "Suspended",
    Amount: "Amount",
    Time: "Time",
    Order: "Order",
    User: "User",
    NotAvailable: "Not Available",
    Unsettled: "Unsettled",
    AwaitingSettled: "Awaiting Settlement",
    Settled: "Settled",
    SettlementFailed: "Settlement Failed",
    SettleRequest: "Settlement Request",
    emptyInvoice: "No invoices have been registered yet.",
    InvoiceID: "Invoice ID",
    InvoiceType: "Invoice Type",
    InvoiceHistory: "Invoice History",
    OrderDetails: "Order Details",
    InvoiceDetails: "Invoice Details",
    Paid: "Paid",
    Success: "Successful",
    RefundRequest: "Refund Request",
    Refunding: "Refunding",
    Refunded: "Refunded",
    RefundFailed: "Refund Failed",
    Failed: "Failed",
    Package: "Package",
    Product: "Product",
    Feature: "Feature",
    Custom: "Custom",
    Invoice: "Invoice",
    UnknownStatus: "Unknown Status",
    NoSettlementsRegisteredYet: "No settlements have been registered yet.",
    LogesticPayment: "Logistics Payment",
    ProductIncome: "Product Income",
    BrancyFeatureIncome: "Brancy Feature Income",
    BrancyLogesticPayment: "Brancy Logistics Payment",
    BrancyPackageIncome: "Brancy Package Income",
    BrancyProductIncome: "Brancy Product Income",
    BrancyTransferPayment: "Brancy Transfer Fee",
    WalletBalance: "Wallet Balance",
    TotalWithdrawn: "Total Withdrawn",
    FailedTransactions: "Failed Transactions",
    PendingSettlement: "Pending Settlement",
    OrderInProgress: "Order in Progress",
    OrderPickup: "Order Pickup",
    OrderDelivery: "Order Delivery",
    SubInvoiceHistory: "Sub-Invoice History",
    history: "History",
    // #endregion wallet
  },
};
